export default {
  translations: {
    default: {
      available: 'disponible',
      staySafe: 'Assurez votre sécurité avec Protexxa',
      bookDemo: 'Demander une démo',
      watchVideo: 'Regarder la vidéo',
      logout: 'Déconnexion',
      GoDashboard: 'Ouvrir le Tableau de bord',
      completeProfile: 'Compléter votre profil',
      login: 'Connexion',
      individuals: 'Pour les particuliers',
      emailVerified: 'Adresse de courrier électronique vérifiée',
      add: 'Ajouter',
      primary: 'Adresse de courrier électronique principale',
      email: 'Email',
      change: 'Modifier le profil',
      profile: 'Profil',
      yes: 'Oui',
      no: 'Non',
      cancel: 'Annuler',
      apply: 'Appliquer',
      ok: 'Ok',
      or: 'OU',
      delete: 'Supprimer',
      remove: 'Supprimer',
      learnMore: 'En savoir plus',
      gotIt: ' D’accord',
      saveChanges: 'Enregistrer les modifications',
      back: 'Retour',
      next: 'Suivant',
      backToHomePage: "Retour à la page d'accueil",
      previous: 'Précédent',
      finish: 'Terminer',
      contactSupport: 'Contactez le support',
      contactSupportShort: 'Contactez-nous',
      ignore: 'Ignorer',
      promotion:
        "Obtenez dès aujourd'hui votre Évaluation personnelle de cybersécurité pour 49,99 $",
      translationAlert: 'Moteur de traduction pour les détails de tiers lancé en décembre 2023.',
      placeHolderPhoneCountry: 'Choisir',
      placeHolderPhone: '(234) 567-8910',
      expand: 'Développer',
      collapse: 'Réduire',
      viewMore: 'Voir plus',
      viewLess: 'Voir moins',
      maintenanceNotification:
        'La maintenance est prévue pour le lundi 16 septembre, de 17 h à 18 h HAE. Le système ne sera pas disponible pendant cette période.',
      scanAlert: {
        onGoing:
          'Votre analyse est en cours et les résultats seront mis à jour en temps réel sur votre tableau de bord. Vous serez notifié une fois l’analyse terminée, ce qui peut prendre jusqu’à 48 heures.',
        hasError:
          "Votre analyse n’a pas pu être complétée en raison d’un problème serveur. Veuillez cliquer sur le bouton 'Relancer l’analyse' pour réessayer.",
        notBeCompleted: 'L’analyse n’a pas pu être complétée.',
        retryScan: 'Relancer l’analyse',
        serverError: 'Votre score n’a pas pu être affiché en raison d’une erreur serveur.',
      },
      profileMenu: {
        adminAccount: 'Compte Admin',
        personalAccount: 'Compte Personnel',
        logout: 'Se déconnecter',
      },
      appSidebar: {
        dashboard: 'Tableau de bord',
        findings: 'Résultats',
        users: 'Utilisateurs',
        bulkScans: 'Analyses en masse',
        scanLogs: 'Journaux de scan',
        training: 'Formation',
        integration: 'Intégration',
        settings: 'Paramètres',
        CYBERMATCH: 'Job Matching',
        jobMatching: 'Job Matching',
        new: 'Nouveau',
      },
      adminBanner: {
        fragments: {
          youReViewing: 'Vous consultez le ',
          adminDashboardAs: "  tableau de bord d'administration en tant que ",
          superAdmin: 'Super administrateur',
        },
        button: { backToCompany: 'Retour aux entreprises' },
      },
      search: 'Rechercher',
      emptyState: {
        table: {
          title: 'Aucune donnée trouvée',
          description: "Il n'y a rien à afficher pour le moment.",
        },
      },
    },
    filters: {
      all: 'Tous',
      riskLevel: 'Niveaux de risque',
      deepScanStatus: 'Statut de l’analyse approfondie',
      deactivatedBy: 'Désactivé par',
      deactivatedAt: 'Date',
    },
    riskLevels: {
      low: 'Faible',
      medium: 'Moyen',
      high: 'Élevé',
      critical: 'Critique',
      pending: 'En attente',
    },
    deepScanStatus: {
      NOT_STARTED: 'Non commencé',
      INVITED: 'Invité',
      NOT_INVITED: 'Non invité',
      INITIATED: 'Initié',
      COMPLETED: 'Terminé',
      FAILED: 'Échoué',
      PROCESSING: 'En cours',
      SCANNING: 'Analyse en cours',
      UNAVAILABLE_SEATS: 'Places indisponibles',
      IMPORTANT: 'Important',
      CRITICAL: 'Critique',
    },
    universalTableComponent: {
      searchPlaceholder: 'Rechercher...',
      page: 'page',
    },
    homeScreenCards: {
      community: {
        nameTitle: 'Protexxa Defender',
        namePlan: 'Communauté',
        price: ['/facturé', 'une fois'],
        priceMessage: 'analyse ponctuelle',
        button: 'Acheter maintenant',
        items: [
          'Comprend une',
          'analyse',
          "ponctuelle qui permet d'identifier si vos comptes ont fait l'objet d'une violation de cybersécurité",
          'Fournit des solutions détaillées pour résoudre chaque compromission identifiée',
        ],
      },
      business: {
        nameTitle: 'Protexxa Defender',
        namePlan: 'Entreprise',
        price: 'Contactez-nous',
        button: 'Réserver une démonstration',
        items: [
          "Permet aux membres de l'entreprise d'améliorer leur sécurité en ligne sur une",
          'base',
          'mensuelle',
          'Fournit des solutions détaillées pour résoudre chaque compromission identifiée et des étapes pour renforcer la cybersanté individuelle des employés',
        ],
      },
    },
    concierge: {
      welcome: 'Bienvenue au Concierge de Protexxa',
      infoHeader:
        'Nous sommes à votre disposition pour répondre à vos besoins immédiats en matière de cybersécurité et vous aider à utiliser notre plateforme. Si vous avez des questions sur votre cote de cybersécurité ou sur les stratégies d’atténuation qui vous sont présentées, n’hésitez pas à utiliser ce formulaire pour nous les transmettre.',
      infoBody:
        'De plus, comme vous utilisez la première version de la plateforme personnelle de cybersécurité Protexxa, vous pourriez vous poser des questions concernant l’utilisation de notre plateforme, ou même avoir des suggestions et des idées pour l’améliorer. Nous avons hâte de recevoir vos commentaires.',
      infoFooter:
        'Une fois que vous nous aurez envoyé votre question, votre demande ou votre commentaire, nous vous répondrons dans les 24 heures ouvrables.',
      team: 'L’équipe Protexxa',
      name: 'Nom du contact',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      type: 'Type',
      description: 'Description',
      submit: 'Envoyer',
      errorName: 'Le nom complet est requis',
      errorEmail: "L'e-mail est requis",
      errorPhone: 'Le téléphone est requis',
      errorCompany: "L'entreprise est requis",
      errorDescription: 'Le description est requis',
      errorType: 'Le type est requis',
      namePlaceholder: 'Insérez votre nom complet',
      emailPlaceholder: 'Insérez votre adresse e-mail',
      phonePlaceholder: '+0 (00) 000-0000',
      companyPlaceholder: 'Insérez le nom de votre entreprise',
      typePlaceholder: 'Veuillez sélectionner le type de problème',
      descriptionPlaceholder: 'Écrivez-nous un message',
      types: {
        none: '--Aucun--',
        technicalissue: 'Problème technique',
        feedback: "Retour d'information",
        billing: 'Facturation',
        generalinquiry: 'Demande générale',
        mycybersecurityscore: 'Mon Score de Cybersécurité',
      },
      salesforce: {
        welcome: 'Bienvenue dans le Protexxa Concierge',
        infoHeader:
          "Nous sommes là pour vous aider avec vos besoins immédiats en matière de cybersécurité et fournir un support complet. Si vous avez des questions concernant votre score en cybersécurité, les stratégies d'atténuation présentées, ou la navigation sur notre plateforme, nous sommes là pour vous aider.",
        infoBody:
          "Nous nous efforçons constamment de nous améliorer. Que vous ayez des suggestions d'amélioration, des préoccupations ou d'autres idées, nous sommes impatients de vous entendre.",
        infoFooter:
          'Veuillez partager votre problème, votre demande ou votre question avec nous, et nous nous assurerons de vous répondre dans les 24 heures ouvrables.',
        team1: 'Avec nos meilleures salutations,',
        team2: "L'équipe Protexxa",
      },
    },
    companyAdmin: {
      welcome: 'Bienvenue dans la communauté Protexxa',
      info: 'Voyons si vous avez été victime de cyberincidents ou si vous avez des vulnérabilités cachées, mais avant tout, créons votre profil :',
      info1:
        "Construisez votre profil personnel pour savoir si vous êtes victime de violations de cybersécurité ou si vous avez des zones d'ombre en matière de sécurité, ou visitez le tableau de bord de votre entreprise pour en savoir plus sur sa santé en matière de cybersécurité.",
      info2:
        "Soyez assuré que toutes les informations que vous fournissez, y compris les résultats de votre évaluation, sont traitées avec la plus grande confidentialité et ne seront pas partagées avec d'autres personnes.",
      menu: 'Ouvrir le Tableau de bord de l’entreprise',
      profile: 'Créer mon profil',
      yourJourneyEnhanced: 'Votre parcours vers une cybersanté améliorée commence ici.',
      permissionsTitle:
        'En tant qu’<b>administrateur</b>, vos permissions actuelles vous permettent de :',
      permissionsList: [
        'voir le tableau de bord de l’entreprise',
        'lancer un nouveau scan groupé',
        'envoyer une alerte aux utilisateurs',
        'inviter des utilisateurs à une analyse approfondie',
      ],
      dashboardInfo:
        'Vous pouvez accéder au <b>tableau de bord de cybersanté de votre entreprise</b> pour surveiller la cybersanté globale ou individuelle, prendre les mesures nécessaires, ou <b>créer votre profil Defender personnel</b>.',
    },
    companyOnboarding: {
      lockedTitle: "La configuration de l'entreprise est en cours...",
      lockedMessage:
        "Un autre administrateur est en train d'intégrer votre entreprise à Defender. Une fois la configuration terminée, vous aurez accès au tableau de bord de l'entreprise. En attendant, vous pouvez continuer avec votre compte personnel.",
      logout: 'Se déconnecter',
      personalDashboard: 'Aller au tableau de bord personnel',
    },
    companyDashboard: {
      tables: {
        users: {
          title: 'Aucune donnée disponible pour les utilisateurs',
          description:
            'Importez les données de vos employés pour accéder à des informations détaillées sur leur santé cybernétique.',
          buttonLabel: 'Importer les données des employés',
        },
        findings: {
          title: 'Aucune donnée disponible pour les fuites',
          description:
            'Importez les données de vos employés pour accéder à des informations détaillées sur leur santé cybernétique.',
          buttonLabel: 'Importer les données des employés',
        },
        departments: {
          title: 'Aucune donnée disponible pour les départements',
          description:
            'Mettez à jour les données de vos employés avec leurs départements pour accéder à des informations détaillées sur la santé cybernétique de chaque département.',
          buttonLabel: 'Mettre à jour les données des employés',
        },
        executives: {
          title: 'Aucune donnée disponible pour les cadres',
          description:
            'Mettez à jour les données de vos employés avec leurs rôles pour accéder à des informations détaillées sur la santé cybernétique de vos départements.',
          buttonLabel: 'Mettre à jour les données des employés',
        },
        customTable: {
          title: 'Aucun résultat trouvé pour les filtres actuels',
          description: "Essayez d'ajuster les filtres pour voir plus de données.",
          buttonLabel: 'Mettre à jour les données des employés',
        },
      },
      users: 'Utilisateurs',
      menuHeader: 'Tableau de bord',
      menuDashboard: 'Tableau de bord de l’entreprise',
      menuReport: 'Rapport personnel',
      menuInvite: 'Inviter des utilisateurs',
      threatsIndicators: 'Indicateurs de compromission',
      threatsLeaks: 'Possibilités de fuite ou de violation',
      threatsCyber: 'Hygiène informatique',
      threatsControls: 'Contrôles manquants',
      companyScore: 'Cote de l’entreprise',
      companyScoreDescription: 'Cela montre l’évolution du score moyen Protexxa au fil du temps.',
      companyScoreDescriptionLearnMore: 'Apprendre encore plus',
      userCyberScore: 'Cote de cybersécurité des utilisateurs',
      userCyberScoreDescription:
        'Résultats obtenus par les utilisateurs de votre entreprise dans leurs analyses individuelles.',
      trendDescription:
        "Ce composant affiche le dernier statut du score de l'entreprise. Le score de votre entreprise est mis à jour mensuellement, lorsqu'un nouvel utilisateur rejoint votre entreprise ou si les scores de l'un de vos utilisateurs changent.",
      trendUpArrow: "Flèche vers le haut : votre score s'est amélioré.",
      trendDownArrow: 'Flèche vers le bas : votre score a diminué.',
      trendDoubleArrow: 'Double flèche : Pas de changement, le score reste le même.',
      scoreHighest: 'Cote maximale',
      scoreAverage: 'Cote moyenne',
      scoreLowest: 'Cote minimale',
      lastScanHappenedIn: 'Dernière analyse :',
      nextScanSchedulefor: 'Prochaine analyse prévue :',
      recommendedAction: 'Mesures recommandées',
      review: 'Vérifier',
      reviewActivity: "Examiner l'Activité",
      gotIt: 'D’accord',
      criticalAreas: 'Problèmes critiques',
      criticalAreasDescription:
        'Ces éléments pourraient vous exposer, ainsi que votre entreprise, à une cyberattaque.',
      threatsIdentified: 'menaces trouvées',
      importantAreas: 'Problèmes importants',
      importantAreasDescription:
        'Résoudre ces problèmes pourrait améliorer considérablement la sécurité de votre entreprise.',
      noCriticalThreats: 'Aucune menace critique',
      noImportantThreats: 'Aucune menace importante',
      areasOfStrength: 'Points forts',
      areasOfStrengthDescription:
        'Ces éléments vous aident à assurer la sécurité de votre entreprise.',
      areasIdentified: 'points identifiés',
      noAreasOfStrength: 'Aucune menace sur les points forts',
      whyIsThisImportant: 'Pourquoi est-ce important?',
      findings: {
        externalFindings: 'Résultats externes',
        internalFindings: 'Résultats internes',
      },
      emptyState: {
        title: 'Euh oh ! Il n’y a pas de données disponibles pour faire rapport.',
        description:
          'Invitez davantage de membres à commencer à calculer le score de votre entreprise.',
        secondTitle: 'Le score de votre entreprise est presque prêt.',
        secondDescription:
          'Une fois que cinq membres ou plus auront terminé leur analyse personnelle, le score de votre entreprise sera disponible.',
        resendInvites: 'Renvoyer les invitations',
        succesInviteUsers: 'Invitations envoyées avec succès!',
      },
      emptyStateDescription:
        'Dès que le premier utilisateur aura effectué son analyse personnelle, la cote de votre entreprise sera calculée.',
      inviteUsers: 'Inviter des utilisateurs',
      inviteUsersDescription:
        'Ajoutez des utilisateurs en leur envoyant ce lien pour qu’ils puissent créer leur compte',
      inviteByEmail: {
        messages: {
          success: 'Invitations par e-mail envoyées avec succès.',
          error: "Erreur lors de l'envoi des invitations par e-mail. Veuillez réessayer plus tard.",
        },
        placeholder:
          'Invitez un ou plusieurs utilisateurs en même temps:\njohn@email.com, jane@email.com, adam@email.com',
        sendButton_zero: 'Envoyer des invitations',
        sendButton_one: 'Envoyer {{count}} invitation',
        sendButton_other: 'Envoyer {{count}} invitations',
        clearButton: 'Supprimer tout',
        header: 'Inviter par e-mail',
        invalidEmailMessage:
          'Une ou plusieurs adresses e-mail invalides. Vérifiez si toutes les informations sont correctes et réessayez.',
      },
      totalSeats: 'Nombre total de postes',
      totalSeatsDescription: 'Nombre de postes autorisés avec la licence actuelle',
      upgrade: 'Mise à niveau',
      seatsTooltip:
        'Nombre maximum d’utilisateurs. Communiquez avec notre service commercial pour mettre à niveau votre licence.',
      userProfiles: 'Profils des utilisateurs',
      usersProfilesDescription: 'Utilisateurs ayant créé un profil',
      seatsConvertedToProfiles: 'des postes ont été convertis en profils d’utilisateurs.',
      seatsAvailable: 'postes disponibles',
      userScans: 'Analyses des utilisateurs',
      userScansDescriptions: 'Utilisateurs regroupés sur ce tableau de bord',
      usersHaveNotScannedYet: 'utilisateurs n’ont pas encore réalisé d’analyse',
      usersHaveCompletedTheirScan: 'des utilisateurs ont terminé leur analyse',
      noIssues: 'Aucun problème',
      changePasswordLeak: 'Avez-vous changé votre mot de passe après les fuites?',
      TwoFactor: 'Authentification multi-facteurs',
      TwoFactorDescription: `Améliorez votre sécurité en ligne en vérifiant si les applications que vous avez sélectionnées lors de la création de votre profil proposent cette option, et commencez à utiliser l'authentification multi-facteurs pour vous connecter.`,
      addressLeak: `Fuite d'adresse`,
      addressLeakDescription: `Votre adresse a été divulguée sur ces sites`,
      personageImage: `Utilisation d'une image personnelle`,
      personalImageDescription: 'Votre image personnelle a été trouvée sur ces sites',
      appPermision: `Autorisations d'application intrusives`,
      appPermisionDescription:
        'Vous utilisez certaines applications qui peuvent être nuisibles pour votre sécurité',
      phoneLeak: 'Votre numéro de téléphone est enregistré sur ces sites',
      socialMedia: 'Réseaux sociaux privés',
      socialMediaDescription: `Vous n'avez pas tous vos comptes sociaux configurés en privé. Commencez à améliorer votre sécurité en ligne en vérifiant si les applications que vous avez sélectionnées lors de la création de votre profil proposent des options pour sécuriser vos données personnelles.`,
      downloadTemplate: 'Télécharger le modèle',
      goToMarketplace: 'Accéder à la place de marché',
      scoreRange: {
        modalTitle: 'Que signifie le score ?',
        modalButton: "J'ai compris",
        a: "900 - 1000 : Votre organisation a une excellente cyber-hygiène ou un rayon d'exposition limité. Nous encourageons votre concentration et votre diligence continues. Gardez toujours la cyberprotection au premier plan de vos opérations.",
        b: '800-899 : Les efforts de votre organisation ont un impact positif. Il reste encore de la place pour améliorer encore vos défenses. Continuez votre bon travail et continuez à donner la priorité à la cyberprotection pour renforcer votre résilience numérique.',
        c: "700 - 799 : Votre organisation a de très bonnes habitudes en ligne et est moins susceptible d'être la proie des cybermenaces. Envisagez d'améliorer votre cyberformation pour renforcer la protection de l'entreprise.",
        d: "600 - 699 : Votre organisation a de très bonnes habitudes en ligne et est moins susceptible d'être la proie des cybermenaces. Envisagez d'améliorer votre cyberformation pour renforcer la protection de l'entreprise.",
        e: "400 - 599 : Votre organisation a une chance raisonnable d'être touchée par une cyberattaque. Une attention supplémentaire à votre cyber-hygiène est nécessaire. Quelques petits changements auront un impact majeur pour votre entreprise.",
        f: "0 - 399 : Votre organisation a une mauvaise cyber-hygiène et vous êtes dans la catégorie de risque de compromission la plus élevée. Il est nécessaire de se concentrer immédiatement sur la réduction de la surface d'attaque.",
      },
      legend: {
        title: 'Légende',
        lessThan50: 'Moins de 50 % des utilisateurs',
        atLeast50: 'Au moins 50 % des utilisateurs',
        all00: '100 % des utilisateurs',
        numberOfUsersWithIncidents:
          "Nombre d'utilisateurs avec des incidents depuis la dernière analyse.",
      },
      whatCanIDo: 'Que puis-je faire ?',
      company: 'Entreprise',
      personal: 'Personnel',
      status: {
        completed: 'Terminé',
        initiated: 'Initié',
        notStarted: 'Pas commencé',
        invited: 'Invité',
        pending: 'En attente',
        notInvited: 'Non invité',
        failed: 'Échoué',
        processing: 'Traitement',
        scanning: 'Analyse',
        inProgress: 'En cours',
        unavailableSeats: 'Postes non disponibles',
        important: 'Important',
        critical: 'Critique',
      },
      level: {
        low: 'Faible',
        medium: 'Moyen',
        high: 'Élevé',
        critical: 'Critique',
        pending: 'En attente',
      },
      bulkAction: {
        bulkAction: 'Actions',
        alertUsers: 'Alerter les utilisateurs',
        requestTakedown: 'Demander la suppression',
      },
      companyFindings: {
        allFindings: 'Toutes les découvertes externes',
        allDomains: "Tous les domaines de l'entreprise",
        allResults: 'Tous les résultats',
        tableAriaLabel: 'Tableau des résultats',
        issuesCount_one: '{{count}} problème',
        issuesCount_other: '{{count}} problèmes',
        showingAllResults: 'Affichage de tous les résultats',
        showingAllCredentialLeaks: 'Affichage de toutes les fuites d’identifiants',
        showingAllMentions: 'Affichage des mentions de nom et de courriel',
        showingAllNameMentions: 'Affichage de toutes les mentions de nom',
        showingAllEmailMentions: 'Affichage de toutes les mentions de courriel',
        listByIssue: 'Lister par problème',
        listBySource: 'Lister par source',
        credentials: "Fuites d'identifiants",
        credentialsTooltip:
          "Résultats de scan avec des mots de passe d'employés et d'autres identifiants divulgués.",
        passwordLeaks: 'Fuites de mots de passe',
        malware: 'Malware',
        botnet: 'Botnet',
        nameAndEmailMentions: 'Mentions de nom et de courriel',
        mentionsTooltip: "Résultats de scan avec des noms ou des courriels d'employés mentionnés.",
        namesExposed: 'Mentions de nom',
        namesExposedTooltip: "Résultats de scan avec des noms d'employés mentionnés.",
        emailsExposed: 'Mentions de courriel',
        emailsExposedTooltip: "Résultats de scan avec des courriels d'employés mentionnés.",
        scanInProgressTitle: 'Le scan est actuellement en cours...',
        scanInProgressSubtitle:
          'Les résultats de votre scan seront affichés ici une fois le scan terminé.',
        filters: {
          departments: 'Départements',
          threatLevel: 'Niveau de menace',
          source: 'Source',
          dateOfExposure: "Date d'exposition",
          issue: 'Problème',
          allDates: 'Toutes les dates',
          last7Days: '7 derniers jours',
          last30Days: '30 derniers jours',
          last90Days: '90 derniers jours',
          passwordLeaks: 'Fuites de mots de passe',
          botnetLeaks: 'Fuites Botnet',
          plainTextPassword: 'Mot de passe en texte clair',
          nameExposure: 'Mention de nom',
          emailExposure: 'Mention de courriel',
          low: 'Faible',
          medium: 'Moyen',
          high: 'Élevé',
          pending: 'En attente',
          finance: 'Finance',
          marketing: 'Marketing',
          sales: 'Ventes',
          technology: 'Technologie',
          customerSuccess: 'Succès client',
          all: 'Tous',
          allIssues: 'Tous les problèmes',
          critical: 'Critique',
          important: 'Important',
          deepScanStatus: "Statut de l'analyse",
          bulkScanStatus: 'Statut',
          date: 'Date',
          riskLevel: 'Niveau de risque',
          users: 'Utilisateurs',
          allUsers: 'Tous les utilisateurs',
          executives: 'Cadres',
          rangeError: 'Plage invalide',
        },
        tableHeader: {
          userAffected: 'Utilisateur concerné',
          breached: 'Compromis',
          dateFound: 'Date de découverte',
          sortedDescending: 'trié par ordre décroissant',
          sortedAscending: 'trié par ordre croissant',
          breachedTooltip: 'Quand la violation a eu lieu.',
          dateFoundTooltip:
            'Quand cette violation a été découverte pour la dernière fois par Protexxa Defender.',
        },
        tooltips: {
          alertUsers: "Alerter l'utilisateur",
          deepScan: 'Invitation à une analyse approfondie',
          requestTakedown: 'Demander la suppression',
          comingSoon: 'Bientôt disponible',
        },
        description:
          'Ce sont des expositions qui proviennent de sources potentiellement risquées et qui nécessitent un examen immédiat et des actions pour les traiter.',
        internalDescription:
          'Ce sont des expositions qui proviennent des domaines de votre entreprise et qui sont marquées comme sûres. Les actions d’escalade du niveau de menace sont désactivées pour ces expositions.',
        listLabel: 'Voici une liste des expositions trouvées pour :',
        ofTotalExposures: 'du total des expositions',
        riskLevelChange: {
          confirmTitle: 'Vous êtes sûr de vouloir continuer ?',
          confirmDescription:
            'Si vous continuez, le niveau de risque pour cette découverte sera mis à jour.',
          cancel: 'Annuler',
          proceed: 'Continuer',
          restoreToDefault: 'Restaurer par défaut',
        },
        downloadReport: {
          button: 'Télécharger le rapport',
          resultsFound: "Résultats trouvés à partir de vos analyses d'entreprise.",
          selectCompletedScheduledScan: 'Sélectionnez une analyse planifiée terminée',
          downloadAsCsv: 'Télécharger en CSV',
          latest: 'récent',
          loadScansError: 'Impossible de charger les analyses planifiées terminées.',
          downloadSuccess: 'Rapport téléchargé avec succès.',
          downloadError: "Impossible de télécharger le rapport de l'analyse sélectionnée.",
        },
      },
      score: {
        scannedUsers: 'Utilisateurs actifs',
        inProgress: {
          title: 'Analyse en cours...',
          description:
            'Les résultats de la cybersécurité de votre entreprise seront affichés ici une fois l’analyse terminée.',
        },
      },
    },
    usersPage: {
      owner: 'Propriétaire',
      admin: 'Administrateur',
      emptyStates: {
        admins: {
          title: 'Aucune donnée pour les administrateurs',
          description:
            'Mettez à jour les données de vos administrateurs avec leurs rôles pour accéder à des informations détaillées.',
          buttonLabel: 'Mettre à jour les données administrateur',
        },
        departments: {
          title: 'Il n’y a pas de données pour les départements',
          description:
            'Mettez à jour les données de vos utilisateurs avec leurs départements pour débloquer des informations détaillées sur la cybersanté de vos départements.',
          buttonLabel: 'Mettre à jour les données des utilisateurs',
        },
        allUsers: {
          title: 'Il n’y a pas de données pour les utilisateurs',
          description:
            'Téléchargez les données de vos utilisateurs pour débloquer des informations détaillées sur la cybersanté de vos utilisateurs.',
          buttonLabel: 'Télécharger les données des utilisateurs',
        },
        executives: {
          title: 'Il n’y a pas de données pour les cadres',
          description:
            'Mettez à jour les données de vos utilisateurs avec leurs rôles pour débloquer des informations détaillées sur la cybersanté de vos départements.',
          buttonLabel: 'Mettre à jour les données des utilisateurs',
        },
        default: 'Indisponible',
      },
      updateEmployees: {
        buttonLabel: 'Mettre à jour les employés',
        modal: {
          title: "Mettre à jour votre liste d'employés",
          subtitle:
            "Téléchargez votre dernier fichier de main-d'œuvre pour mettre à jour votre répertoire d'employés actifs. Cela ajoutera, mettra à jour ou supprimera automatiquement les employés sur la plateforme.",
          downloadSampleText: 'Pour un modèle sur la façon de structurer vos données correctement,',
          downloadSampleLink: 'Télécharger ce fichier exemple',
          downloadSample: 'Télécharger le fichier exemple',
          browseFile: 'Parcourir les fichiers',
          dragAndDrop: 'ou glissez-déposez ici.',
          supportedFormats: 'Seuls les formats de fichiers CSV et XLS sont pris en charge.',
          replaceFile: 'Remplacer le fichier',
          previewFile: 'Aperçu du fichier',
          uploading: 'téléchargement...',
          uploaded: 'téléchargé',
          profilesUploaded: '{{count}} profils ont été téléchargés.',
          comparing: 'Comparaison des données téléchargées avec les utilisateurs actuels...',
          invalidFormat:
            'Format de fichier invalide. Seuls les fichiers CSV et XLS sont pris en charge.',
          noNewUsers: {
            title: 'Aucun nouvel utilisateur trouvé ou manquant.',
            description:
              'Mettez à jour votre répertoire pour être actualisé avec les dernières informations.',
            button: "Mettre à jour la liste d'employés",
          },
          newUsersFound: {
            title:
              "{{count}} nouveaux utilisateurs détectés dans le fichier ne figurent pas dans votre liste d'employés actuelle.",
            description:
              "Vous pouvez analyser les nouveaux utilisateurs maintenant ou mettre à jour la liste d'employés uniquement et les inclure dans la prochaine analyse programmée.",
            viewProfiles: 'Voir les profils',
            scanButton: 'Mettre à jour et analyser les nouveaux utilisateurs',
            skipButton: "Passer l'analyse, mettre à jour la liste uniquement",
          },
          missingUsers: {
            title:
              "{{count}} utilisateurs de votre liste d'employés actuelle ne figurent pas dans ce fichier.",
            description:
              "Examinez ces utilisateurs pour continuer à mettre à jour votre liste d'employés. Cela les désactivera et les exclura des futurs rapports d'analyse (sauf les utilisateurs Admin.",
            learnMore: 'En savoir plus)',
            viewProfiles: 'Voir les profils',
          },
          confirmation: {
            title: 'Voulez-vous continuer ?',
            body: "Votre liste d'employés sera mise à jour avec ce fichier, et les utilisateurs manquants (de la liste) seront désactivés.",
            cancel: 'Annuler',
            proceed: 'Continuer',
          },
          footer: {
            cancel: 'Annuler',
            updateEmployeeList: "Mettre à jour la liste d'employés",
          },
          errors: {
            fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 5 Mo.',
            missingHeaders: 'Le fichier manque des en-têtes requis.',
            noRows: "Le fichier n'a pas de lignes de données.",
            comparisonFailed:
              'Échec de la comparaison des données téléchargées. Veuillez réessayer.',
            invalidFileContent:
              "Votre fichier n'a pas pu être traité. Veuillez vérifier qu'il correspond au modèle de fichier exemple et réessayer.",
            updateFailed: 'Échec de la mise à jour du répertoire. Veuillez réessayer.',
            scanFailed: "Échec du démarrage de l'analyse. Veuillez réessayer.",
          },
          success: {
            updated: "Votre liste d'employés a été mise à jour avec succès.",
            scanning: 'Votre analyse est en cours. Vous serez notifié une fois terminée.',
          },
        },
      },
      notAvailable: 'Non disponible',
      mfa: 'Authentification multi-facteurs (MFA)',
      cyberPlan: 'Plan de réponse en cybersécurité',
      training: 'Formation',
      bulkAction: 'Actions',
      allUsers: {
        tab: 'Tous les utilisateurs',
        active: {
          card: 'Utilisateurs actifs',
          description: 'Afficher et gérer vos utilisateurs actifs sur la plateforme',
          emptyState: {
            title: "Il n'y a pas d'utilisateurs actifs",
            description:
              "Cliquez sur le bouton « Mettre à jour la liste d'employés » ci-dessous pour ajouter vos employés et commencer à surveiller leur exposition et leurs risques de sécurité.",
          },
        },
        inactive: {
          card: 'Utilisateurs inactifs',
          description:
            'Ces utilisateurs ont été désactivés et ne sont actuellement pas surveillés.',
          emptyState: {
            title: "Il n'y a pas d'utilisateurs inactifs",
            description: 'Les utilisateurs désactivés apparaîtront ici.',
          },
        },
        alertUsers: 'Alerter les utilisateurs',
        deactivateUsers: 'Désactiver les utilisateurs',
        inviteToDeepScan: "Inviter à l'analyse approfondie",
        reactivateUsers: 'Réactiver les utilisateurs',
        reactivateUser: "Réactiver l'utilisateur",
        deleteUsers: 'Supprimer les utilisateurs',
        deleteUser: "Supprimer l'utilisateur",
        queuedUsers: 'Utilisateurs en attente',
        queuedUsersDialog: {
          title: 'Utilisateurs en attente',
          description:
            "Ces utilisateurs ont été récemment ajoutés. Ils seront inclus dans le prochain scan de l'entreprise et seront déplacés vers Utilisateurs actifs.",
          emptyState: {
            title: "Il n'y a pas d'utilisateurs en attente",
            description:
              "Cliquez sur le bouton « Mettre à jour la liste d'employés » pour ajouter vos employés et commencer à surveiller leur exposition et leurs risques de sécurité.",
          },
        },
        deactivateUsersDialog: {
          title: 'Êtes-vous sûr de vouloir désactiver ces utilisateurs ?',
          titleSingle: 'Êtes-vous sûr de vouloir désactiver cet utilisateur ?',
          description:
            "Les profils et les données des utilisateurs seront supprimés des analyses d'entreprise ultérieures et les utilisateurs seront considérés comme 'Inactifs'. Voulez-vous continuer ?",
          descriptionSingle:
            "Le profil et les données de l'utilisateur seront supprimés des analyses d'entreprise ultérieures et l'utilisateur sera considéré comme 'Inactif'. Voulez-vous continuer ?",
          cancel: 'Annuler',
          confirm: 'Désactiver les utilisateurs',
          confirmSingle: "Désactiver l'utilisateur",
        },
        deactivateUsersToast: {
          success_one: '{{count}} utilisateur désactivé avec succès.',
          success_other: '{{count}} utilisateurs désactivés avec succès.',
          partial:
            '{{successCount}} utilisateur(s) désactivé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}.',
          partialWithError:
            '{{successCount}} utilisateur(s) désactivé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}. Première erreur : {{error}}',
          error: 'Échec de la désactivation des utilisateurs. {{error}}',
          errorFallback_one: 'Impossible de désactiver {{count}} utilisateur sélectionné.',
          errorFallback_other: 'Impossible de désactiver {{count}} utilisateurs sélectionnés.',
          catchError: 'Impossible de désactiver les utilisateurs sélectionnés.',
        },
        reactivateUsersDialog: {
          titleSingle: 'Êtes-vous sûr de vouloir réactiver cet utilisateur ?',
          titleMultiple: 'Êtes-vous sûr de vouloir réactiver ces utilisateurs ?',
          descriptionSingle:
            "Le profil et les données de l'utilisateur seront inclus dans les analyses d'entreprise ultérieures et l'utilisateur sera considéré comme 'Actif'. Voulez-vous continuer ?",
          descriptionMultiple:
            "Les profils et les données des utilisateurs seront inclus dans les analyses d'entreprise ultérieures et les utilisateurs seront considérés comme 'Actifs'. Voulez-vous continuer ?",
          cancelSingle: 'Annuler',
          cancelMultiple: 'Annuler',
          confirmSingle: "Réactiver l'utilisateur",
          confirmMultiple: 'Réactiver les utilisateurs',
        },
        reactivateUsersToast: {
          success_one: '{{count}} utilisateur réactivé avec succès.',
          success_other: '{{count}} utilisateurs réactivés avec succès.',
          partial:
            '{{successCount}} utilisateur(s) réactivé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}.',
          partialWithError:
            '{{successCount}} utilisateur(s) réactivé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}. Première erreur : {{error}}',
          error: 'Échec de la réactivation des utilisateurs. {{error}}',
          errorFallback_one: 'Impossible de réactiver {{count}} utilisateur sélectionné.',
          errorFallback_other: 'Impossible de réactiver {{count}} utilisateurs sélectionnés.',
          catchError: 'Impossible de réactiver les utilisateurs sélectionnés.',
        },
        deleteUsersDialog: {
          titleSingle: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
          titleMultiple: 'Êtes-vous sûr de vouloir supprimer ces utilisateurs ?',
          alert: 'Cette action est irréversible !',
          descriptionSingle:
            'Le profil de cet utilisateur et les données associées seront supprimés définitivement. Cette action est irréversible. Voulez-vous continuer ?',
          descriptionMultiple:
            'Les profils de ces utilisateurs et les données associées seront supprimés définitivement. Cette action est irréversible. Voulez-vous continuer ?',
          cancelSingle: 'Annuler',
          cancelMultiple: 'Annuler',
          confirmSingle: "Supprimer l'utilisateur",
          confirmMultiple: 'Supprimer les utilisateurs',
        },
        deleteUsersToast: {
          success_one: '{{count}} utilisateur supprimé avec succès.',
          success_other: '{{count}} utilisateurs supprimés avec succès.',
          partial:
            '{{successCount}} utilisateur(s) supprimé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}.',
          partialWithError:
            '{{successCount}} utilisateur(s) supprimé(s) sur {{total}}. Ignorés : {{skipped}}. Échecs : {{failed}}. Première erreur : {{error}}',
          error: 'Échec de la suppression des utilisateurs. {{error}}',
          errorFallback_one: 'Impossible de supprimer {{count}} utilisateur sélectionné.',
          errorFallback_other: 'Impossible de supprimer {{count}} utilisateurs sélectionnés.',
          catchError: 'Impossible de supprimer les utilisateurs sélectionnés.',
        },
      },
      departments: {
        tab: 'épartements',
        description: 'Voir et gérer vos départements au sein de la plateforme',
        emptyState: {
          title: "Il n'y a pas de départements",
          description:
            'Cliquez sur le bouton « Mettre à jour les employés » ci-dessous pour ajouter vos employés et commencer à surveiller leur exposition et leurs risques de sécurité.',
        },
      },
      tables: {
        headers: {
          users: 'Utilisateurs',
          name: 'Nom',
          nameDescription: 'Prénom et Nom',
          title: 'Titre',
          email: 'Email',
          department: 'Département',
          role: 'Rôle',
          deepScanStatus: "Statut d'analyse approfondie",
          findings: 'Découvertes',
          findingsTooltip: {
            criticalFindings: 'Découvertes critiques',
            highRiskFindings: 'Découvertes à risque élevé',
            mediumRiskFindings: 'Découvertes à risque moyen',
            lowRiskFindings: 'Découvertes à faible risque',
            noFindings: 'Aucune découverte',
            criticalRiskUsers: 'Utilisateurs à risque critique',
            highRiskUsers: 'Utilisateurs à risque élevé',
            mediumRiskUsers: 'Utilisateurs à risque moyen',
            lowRiskUsers: 'Utilisateurs à faible risque',
            usersWithNoFindings: 'Utilisateurs sans découvertes.',
          },
          riskLevels: 'Niveaux de risque',
          usersByRiskLevels: 'Utilisateurs par niveaux de risque',
          deactivatedBy: 'Désactivé par',
          deactivatedAt: 'Désactivé le',
          actions: 'Actions',
          userCount: "Nombre d'utilisateurs",
        },
        unassigned: 'Non assigné',
        emptyState: {
          active: {
            title: "Il n'y a pas d'utilisateurs actifs",
            description: "Il n'y a pas d'utilisateurs actifs correspondant à vos filtres actuels.",
          },
          inactive: {
            title: "Il n'y a pas d'utilisateurs inactifs",
            description:
              "Il n'y a pas d'utilisateurs inactifs correspondant à vos filtres actuels.",
          },
        },
      },
      users: 'Utilisateurs',
      actions: 'Actions',
      profile: {
        source: 'Source',
        details: 'Détails',
        findings: 'Découvertes',
        email: 'Email :',
        dateAdded: 'Date ajoutée :',
        phone: 'Téléphone :',
        location: 'Emplacement :',
        noInformation: 'Aucune information',
        thisUser: 'cet utilisateur',
        deepScanStatus: "Statut de l'analyse approfondie :",
        deepScanInitiated: 'Analyse approfondie initiée :',
        protexxaScore: "Score Protexxa de l'utilisateur",
        low: 'Risque faible',
        medium: 'Risque moyen',
        high: 'Risque élevé',
        critical: 'Risque critique',
        criticalRiskIssues: 'Enjeux de risque critique',
        highRiskIssues: 'Enjeux de risque élevé',
        mediumRiskIssues: 'Enjeux de risque moyen',
        lowRiskIssues: 'Enjeux de risque faible',
        findingsSummary_one: 'enjeu a été trouvé pour {{name}}',
        findingsSummary_other: 'enjeux ont été trouvés pour {{name}}',
        securityHabits: {
          title: 'Habitudes de securite',
          passwordManager: 'Gestionnaire de mots de passe',
          multiFactorAuthentication: 'Authentification multifacteur',
          incidentResponsePlan: 'Plan de reponse aux incidents',
          usingOne: 'En utilise un',
          enabled: 'Activee',
          setUp: 'Configure',
          notSetUp: 'Non configure',
        },
        securityProfile: 'Profil de securite',
        userScanNavigation: 'Navigation des analyses utilisateur',
        pending: 'Risque en attente',
        scoreDisclaimer:
          "Score préliminaire basé sur des données limitées. Le score complet de l'utilisateur sera mis à jour après l'analyse approfondie.",
        fromLastScan: 'depuis la dernière analyse',
        inviteDeepScan: 'Inviter pour une analyse approfondie',
        lastScan: 'Dernière analyse:',
      },
      companyScan: {
        companyScan: "Scan d'entreprise",
        companyScanResults: "Résultats de l'analyse d'entreprise",
        info: "À partir de l'analyse en masse de l'entreprise initiée par l'administrateur.",
        lastScan: 'Dernière analyse:',
        nextScheduledScan: 'Prochaine analyse programmée:',
        noIssuesFoundCompanyScan:
          "Aucun problème n'a été trouvé pour cet utilisateur dans l'analyse de l'entreprise.",
        notInvitedDescription:
          'Invitez cet utilisateur a lancer une analyse approfondie de ses comptes personnels pour une securite numerique amelioree.',
        inviteForDeepScan: 'Inviter pour une analyse approfondie',
        recommendations: {
          title: 'Recommandations',
          alertUser: "Alerter l'utilisateur",
          inviteDeepScanDescription:
            "Invitez l'utilisateur à effectuer une analyse approfondie immédiatement sur son compte pour identifier toutes les données compromises.",
          alertUserDescription:
            'Alertez cet utilisateur et demandez-lui de réinitialiser son mot de passe sur les comptes compromis ou de signaler tout site web exposant ses données pour suppression.',
          mfaTrainingDescription:
            "Partagez des supports de formation à l'utilisateur sur la configuration de l'authentification multifacteur sur ses comptes d'entreprise et le renforcement de sa sécurité en ligne.",
          codes: {
            'verify-data-consent':
              'Alertez cet utilisateur pour verifier le consentement des donnees et signaler toute utilisation non autorisee.',
            'run-deep-scan':
              "Invitez l'utilisateur a lancer une analyse approfondie pour identifier des expositions supplementaires.",
            'check-user-profile':
              "Consultez le profil de l'utilisateur pour verifier d'autres expositions.",
            'reset-leaked-passwords':
              "Demandez a l'utilisateur de reinitialiser les mots de passe des comptes compromis.",
            'check-similar-passwords': 'Verifiez les problemes lies a des sources similaires.',
          },
        },
      },
      discoveryTable: {
        recentDiscoveries: 'Découvertes récentes',
        detail: 'Détail',
        threatLevel: 'Niveau de menace',
        date: 'Date',
        searchPlaceholder: 'Entrer le nom de la source à rechercher',
        issueType: 'Problème',
        actions: 'Actions',
        modal: {
          title: {
            name: 'Exposition du nom',
            email: "Exposition de l'email",
            nameMention: 'Mention du nom',
            emailMention: "Mention de l'email",
            address: "Exposition de l'adresse",
            phone: 'Exposition du téléphone',
            webdomain: 'Exposition du domaine web',
            credential: "Fuite d'information d'identification",
            botnet: 'Fuite de botnet',
            default: 'Exposition',
          },
          notAvailable: 'Non disponible',
          notProvided: 'Non fourni',
          dateFound: 'Date trouvée :',
          dateFoundLabel: 'Date trouvée',
          detailsTitle: 'Détails',
          viewUserProfile: "Voir le profil de l'utilisateur",
          showMore: 'Afficher plus',
          showLess: 'Afficher moins',
          close: 'Fermer',
          riskSuffix: 'risque',
          descriptionFallback:
            'Aucune description fournie. Certaines expositions ne révèlent que des champs de base tels que les données divulguées et la date de la fuite.',
          preview: {
            title: 'Aperçu des données divulguées',
            dataTitle: 'Aperçu des données',
            email: 'Email',
            username: "Nom d'utilisateur",
            password: 'Mot de passe',
            name: 'Nom',
          },
          fields: {
            botnetFamily: 'Famille de botnet',
            dataTypesLeaked: 'Types de données divulgués',
            dataTypesExposed: 'Types de données exposées',
          },
          previewDescription: {
            botnet:
              'Les appareils liés à une activité de botnet peuvent être compromis et utilisés pour propager des malwares ou lancer des attaques depuis votre réseau.',
            credentials:
              "Les identifiants exposés sont souvent réutilisés sur les systèmes de l'entreprise.",
            name: "Les noms exposés peuvent être utilisés pour l'usurpation d'identité, l'ingénierie sociale ou des tentatives de phishing ciblées contre votre organisation.",
            email:
              'Les adresses email exposées augmentent le risque de phishing, de credential stuffing et de compromission ciblée de comptes.',
          },
          linkCopy: 'Le lien a été copié dans le presse-papiers',
          exposure: {
            details: "Détails de l'exposition",
            exposedData: 'Données exposées',
            date: "Date d'exposition",
            source: 'Source',
            companyName: "Nom de l'entreprise",
            exposedDataTypes: {
              name: 'Nom',
              email: 'Email',
              address: 'Adresse',
              phone: 'Téléphone',
            },
          },
          leak: {
            details: 'Détails de la fuite',
            type: 'Type',
            passwordLeak: 'Fuite de mot de passe',
            leakedData: 'Données divulguées',
            breachDate: 'Date de la violation',
            breachSource: 'Source de la violation',
            impactedDomain: 'Domaine impacté',
            description: 'Description',
            date: 'Date de la violation',
            breachName: 'Nom de la violation:',
            breachDomain: 'Domaine de la violation:',
          },
          recommendations: {
            title: 'Recommandations',
            alertUser: "Alerter l'utilisateur",
            alertUserDescription:
              "pour vérifier s'ils ont consenti à partager leurs données avec le site web et, dans le cas contraire, le signaler immédiatement.",
            promptUser: 'Inviter l’utilisateur',
            promptUserDescription:
              "à effectuer une analyse approfondie afin de découvrir et signaler d'autres failles de sécurité.",
          },
        },
        emptyState: "Aucun problème n'a été trouvé pour cet utilisateur.",
      },
      deepScan: {
        deepScan: 'Analyse approfondie',
        info: "À partir de l'analyse approfondie initiée par l'utilisateur.",
        lastScan: 'Dernière analyse : ',
        nextScan: 'Prochaine analyse prévue :',
        totalExposures: 'Expositions totales',
        takedownRequests: 'Demandes de suppression',
        unlockData:
          "Débloquez plus d'informations avec les données d'analyse approfondie des employés",
        insights:
          'Avec les informations des analyses approfondies des employés, vous pouvez identifier les vulnérabilités et évaluer leur conformité à la cybersanté personnelle.',
        inviteDeepScan: 'Inviter à une analyse approfondie',
        password: 'Mot de passe compromis',
        email: "Expositions d'email",
        address: "Expositions d'adresse",
        name: 'Expositions de nom',
        image: "Expositions d'image",
      },
      deepDepartments: {
        avgScore: 'Score moyen Protexxa',
        trend: 'Tendance du score Protexxa',
        overview: 'Aperçu',
        status: "Statut de l'analyse approfondie",
        users: 'Utilisateurs',
        cyberPlan: 'Plan de cybersécurité',
        mfa: 'Installations MFA',
        training: 'Formation',
        uniqueUsers: 'utilisateurs uniques',
        havePlan: 'ont un plan de réponse en cybersécurité',
        usingMFA: "utilisent l'authentification multi-facteurs",
        haveTraining: 'ont terminé la formation',
        noDataChartTitle: 'Cette section nécessite plus de données',
        noDataChartSubtitle:
          'La tendance de votre score sera affichée après des analyses ultérieures sur votre compte.',
      },
      executives: 'Dirigeants',
    },
    status: {
      completed: 'Terminé',
      initiated: 'Initié',
      notStarted: 'Pas commencé',
      invited: 'Invité',
      pending: 'En attente',
      active: 'Actif',
      inactive: 'Inactif',
      ongoing: 'En cours',
    },
    modals: {
      publicDomains: {
        title: 'Domaines Web - Points importants',
        item1:
          "Seuls les domaines d'entreprise sont autorisés. Les domaines publics ne seront pas analysés.",
        item3: 'Une fois soumis, les domaines ne peuvent plus être modifiés ou supprimés.',
        item2Title: 'Domaine public',
        item2Description: 'est défini comme suit :',
        item2a:
          "est connu pour offrir une inscription massive d'emails au grand public sans exigence d'affiliation organisationnelle.",
        item2b:
          'Toute personne peut y enregistrer une adresse email, sans avoir besoin de posséder ou de contrôler le domaine.',
        item2c:
          'est exploité par un fournisseur de services de messagerie public, généralement gratuit ou à très faible coût.',
        item2d: "est largement connu et possède une base d'utilisateurs massive.",
        examplesTitle: 'Exemples de domaines publics :',
      },
      notifyUser: {
        title: "Notifier l'utilisateur",
        subtitle:
          "Notifier l'utilisateur pour qu'il prenne des mesures. Les notifications seront envoyées par e-mail.",
        messageTitle: 'Ajouter un message personnalisé',
        messagePlaceholder: 'Entrez votre message personnalisé ici',
        shareTitle: 'Partager les supports de formation',
        optional: '(Optionnel)',
        shareUsers: "Partager le lien avec l'utilisateur(s)",
        selectLibrary: 'Sélectionner une ressource de la bibliothèque',
        resource: 'Ressource',
        cancel: 'Annuler',
        share: 'Envoyer',
        bestPractices: 'Meilleures pratiques en cybersécurité',
      },
      inviteUser: {
        title: "Inviter l'utilisateur",
        subtitle:
          "L'utilisateur recevra une notification par e-mail pour effectuer une analyse approfondie.",
        messageTitle: 'Ajouter un message personnalisé',
        button: "Envoyer l'invitation",
        copy: 'Copier',
        copyTitle:
          "Vous pouvez également copier le lien d'invitation et le partager avec l'utilisateur.",
        inviteDefaultMessage:
          "Vous avez été invité à configurer votre compte sur Defender et à lancer une analyse approfondie. Cette étape est essentielle pour garantir un processus d'intégration sécurisé.",
        inviteSuccessMessage: "L'utilisateur a été invité avec succès !",
        inviteErrorMessage: "Une erreur s'est produite lors de l'envoi de l'invitation.",
        inviteDeepScan:
          'Vous avez été invité à configurer votre compte sur Defender et à lancer une analyse approfondie.',
      },
      bulkAction: {
        title: 'Notifier les utilisateurs',
        subtitle:
          "Notifier les utilisateurs pour qu'ils prennent des mesures. Les notifications seront envoyées par e-mail.",
        buttons: {
          cancel: 'Annuler',
          next: 'Suivant',
          previous: 'Précédent',
          share: 'Partager',
          gotIt: 'Compris',
        },
        selectInvite: {
          step: 'Étape 1 : Sélectionnez vos destinataires',
          filter: {
            users: 'Utilisateurs',
            departments: 'Départements',
            executives: 'Cadres',
          },
          searchPlaceholder: 'Recherchez le nom des utilisateurs ici',
          check: 'Envoyer à tous les utilisateurs',
          empty: 'Les utilisateurs sélectionnés seront affichés ici',
          emptyList: 'Aucun donnée disponible',
        },
        sendInvite: {
          step: 'Étape 2 : Entrez le message',
          message: 'Ajouter un message personnalisé',
          placeholder: 'Entrez votre message personnalisé ici',
          share: {
            title: 'Partager des supports de formation',
            optional: '(Optionnel)',
            selectLibrary: 'Sélectionner une ressource de la bibliothèque',
            shareLink: 'Partager le lien avec les utilisateurs',
          },
          link: 'URL du lien',
          linkPlaceholder: 'Collez le lien ici',
        },
        success: {
          title: 'Les notifications ont été envoyées !',
          subtitle:
            'Votre message a été transmis avec succès aux adresses e-mail des destinataires.',
        },
      },
      bulkScanInvite: {
        manualInvite: 'Invitation manuelle',
        bulkInvite: 'Invitation en masse',
        deepScan: 'Invitation à un scan approfondi',
        sendInvitations: 'Envoyer des invitations',
        sendInvitationsWithCount: 'Envoyer {{count}} invitations',
        comingSoon: 'Cette fonctionnalité sera disponible prochainement.',
        success: {
          title: 'Les invitations ont été envoyées !',
          subtitle:
            'Votre message a été transmis avec succès aux adresses e-mail des destinataires.',
        },
      },
      comingSoon: 'Bientôt',
    },
    companySettings: {
      profileToastError: 'Données du profil introuvables.',
      addAdminModal: {
        addSuccesMessage:
          'L’utilisateur administrateur a été ajouté avec succès et l’utilisateur a été informé.',
        revokeSuccesMessage:
          'L’accès administrateur de l’utilisateur a été retiré avec succès et son statut est passé à « inactif ».',
        title: 'Ajouter un administrateur',
        description:
          'Recherchez un utilisateur ou ajoutez-le manuellement pour accorder un accès administrateur',
        searchUser: 'Rechercher un utilisateur',
        addUserManually: 'Ajouter un utilisateur manuellement',
        selectUser: 'Sélectionner un utilisateur',
        enterUserEmail: "Entrez l'e-mail de l'utilisateur",
        emailLabel: 'E-mail',
        grantAccess: "Accorder l'accès",
        cancel: 'Annuler',
        success:
          "L'utilisateur sélectionné aura un accès complet à la gestion des utilisateurs, à l'initiation des analyses, aux demandes de retrait et aux autorisations, pourra inviter des administrateurs de société, attribuer des autorisations et lancer/consulter des analyses groupées et leurs résultats.",
        error: "E-mail invalide. Vérifiez l'e-mail et réessayez.",
        invalidEmail: 'Adresse e-mail invalide',
        hasAlreadyAdminAccess: 'L’utilisateur a déjà un accès administrateur',
        enterUserEmailWithDomain:
          'Entrez l’e-mail de l’utilisateur (avec le domaine de la société) ici',
        searchUserPlaceholder: 'Rechercher un utilisateur par nom ou e-mail',
      },
      revokeAdminAccessModal: {
        title: "Retirer l'accès administrateur",
        confirmation:
          "Êtes-vous sûr de vouloir continuer ? Cet utilisateur perdra l'accès au tableau de bord administrateur et à toutes les fonctions associées.",
        cancel: 'Annuler',
        remove: "Retirer l'accès",
      },
      adminManagement: {
        title: 'Utilisateurs administrateurs',
        description:
          'Créez et gérez des rôles internes dans votre entreprise, de manière sécurisée et autonome, pour soutenir la conformité et la sécurité',
        name: 'Nom',
        createdBy: 'Ajouté par',
        updatedBy: 'Mis à jour par',
        status: 'Statut',
        removeAccess: 'Supprimer l’accès',
        owner: 'Propriétaire',
      },
      adminStatus: {
        status: 'Statut',
        active: 'Actif',
        inactive: 'Inactif',
        invited: 'Invité',
        invitedExpired: 'Invitation expirée',
        invitedCancelled: 'Invitation annulée',
      },

      security: {
        title: 'Paramètres de sécurité',
        description:
          'Protégez votre compte en mettant à jour votre mot de passe ou en gérant l’accès au compte.',
        passwordChanged: 'Mot de passe modifié avec succès',
        updatePassword: {
          title: 'Mettre à jour le mot de passe',
          description:
            'Votre nouveau mot de passe doit comporter au moins 12 caractères et contenir :',
          requirements:
            'Votre nouveau mot de passe doit comporter au moins 12 caractères et contenir :',
          currentPassword: 'Mot de passe actuel',
          newPassword: 'Nouveau mot de passe',
          confirmPassword: 'Confirmer le nouveau mot de passe',
          enterYourNewPassword: 'Saisissez votre nouveau mot de passe',
          enterYourCurrentPassword: 'Saisissez votre mot de passe actuel',
          button: 'Mettre à jour le mot de passe',
          update: 'Mettre à jour le mot de passe',
          cancel: 'Annuler',
          passwordRequirements: 'Exigences relatives au mot de passe',
          requirement: {
            length: 'Au moins 12 caractères',
            uppercase: 'Au moins une lettre majuscule',
            lowercase: 'Au moins une lettre minuscule',
            special: 'Au moins 1 caractère spécial (^$*.[]{}()? -"!@#%&/, ><:;|_`~+=)',
          },
        },
        deleteAccount: {
          title: 'Supprimer le compte',
          description: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
          warning:
            'Cette action supprimera définitivement toutes vos données et révoquera votre accès à la plateforme.',
          irreversible: 'Cette action est irréversible.',
          button: 'Supprimer mon compte',
          success: 'Accès administrateur révoqué avec succès. Vous allez être déconnecté sous peu.',
          error: 'Échec de la suppression du compte. Veuillez réessayer.',
          modal: {
            title: 'Supprimer mon compte',
            confirmation: 'Êtes-vous sûr de vouloir continuer ? Veuillez confirmer à nouveau.',
            irreversibleWarning: 'Cette action est irréversible.',
            cancel: 'Annuler',
            delete: 'Confirmer la suppression du compte',
          },
        },
        validation: {
          currentPassword: {
            required: 'Le mot de passe actuel est requis',
          },
          newPassword: {
            required: 'Le nouveau mot de passe est requis',
            minLength: 'Le mot de passe doit comporter au moins 12 caractères',
            number: 'Le mot de passe doit contenir au moins un chiffre',
            lowercase: 'Le mot de passe doit contenir au moins une lettre minuscule',
            uppercase: 'Le mot de passe doit contenir au moins une lettre majuscule',
            special: 'Le mot de passe doit contenir au moins un caractère spécial',
          },
          confirmPassword: {
            required: 'La confirmation du mot de passe est requise',
            match: 'Les mots de passe doivent correspondre',
          },
        },
      },
      toasterMessage: 'Information mise à jour avec succès!',
      toasterMessageError: 'Erreur lors de la mise à jour des informations !',
      numberOfSeats: 'Nombre de postes',
      outOf: 'sur',
      deleteMyProfile: 'Supprimer mon profil',
      deleteInfo:
        'Vous recevrez un courriel pour confirmer votre décision. Cela ne mettra pas fin à votre abonnement ou à vos paiements et vous continuerez de payer des frais. Vous pouvez annuler votre abonnement, ou changer votre mode de paiement pour maintenir votre équipe active.',
      deleteWarning: 'Vous ne pourrez pas revenir en arrière.',
      deleteConfirmation: 'Supprimer mon profil',
      securityInformation: 'Données de sécurité',
      securityEmail: 'Adresse de courrier électronique:',
      securityPassword: 'Mot de passe:',
      requestMore: 'En demander davantage',
      appsInUse: 'Applications utilisées',
      domains: 'Domaines',
      webDomains: 'Domaines Internet',
      addressStreet: 'Rue',
      addressNumber: 'Numéro',
      addressCity: 'Ville',
      addressZipCode: 'Code postal',
      addressCountry: 'Pays',
      addressState: 'État / Province',
      fullname: 'Nom complet',
      preferred: 'Préférence',
      personalInfo: 'Renseignements personnels',
      gender: 'Genre',
      male: 'Homme',
      female: 'Femme',
      other: 'Autre',
      undefined: 'Plutôt ne pas dire',
      verified: 'Vérifié',
      unverified: 'Non vérifié',
      addSecondaryEmail: 'Ajouter des adresses de courrier électronique secondaires',
      profilePhoto: 'Photo de profil',
      uploadPhoto: 'Téléchargez votre photo ici',
      securityActions: 'Mesures de sécurité',
      twoMFAQuestion: 'Utilisez-vous l’authentification multi-facteurs sur tous vos comptes?',
      twoMFADescription:
        'Cette information nous aide à déterminer si vous appliquez un niveau maximal de protection et de sécurité en ligne.',
      passwordManagerQuestion: 'Utilisez-vous un gestionnaire de mots de passe?',
      passwordManagerDescription:
        'Cette information nous aide à déterminer si vous employez les meilleures pratiques pour stocker vos mots de passe dans une chambre forte numérique qui offre une protection solide contre les cybercriminels.',
      cyberResponsePlanQuestion:
        'Disposez-vous d’un plan personnel d’intervention en cas d’incident de cybersécurité?',
      cyberResponsePlanDescription:
        'Cette information nous aide à déterminer si vous pouvez réagir rapidement et efficacement en cas de cyberattaque ou d’atteinte à la cybersécurité.',
      cyberSecurityInsuranceQuestion: 'Avez-vous une assurance cybersécurité?',
      cyberSecurityInsuranceDescription:
        'Cette information nous aide à déterminer si vous pouvez bénéficier d’une protection et d’un soutien supplémentaires en cas de cyberincident ou de cyberattaque.',
      goToMarketplace: 'Ouvrir le Marché aux outils',
      downloadTemplate: 'Télécharger le modèle',
      saveChanges: 'Enregistrer les modifications',
      billingAddressChanged: 'Courriel de facturation modifié',
      changeBillingEmail: 'Modifier l’adresse de courrier électronique pour la facturation',
      billingActions: 'Actions de facturation',
      billingEmailsAreSentTo: 'Les courriels de facturation sont envoyés à :',
      changeEmail: 'Modifier l’adresse de courrier électronique',
      billingDetails: 'Détails de facturation',
      addMore: 'Ajouter plus de postes',
      cancelSubscription: 'Annuler l’abonnement',
      cancelSubscriptionInfo:
        'Si vous annulez votre abonnement, vous et vos employés n’aurez plus accès à la plateforme Protexxa. Veuillez communiquer avec l’équipe Protexxa pour continuer.',
      domainRemoved: 'Domaine supprimé avec succès',
      domainAdded: 'Domaine ajouté avec succès',
      maxDomains: 'Maximum de 4 domaines autorisés',
      notValidDomain: 'Vide ou domaine non valide',
      publicDomainNotAllowed: 'Les domaines publics ne sont pas autorisés',
      duplicateDomain: 'Domaine déjà ajouté',
      industryChanged: 'Secteur d’activités modifié',
      companyDomains: 'Domaines de l’entreprise',
      companyProfile: 'Profil de l’entreprise',
      companyName: 'Nom de l’entreprise',
      industry: 'Secteur d’activités',
      uploadedLogo: 'Logo téléversé avec succès',
      yourLogo: 'Votre logo',
      uploadYourLogoHere: 'Téléversez votre logo ici',
      imageFileSize:
        'Votre image devrait avoir une hauteur de 45 px, et le fichier ne devrait pas dépasser 200 ko.',
      validation: {
        fullname: 'Le nom complet est requis',
        address: {
          street: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La rue est requise',
          },
          number: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le numéro est requis',
          },
          postalCode: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le code postal est requis',
          },
          city: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La ville est requise',
          },
          country: 'Le pays est requis',
          state: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: "L'État/Province est requis",
          },
        },
        birthDate: 'La date de naissance valide est requise',
        gender: 'Le sexe est requis',
        useMFA: 'La réponse est requise',
        haveResponsePlan: 'La réponse est requise',
      },
      batchScan: {
        title: 'Scans en lot',
        download: 'Fichier téléchargé avec succès !',
        upload: 'Fichier téléversé avec succès !',
        button: {
          choose: 'Choisir un fichier',
          upload: 'Téléverser un fichier',
        },
        status: {
          completed: 'Terminé',
          inProgress: 'En cours',
          error: 'Erreur',
        },
        table: {
          name: 'Nom',
          status: 'Statut',
          created: 'Créé',
          finished: 'Terminé',
          download: 'Télécharger',
          empty: 'Aucune donnée à afficher',
        },
      },
      accountSettings: {
        title: "Informations sur l'entreprise",
        subtitle:
          'Gérez les détails de votre entreprise et les domaines pour aider à sécuriser et personnaliser l’expérience de votre organisation.',
        saveButton: 'Enregistrer les modifications',
        avatar: {
          title: "Logo de l'entreprise",
          upload: {
            title: 'Cliquez ici pour téléverser le logo de votre entreprise',
            subtitle:
              'Votre image doit avoir une taille de fichier de 200 ko et une hauteur de 45 px',
          },
        },
        name: {
          title: "Nom de l'entreprise",
        },
        industry: {
          title: "Secteur d'activité",
          selectPlaceholder: "Sélectionnez le secteur d'activité",
        },
        domains: {
          title: "Domaines de l'entreprise",
          subtitle: 'Ajoutez les domaines de votre entreprise',
          addButton: 'Ajouter',
          readOnlyMessage: 'Pour mettre à jour les domaines de votre entreprise, contactez',
          contactSupport: 'Protexxa Support',
        },
      },
    },
    companySignUp: {
      toastError: 'Lien d’invitation non valide',
      toastDuplicatedAccount: 'Votre compte a déjà été enregistré',
      companyOnBoarding: {
        navBar: {
          firstStep: {
            label: "Détails de l'entreprise",
            description: `Fournissez quelques détails sur votre entreprise`,
          },
          secondStep: {
            label: 'Détails des employés',
            description: "Fournissez des détails sur vos employés dans l'entreprise",
          },
          thirdStep: {
            label: 'Revue et analyse',
            description: `Revoyez les détails fournis avant de lancer votre première analyse`,
          },
        },
        stepComponents: {
          firstStep: {
            fields: {
              companyName: "Nom de l'entreprise",
              industry: "Secteur d'activité",
              webdomains: 'Domaines Web',
              webDomainCaption:
                'Entrez le domaine valide de votre entreprise. Les domaines publics ne sont pas autorisés.',
              webDomainCaptionWarning:
                'Une fois soumis, les domaines ne peuvent plus être modifiés ou supprimés.',
              addAnotherWebDomains: 'Ajouter un autre domaine',
              maximumDomains: 'Maximum de 4 domaines autorisés',
              termsAgreement: 'En cliquant sur “Continuer”, vous acceptez nos',
              and: 'et',
              industries: {
                informationTechnology: "Technologie de l'information",
                healthCare: 'Soins de santé',
                financials: 'Finances',
                consumerDiscretionary: 'Biens de consommation discrétionnaire',
                communicationServices: 'Services de communication',
                industrials: 'Industrie',
                consumerStaples: 'Biens de consommation courante',
                energy: 'Énergie',
                utilities: 'Services publics',
                realEstate: 'Immobilier',
                materials: 'Matériaux',
                other: 'Autre',
                nonProfit: 'Organisme à but non lucratif',
              },
              selectIndustry: "Sélectionnez votre secteur d'activité",
            },
          },
          secondStep: {
            fields: {
              uploadEmployeeData:
                "Téléchargez les données des employés de votre entreprise. Utilisez le fichier d'exemple comme modèle pour structurer vos données correctement.",
              downloadSampleFile: "Télécharger le fichier d'exemple",
              uploadData: 'Télécharger les données',
            },
          },
          thirdStep: {
            fields: {
              companyDetails: "Détails de l'entreprise",
              edit: 'Modifier',
              companyName: "Nom de l'entreprise",
              industry: 'Secteur',
              webDomains: 'Domaines web',
              employeeDetails: 'Détails des employés',
              uploadedFile: 'Fichier téléchargé',
              noFileUploaded: 'Aucun fichier téléchargé',
              preview: 'Aperçu',
              checkboxText:
                "Seules les données de l'entreprise seront analysées maintenant. Les données personnelles pourront être analysées plus tard avec consentement, et les administrateurs ne verront que des informations anonymisées.",
              learnMore: 'En savoir plus',
              previousStep: 'Étape précédente',
              completeAndScan: 'Terminer et analyser',
            },
          },
          previewComponent: {
            fields: {
              filePreviewTitle: 'Aperçu du fichier',
              filePreviewDescription:
                'Aperçu des 10 premiers profils de votre fichier téléchargé pour examiner la structure des données.',
              tableHeaders: {
                name: 'Nom',
                nameDetailed: '(Prénoms et Noms)',
                email: 'E-mail',
                department: 'Département',
                role: 'Rôle',
              },
            },
          },
          fileUploaded: {
            errors: {
              failedUpload: 'Échec du téléchargement du fichier. Veuillez réessayer.',
              unsupportedFileType: 'Type de fichier non pris en charge.',
              seatCountExceeded: 'Nombre de sièges invalide.',
              seatCountPopup:
                "Le nombre d'utilisateurs dans votre fichier dépasse le nombre de sièges autorisés par votre licence. Veuillez vérifier votre fichier et le téléverser à nouveau.",
              requiredFile: 'Le fichier est requis.',
              fileToolLarge: 'Fichier est trop volumineux.',
              fileToolLargePopup: 'Fichier est trop volumineux. Votre fichier dépasse 5 Mo.',
              hasNoRows: 'Le fichier CSV est vide et ne contient aucune ligne.',
              missingHeaders: 'Le fichier ne contient pas les en-têtes requis : ',
              missingHeadersPopup:
                "Le fichier ne contient pas les en-têtes requis, veuillez vous assurer que le fichier correspond au modèle d'exemple.",
            },
            browseFile: 'Parcourir le fichier',
            dragDrop: 'ou glissez et déposez-le ici',
            supportedFormats: 'Seuls les formats CSV, XLSX sont pris en charge',
            fileUploadedCompleted: '- 100 % téléversé',
            uploading: 'téléchargement en cours...',
            uploadAnother: 'Télécharger un autre',
            previewFile: 'Aperçu du fichier',
            invalidFormat:
              'Format de fichier invalide. Seuls les formats CSV ou XLSX sont pris en charge.',
            profilesUploaded: '{{rowCount}} profils ont été téléchargés',
          },
          stepsSchema: {
            firstStep: {
              title: 'Fournissez les détails de votre entreprise',
              description: 'Configurez les détails de votre entreprise pour la préparer',
              validation: {
                companyName: {
                  required: "Le nom de l'entreprise est requis",
                },
                industry: {
                  required: "Le secteur d'activité est requis",
                },
                webDomains: {
                  url: 'Domaine web invalide',
                  required: 'Le domaine web est requis',
                  min: 'Au moins un domaine web est requis',
                  invalid: 'Domaine web invalide',
                  publicDomainNotAllowed:
                    "Ceci est un domaine public. Seuls les domaines d'entreprise sont autorisés.",
                },
              },
              buttons: { next: 'Suivant : Détails des employés' },
            },
            secondStep: {
              title: 'Fournissez les détails de vos employés',
              description:
                'Importez les détails de vos employés pour effectuer une analyse rapide et obtenir des résultats plus qualitatifs',
              buttons: {
                next: 'Suivant : Réviser et analyser',
                previous: 'Étape précédente',
              },
            },
            thirdStep: {
              title: 'Révisez et confirmez vos détails',
              description:
                "Révisez vos détails pour compléter l'inscription et déclencher votre première analyse.",
              validation: {
                employeeFile: {
                  required: 'Le fichier des employés est requis',
                },
                confirmation: {
                  required: 'Vous devez confirmer avant de continuer',
                },
              },
            },
          },
        },
        batchLoading: {
          title: 'Votre analyse est en cours !',
          warningMessage:
            "Cette analyse peut prendre jusqu'à 24 heures. Une fois terminée, votre résultat d'analyse sera disponible dans le tableau de bord et vous serez notifié par courriel.",
          warningMessageShort:
            "Cette analyse peut prendre jusqu'à 24 heures. Une fois terminée, votre résultat d'analyse sera disponible dans le tableau de bord et vous serez notifié par courriel.",
          button: 'Aller au tableau de bord',
        },
      },
    },
    companyInvalidInvite: {
      invalidInviteTitle: `Lien d'invitation invalide.`,
      invalidInviteOutdated: `Le lien d'invitation que vous avez utilisé peut être obsolète, incorrect ou plus disponible.`,
      invalidInviteDoubleCheck: `Veuillez vérifier à nouveau l'URL ou réessayer ultérieurement. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter notre équipe d'assistance pour obtenir de l'aide.`,
      invalidInviteThankYou: 'Merci pour votre compréhension.',
    },
    companyUsers: {
      unassigned: 'Non assigné',
      noRole: 'Aucun rôle',
      admins: 'Liste des membres',
      addAdmin: 'Ajouter un administrateur',
      deleteUser: 'Supprimer un utilisateur',
      deleteInfo: 'Voulez-vous vraiment supprimer votre compte?',
      editUser: "Modifier l'utilisateur",
      delete: 'Supprimer',
      name: 'Nom',
      accountCreated: 'Compte créé',

      status: 'Statut',
      showing: 'Montrant',
      email: 'Adresse électronique',
      invited: 'Invitation envoyée',
      removeSelected: 'Supprimer la sélection',
      searchPlaceholder: 'Rechercher par e-mail',
      searchNewUser: 'rechercher un nouvel utilisateur',
      sortNameAZ: 'Nom [A-Z]',
      sortNameZA: 'Nom [Z-A]',
      sortEmailAZ: 'Adresse de courrier électronique [A-Z]',
      sortEmailZA: 'Adresse de courrier électronique [Z-A]',
      scanCompleted: 'Analyse terminée',
      scanIncomplete: 'Analyse incomplète',
      sortBy: 'Trier par :',
      subtitleAddAdminModal: "Entrez une adresse e-mail valide pour recevoir l'invitation",
      editUserModal: {
        title: "Modifier l'utilisateur",
        resendInvite: "Renvoyer l'invitation",
        user: 'Utilisateur',
        admin: 'Administrateur',
        name: 'Nom',
        role: 'Rôle',
        validation: {
          email: "L'e-mail est requis",
        },
      },
      listofMembers: 'Liste des membres',
      subtitle: {
        left: 'dehors',
        right: 'sièges occupés',
      },
      deleteUserModal: {
        succesMessage: 'Compte supprimé!',
      },
      showingSelect: {
        allMembers: 'Tous les membres',
        admins: 'Administrateurs',
        users: 'Utilisateurs',
      },
      statusSelect: {
        showingAll: 'Afficher tout',
        completedProfile: 'Profil complété',
        registered: 'Inscrit',
        pending: 'En attente',
      },
      deleteUserTitle: 'Es-tu sûr? ',
      deleteUserMessage:
        'Si vous continuez, toutes les informations de ces utilisateurs seront supprimées et ils perdront l’accès à la plateforme. Cette action ne peut pas être annulée.',
      resendInvites: 'Renvoyer les invitations',
      inviteUsers: 'Inviter des utilisateurs',
      succesInviteUsers: 'Invitations envoyées avec succès!',
      emptyStates: {
        inviteTable: "Vous n'avez aucune invitation à prévisualiser pour {{pageState}}.",
      },
    },
    bulkScans: {
      noScanPerformed: 'Aucun scan',
      title: 'Consultez le journal des analyses récentes de votre entreprise',
      totalActiveUsers: 'Total des utilisateurs actifs',
      totalActivedUsers: {
        progressBar: '{{percentage}}% des {{totalNumber}} sièges sous licence',
      },
      recentBulkUploads: 'Téléversements récents',
      runScan: 'Lancer une analyse en masse',
      upgrade: 'Mise à niveau',
      recentBulkUploadsSubText:
        "Les administrateurs peuvent consulter ici les téléchargements antérieurs et les résultats d'analyse. Seuls les nouveaux utilisateurs dont l'adresse e-mail professionnelle est valide sont analysés ; les autres suivent leur cycle d'analyse défini (par exemple, mensuel, bimestriel).",
      recentBulkScansSubText:
        'Les administrateurs peuvent consulter ici les analyses en masse passées (programmées ou manuelles) et leurs résultats.',
      table: {
        bulkScanByDate: 'Analyses par date',
        domains: 'Domaines',
        usersScanned: 'Utilisateurs analysés',
        type: 'Type',
        status: 'Statut',
        downloadResult: 'Télécharger le résultat',
        filename: 'Nom du fichier',
        uploadedUsers: 'Téléchargé par des utilisateurs',
        validUsersTooltip:
          "Le nombre d'utilisateurs dans le fichier en masse avec les e-mails du domaine de l'entreprise.",
        validUsers: 'Utilisateurs valides',
        uploadedBy: 'Téléchargé par',
        uploaded: 'Téléchargé',
        action: 'Actions',
        downloadScanResult: "Résultat de l'analyse",
        tooltip: {
          title:
            "Une erreur technique s'est produite. Cliquez sur le bouton ci-dessous pour réessayer.",
          button: "Lancer l'analyse groupée",
        },
      },
      runScanModal: {
        title: 'Importez les données de vos employés',
        description:
          'Importez les informations de vos employés pour lancer une analyse rapide et obtenir des résultats plus qualitatifs',
        cancel: 'Annuler',
        startBulkScanError:
          "Erreur lors du démarrage de l'analyse groupée. Veuillez réessayer ultérieurement.",
        populateBulkScanError:
          'Erreur lors du pré-remplissage des données du scan groupé. Veuillez réessayer plus tard.',
      },
      status: {
        all: 'Tout',
        pending: 'En attente',
        completed: 'Terminé',
        failed: 'Échoué',
        scanning: 'En cour',
      },
      type: {
        by: 'par',
        manual: 'Manuel',
        scheduled: 'Programmé',
        tooltip: {
          parts: [
            { text: 'Les analyses manuelles', variant: 'bold' },
            { text: ' sont lancées par un administrateur, tandis que les ', variant: 'regular' },
            { text: 'analyses programmées', variant: 'bold' },
            {
              text: " s'exécutent automatiquement en fonction du plan de votre entreprise.",
              variant: 'regular',
            },
          ],
        },
      },
      toast: {
        successDownloadBulkScan:
          'Votre téléchargement a commencé automatiquement. Il sera bientôt terminé.',
        errorDownloadBulkScan: 'Échec du téléchargement des résultats de scan',
      },
      expandedDetails: {
        tooltipInfo:
          'Nombre d’utilisateurs dans le fichier groupé ayant des adresses e-mail du domaine de l’entreprise.',
        fileUploaded: 'Fichier téléversé',
        uploadedUsers: 'Utilisateurs téléversés',
        validUsers: 'Utilisateurs valides',
        scanStarted: 'Analyse commencée',
        scanCompleted: 'Analyse terminée',
        uploadedBy: 'Téléversé par',
        scanTriggered: 'Analyse déclenchée',
      },
      manualBy: 'Manuel par',
      recentBulkScans: 'Analyses récentes',
      nextScheduledScan: 'Prochaine analyse planifiée',
      lastBulkScan: 'Dernière analyse groupée',
    },
    home: {
      business: 'Pour les entreprises',
      coming: 'Prochainement',
      message: 'Bonjour tout le monde!',
      active: 'Activez votre meilleur atout en matière de cybersécurité...',
      people: 'votre personnel',
      transformDigital:
        '90 % des cyberattaques sont causées par des erreurs humaines. Révolutionnez votre protection numérique dès aujourd’hui.',
      b2bsaas:
        'Protexxa est une plateforme de cybersécurité B2B en SaaS qui s’appuie sur l’intelligence artificielle de façon à rapidement',
      identify: 'identifier',
      evaluate: 'évaluer',
      predict: 'prévoir',
      and: 'et',
      resolveCyber: 'résoudre les problèmes de cybersécurité',
      forEmployees: 'pour le personnel.',
      orService: 'Nos services',
      helpingDigitalSecurity:
        'Pour vous aider à accroître la sécurité numérique dans toute votre entreprise',
      defender: 'Protexxa Defender',
      defenderDescription:
        'Prenez le contrôle et réduisez les cybervulnérabilités grâce à notre solution d’évaluation et de correction fondée sur l’IA.',
      consulting: 'Services-conseils',
      consultingDescription:
        'Renforcez vos capacités de cybersécurité grâce à des services-conseils stratégiques, des tests de contrôle et des exercices interactifs sur table.',
      training: 'Formation',
      trainingDescription:
        'Renforcez l’assurance de tous les membres de votre entreprise en matière de cybersécurité. Les cadres supérieurs sont ciblés 12 fois plus que les employés.',
      getInTouch: 'prendre contact',
      learnMore: 'En savoir plus',
      vulnerableCompany:
        'Savez-vous à quel point votre entreprise est vulnérable aux cyberattaques?',
      vulnerableCompanyDescription:
        'Les cyberattaques se multiplient rapidement. Depuis le début de la pandémie de la COVID-19, la cybercriminalité a quadruplé.',
      penetrated: 'réseaux d’entreprise peuvent être infiltrés',
      human: 'cyberattaques sont causées par des erreurs humaines',
      hacked: 'internautes ont été piratés',
      malware:
        'téléphones intelligents ou ordinateurs sont infectés par des logiciels malveillants',
      small: 'cyberattaques visent les petites entreprises',
      networks: 'cyberattaques ont visé des réseaux d’entreprise depuis 2021',
      aboutUs: 'Témoignages à notre sujet',
      customers: 'Quelques mots de nos clients',
      partners: 'Des partenaires de confiance',
      partnerships: 'Des partenariats en place pour vous protéger et vous soutenir',
      testimonials: {
        jane: `Nous avons été choqués d'apprendre que tous les membres de notre équipe avaient des renseignements personnels à vendre sur le Web clandestin. Protexxa nous a permis de renforcer énormément notre sécurité.`,
        steve:
          'Mon entreprise a été piratée et nous avions 45 minutes pour payer la rançon. Je ne savais pas qui appelais, alors j’ai payé. Maintenant que nous sommes clients de Protexxa, nous savons quoi faire et qui appeler si cela se reproduit... ce que je n’espère pas!',
        mohamed:
          'La formation en cybersécurité offerte par Protexxa a changé la façon dont nous travaillons au sein de notre entreprise. La sécurité est maintenant intégrée à tous nos processus.',
      },
    },
    contact: {
      reachingOut: 'Merci de nous avoir contactés',
      hereToHelp: 'Nous sommes là pour vous aider, parlons.',
    },
    forgotPassword: {
      forgotPassword: 'Mot de passe oublié',
      enterEmail:
        'Veuillez saisir l’adresse de courrier électronique associée à votre compte et nous vous enverrons un code de vérification pour réinitialiser votre mot de passe.',
      email: 'Adresse électronique',
      sendCode: 'Envoyer un code',
      cancel: 'Annuler',
      checkEmail: 'Veuillez vérifier votre adresse de courrier électronique et réessayer.',
      verification: 'Vérification',
      securityCodePhoneNumber: 'Nous avons envoyé le code de sécurité au numéro de téléphone',
      securityCodeEmail: "Nous avons envoyé le code de sécurité à l'e-mail",
      editNumber: 'Modifier le numéro de téléphone',
      didntReceive: 'Vous n’avez pas reçu le code?',
      resendCode: 'Envoyer un nouveau code',
      wrongCode: 'Code erroné',
      passwordChanged: 'Votre mot de passe a été modifié avec succès',
      resetPassword: 'Réinitialiser le mot de passe',
      strongPassword: 'Choisissez un mot de passe robuste pour sécuriser votre compte',
      passwordRequirements: 'Exigences pour votre mot de passe',
      minimumCharacters: 'Minimum de 12 caractères',
      oneNumber: 'Au moins un chiffre',
      oneUppercase: 'Au moins une lettre majuscule',
      validation: {
        newPassword: {
          required: 'Le mot de passe est requis',
          min: 'Le mot de passe est trop court - il doit contenir au moins 12 caractères.',
          matches:
            'Doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial',
        },
        confirmNewPassword: {
          required: 'Confirmer le mot de passe est requis',
          oneOf: 'Les deux mots de passe doivent être identiques',
        },
      },
      networkError: 'Erreur réseau. Veuillez vérifier votre connexion internet.',
      somethingWentWrong: "Quelque chose s'est mal passé. Veuillez réessayer ultérieurement.",
      modal: {
        title: 'Compte non confirmé',
        subtitle:
          "Votre compte n'est pas encore confirmé. Veuillez confirmer votre compte en vous reconnectant ou contactez le support pour obtenir de l'aide.",
        button: "Page d'accueil",
      },
    },
    integration: {
      message: {
        comingSoon:
          'Intégrez les données de vos employés de manière transparente depuis vos différentes plateformes de ressources humaines tierces.',
      },
    },
    settings: {
      toasterMessage: 'Information mise à jour avec succès!',
      password: 'Mot de passe',
      emailUpdated: 'Adresse de courrier électronique mise à jour!',
      maxEmails: 'Nombre maximum d’adresses de courrier électronique atteint',
      passwordChanged: 'Mot de passe modifié!',
      securityInformation: 'Données de sécurité',
      saveChanges: 'Enregistrer les modifications',
      add: 'Ajouter',
      email: 'Adresse électronique principale',
      primary: 'Principal',
      secondaryAccounts: 'Ajouter des comptes avec adresses secondaires',
      changePassword: 'Modifier le mot de passe',
      passwordRequirements: 'Exigences pour votre mot de passe',
      minimumCharacters: 'Minimum de 12 caractères',
      oneNumber: 'Au moins un chiffre',
      oneUppercase: 'Au moins une lettre majuscule',
      containsSpecial: 'Au moins un caractère spécial',
      currentPassword: 'Mot de passe actuel',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      deleteProfile: 'Supprimer mon profil',
      confirmDecision:
        'Vous recevrez un courriel pour confirmer votre décision. Cela ne mettra pas fin à votre abonnement ou à vos paiements et vous continuerez de payer des frais. Vous pouvez annuler votre abonnement, ou changer votre mode de paiement pour maintenir votre équipe active.',
      cantReversed: 'Vous ne pourrez pas revenir en arrière.',
      accountDeleted: 'Compte supprimé',
      deleteUser: 'Supprimer un utilisateur',
      sureDelete1: 'Êtes-vous sûr(e) de vouloir supprimer votre compte Protexxa ?',
      sureDelete2:
        "Cette action est irréversible et effacera définitivement toutes vos données. Vous perdrez l'accès à nos services, y compris la surveillance de la sécurité numérique et les plans d'intervention en cas d'incident.",
      sureDelete3:
        "Avant de continuer, veuillez contacter notre support Concierge qui pourra répondre à toutes vos préoccupations ou vous fournir de l'aide pour votre compte.",
      appsInUse: 'Applications utilisées',
      domains: 'Domaines',
      webDomains: 'Domaines Internet',
      securityActions: 'Mesures de sécurité',
      goToMarketplace: 'Ouvrir le Marché aux outils',
      downloadTemplate: 'Télécharger le modèle',
      TowFactor: 'Utilisez-vous l’authentification multi-facteurs sur tous vos comptes?',
      towFactorDescription:
        'Cela aide à déterminer si vous améliorez votre protection et sécurité en ligne.',
      passwordManager: 'Utilisez-vous un gestionnaire de mots de passe?',
      passwordManagerDescription:
        'Cette information nous aide à déterminer si vous employez les meilleures pratiques pour stocker vos mots de passe dans une chambre forte numérique qui offre une protection solide contre les cybercriminels.',
      responsePlan:
        'Disposez-vous d’un plan personnel d’intervention en cas d’incident de cybersécurité?',
      responsePlanDescription:
        'Cette information nous aide à déterminer si vous pouvez réagir rapidement et efficacement en cas de cyberattaque ou d’atteinte à la cybersécurité.',
      securityInsurance: 'Avez-vous une assurance cybersécurité?',
      securityInsuranceDescription:
        'Cette information nous aide à déterminer si vous pouvez bénéficier d’une protection et d’un soutien supplémentaires en cas de cyberincident ou de cyberattaque.',
      notVerified: 'Non vérifié',
      resendVerificationButton: 'Renvoyer la vérification',
      resendVerification: {
        success: 'Email renvoyé avec succès !',
        error: "Impossible de renvoyer l'email de vérification. Veuillez réessayer ultérieurement.",
      },
      validation: {
        fullname: 'Le nom complet est requis',
        address: {
          street: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La rue est requise',
          },
          number: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le numéro est requis',
          },
          postalCode: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le code postal est requis',
          },
          city: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La ville est requise',
          },
          country: 'Le pays est requis',
          state: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: "L'État/Province est requis",
          },
        },
        birthDate: 'La date de naissance valide est requise',
        gender: 'Le sexe est requis',
        useMFA: 'La réponse est requise',
        haveResponsePlan: 'La réponse est requise',
        currentPassword: 'Le mot de passe actuel est requis',
        newPassword: {
          required: 'Le nouveau mot de passe est requis',
          min: 'Le mot de passe est trop court - il doit contenir au moins 12 caractères.',
          matches:
            'Doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial',
        },
        confirmPassword: {
          required: 'Confirmer le mot de passe est requis',
          oneOf: 'Les deux mots de passe doivent être identiques',
        },
      },
    },
    dashboard: {
      welcomeBack: 'Bienvenue, {{name}}',
      lastUpdatedAt: 'Dernière mise à jour',
      overviewTitle: 'Aperçu',
      findingsTitle: 'Résultats',
      trainingTitle: 'Formation',
      updateEmployees: 'Mettre à jour les employés',
      downloadReport: 'Télécharger le rapport',
      toast: {
        downloadSuccess: 'Rapport téléchargé avec succès',
        downloadError: 'Échec du téléchargement du rapport',
      },
      users: 'Utilisateurs',
      password: 'Mot de passe',
      address: 'Adresse',
      emailAddress: 'Adresse e-mail',
      phone: 'Téléphone',
      image: 'Image',
      adminOnboardingMessage:
        'Terminez votre intégration et lancez votre deep scan pour voir le tableau de bord personnalisé de la cybersanté',
      youreViewingCompanyDashboard: "Vous consultez le tableau de bord de l'entreprise !",
      buildProfile: 'Créer mon profil Defender',
      instructionNewAdminSwitchAccounts:
        "Cliquez sur l'icône de profil dans la barre de navigation supérieure pour basculer entre le tableau de bord de l'entreprise et votre compte personnel.",
      importantAreasDescription:
        'Réparer ces problèmes pourrait avoir un impact majeur sur votre sécurité en ligne.',
      areasOfStrengthDescription:
        'Ces éléments contribuent à la sécurité de vos comptes. Continuez ainsi, vous faites du bon travail.',
      criticalAreasDescription: 'Ces éléments pourraient vous exposer à une attaque cybernétique.',
      dashboard: 'Tableau de bord',
      companyDashboard: 'Tableau de bord de l’entreprise',
      personalReport: 'Rapport personnel',
      checkAgain:
        'Nous attendons encore certaines données avant de pouvoir générer une cote précise. Veuillez réessayer plus tard.',
      pendingData: 'En attente de données',
      workingOn: `These are the information items we're still working on`,
      workingProvide:
        'Nous travaillons sur vos données afin de vous offrir les renseignements les plus exacts, veuillez réessayer plus tard.',
      pendingItems: 'Éléments en attente',
      identifyPotential: `We couldn't identify all potential threats at the moment. Please rescan for accurate information and final score.`,
      scanAgain: 'Faire une nouvelle analyse',
      protexxaScore: 'Cote Protexxa',
      scoreTooltip:
        'Vous pouvez améliorer votre score en mettant en œuvre les actions recommandées!',
      outOf100: 'sur 1 000',
      scanInProgress: 'Analyse en cours...',
      scanningNotification:
        'Voici votre score initial. Nous lançons une analyse plus approfondie ; attendez-vous à voir une mise à jour bientôt.',
      lastScan: 'Dernière analyse',
      nextScan: 'Prochaine analyse',
      remainingScans: 'Aucune analyse restante.',
      repetPurchase: 'Achat répété',
      poor: 'Insuffisant',
      good: 'Bon',
      veryGood: 'Très bon',
      excellent: 'Excellent',
      scoreMeans: 'Que signifie votre cote?',
      poorDescription:
        "0 - 399: Vous avez une mauvaise hygiène cybernétique et vous êtes dans la catégorie de risque la plus élevée en termes de compromission. Une attention immédiate pour réduire votre surface d'attaque est nécessaire. Vous pouvez le faire !",
      goodDesctipion:
        "400 - 599: Vous avez une chance raisonnable d'être impacté par une attaque cybernétique. Une attention supplémentaire sur votre hygiène cybernétique est requise. Quelques petits changements auront un impact majeur pour vous !",
      veryGoodDesctipion:
        '600 - 799: Vous avez de très bonnes habitudes en ligne et êtes moins susceptible de tomber victime de menaces cybernétiques. Pensez à améliorer votre hygiène cybernétique. Vous êtes sur la bonne voie, continuez ainsi !',
      excellentDesctipion:
        "800 - 1000: Vous avez une excellente hygiène cybernétique ou un rayon d'exposition limité. Nous vous encourageons à maintenir votre attention et votre diligence, continuez le bon travail !",
      backtoDashboard: 'Retour au tableau de bord',
      passwordLeaked: 'Mot de passe potentiellement divulgué',
      changingPassword: 'Rencontrez-vous des difficultés pour changer votre mot de passe ?',
      learnHow: 'Apprenez comment',
      category: 'Catégorie',
      whatMean: 'Que signifie cela ?',
      warnDescription:
        "Une attention supplémentaire à votre hygiène numérique est nécessaire, car votre entreprise risque d'être impactée par une cyberattaque.",
      scoreUpdateInfo: 'Votre score sera mis à jour à la fin de chaque analyse programmée.',
      threats: 'Menaces',
      yourAttention:
        "Votre attention est requise pour veiller à ce que vos informations personnelles restent privées car une activité inhabituelle a été découverte lors de l'examen de votre domaine web.",
      highSensitive:
        "Il y a une forte probabilité que des informations sensibles ou personnelles concernant l'enregistrement de votre domaine aient été divulguées.",
      recommendedAction: 'Action recommandée',
      checkRegistration:
        "Vérifiez ce qui est publiquement disponible concernant l'enregistrement de votre domaine ou si votre domaine a été compromis de quelque manière que ce soit. Vous devrez peut-être contacter votre fournisseur.",
      leakedInformation: 'Informations divulguées',
      haventFixed: "Vous n'avez encore corrigé aucun problème.",
      noLonger: "Vous n'avez plus de fuites de mot de passe récemment détectées.",
      achangePassword:
        'Changez votre mot de passe et faites-nous savoir que vous avez pris des mesures pour sécuriser vos comptes en ligne.',
      scoreUpdate: 'Quand vous mettez à jour vos informations, elles seront évaluées',
      followingMonthlyScan: 'lors de votre prochaine évaluation mensuelle de la cybersécurité.',
      reviewListLeaks:
        'Si vous souhaitez consulter la liste des fuites, cliquez sur le bouton ci-dessous.',
      fixLeaks: 'Voir les fuites corrigées',
      dateLeak: 'Date de la fuite',
      details: 'Détails',
      yes: 'Oui',
      no: 'Non',
      changeMyPassword: 'changer mon mot de passe',
      showing: 'Affichage',
      detectedLeaks: 'Fuites détectées',
      fixedLeaks: 'Fuites corrigées',
      redefinePassword: 'Redéfinir votre mot de passe',
      howRedefinePassword:
        "La plupart des applications et des sites web suivent un cheminement similaire pour la redéfinition du mot de passe, nous avons donc compilé une liste d'indications pour vous aider à trouver cette option dans tous vos comptes.",
      learMore: 'En savoir plus',
      listSites:
        "Si vous utilisez l'une des applications ou des sites web répertoriés, vous pouvez également cliquer pour afficher des tutoriels spécifiques.",
      redefineLinkedin: 'Redéfinition du mot de passe sur Linkedin',
      redefineFacebook: 'Redéfinition du mot de passe sur Facebook',
      redefineMyFitnessPal: 'Redéfinition du mot de passe sur MyFitnessPal',
      redefineCanva: 'Redéfinition du mot de passe sur Canva',
      yourPersonalImageWasFound: 'Votre image personnelle a été trouvée sur',
      yourNameWasFound: 'Votre nom a été exposé dans',
      yourPhoneWasFound: 'Votre numéro de téléphone a été exposé dans',
      yourAddressWasLeaked: 'Votre adresse a été exposé dans',
      yourEmailHaveBeenCompromised_0: 'Nous avons identifié',
      yourEmailHaveBeenCompromised: 'des menaces dans vos comptes de messagerie confirmés.',
      yourWebDomainsHaveBeenCompromised_0: 'Nous avons identifié',
      yourWebDomainsHaveBeenCompromised: 'des menaces dans vos domaines web.',
      websites: 'sites web',
      leaksFound: 'des fuites potentielles de mots de passe ont été trouvées pour ce compte email.',
      leak: 'Fuite',
      leakSmall: 'fuite',
      leaksSmall: 'fuites',
      notShowing: 'Ne pas montrer',
      fiveYearsAgo: "d'il y a plus de 5 ans.",
      showLeaks: 'Afficher les fuites',
      hideLeaks: 'Masquer les fuites',
      company: 'Entreprise',
      personal: 'Personnel',
      leakWarning:
        'Cette liste peut changer avec le temps alors que nous continuons à rechercher vos informations en ligne.',
      employees: 'Employés',
      low: 'Faible',
      medium: 'Moyen',
      moderate: 'Modéré',
      high: 'Élevé',
      critical: 'Critique',
      name: 'Nom',
      email: 'Adresse e-mail',
      credential: 'Mot de passe',
      additionalInformationAboutThreatLevels:
        'Répartition des utilisateurs en fonction de la gravité des problèmes détectés lors des analyses.',
      companyScanSummary: {
        title: "Résumé des analyses de l'entreprise",
      },
      dates: {
        yesterday: 'Hier',
        justNow: "À l'instant",
      },
      employeeDeepScanSummary: {
        title: 'Résumé des analyses approfondies',
        inviteForDeepScan: {
          title:
            "Débloquez plus d'informations avec les données d'analyse approfondie des utilisateurs",
          description:
            'Grâce aux analyses approfondies de vos utilisateurs, vous pouvez identifier les vulnérabilités et évaluer leur conformité en cybersécurité.',
          buttons: {
            inviteForDeepScan: "Inviter les utilisateurs à l'analyse approfondie",
            notifyUsers: 'Notifier les utilisateurs',
          },
        },
        conciergeCTA: {
          title: "Débloquez plus d'informations avec les données d'analyse approfondie",
          description:
            'Grâce aux données agrégées des analyses approfondies de vos utilisateurs, vous pouvez identifier les vulnérabilités et évaluer leur conformité en cybersécurité.',
          button: 'Activer le module Deep Scan',
          prefillDescription:
            'Je souhaite en savoir plus sur le module Deep Scan pour mon entreprise.',
        },
        scanSummary: {
          title: 'Résumé',
          description: 'Résumé des analyses approfondies des utilisateurs',
          cards: {
            registeredUsers: 'Utilisateurs enregistrés',
            scannedUsers: 'Utilisateurs actifs',
            usersWithExposures: 'Utilisateurs compromis',
            invitedUsers: 'Utilisateurs invités',
          },
        },
      },
      highRiskDepartment: {
        departments: 'Départements',
        users: 'Utilisateurs',
        usersTooltip:
          "Nombre d'utilisateurs avec le niveau de risque le plus élevé du département.",
        riskLevels: 'Niveaux de risque',
        onGoing: {
          title: 'Niveau de risque par départements',
          top5Departments: 'Départements avec les risques les plus élevés',
          scanIsCurrentlyInProgress: "L'analyse est en cours.",
          yourScanResultsWillBeDisplayed:
            "Les résultats de votre analyse s'afficheront ici une fois l'analyse terminée.",
        },
        noData: {
          thereIsNoDataForDepartments: "Il n'y a pas de données pour les départements",
          updateYourEmployeeData:
            'Mettez à jour les données de vos employés avec leurs départements pour déverrouiller des informations sur ce graphique',
          updateEmployeeDataButton: 'Mettre à jour les données des employés',
        },
      },
      threatLevelByUsers: {
        title: 'Niveau de risque par utilisateur',
        subtitle: 'Répartition des utilisateurs par niveau de risque de sécurité',
        helpTooltip:
          'Répartition des utilisateurs selon la gravité des problèmes détectés lors des analyses.',
        viewAll: 'Voir tout',
        scanInProgress: {
          title: "L'analyse est en cours.",
          description:
            "Les résultats de votre analyse s'afficheront ici une fois l'analyse terminée.",
        },
        activeUsers: 'Utilisateurs actifs avec des résultats',
      },
      vulnerabilities: {
        onGoing: {
          title: 'Vulnérabilités',
          dashTitle: 'Résultats',
          dashSubtitle: "Problèmes identifiés lors de l'analyse de l'entreprise",
          topPotencialLeaksOrBreanches: 'Principales fuites ou brèches potentielles',
          viewAll: 'Voir tout',
          helpTooltip: 'Problèmes détectés dans les domaines de votre entreprise',
          detectedAcrossCompanyDomains: 'Détectés dans les domaines de votre entreprise',
          credentialLeaks: "Fuites d'identifiants",
          namesExposed: 'Noms exposés',
          emailsExposed: 'Emails exposés',
          issuesFound: 'problèmes trouvés',
        },
      },
    },
    dashboardStrengthArea: {
      title: 'Domaines de force',
      description: 'Ces éléments contribuent à votre sécurité et celui de votre entreprise.',
      noStrengthAreas: 'Aucun domaine de force',
      areasIdentified: 'domaines identifiés',
      whyIsThisImportant: 'Pourquoi est-ce important ?',
    },
    emailLeaks: {
      unverifiedEmail: {
        title: 'Vérifiez votre email pour voir plus de détails',
        description1: 'Nous avons envoyé un email à ',
        description2:
          '. Il vous suffit de cliquer sur le bouton dans cet email pour finaliser votre inscription. Si vous ne le voyez pas, vous devrez peut-être vérifier votre dossier de courrier indésirable.',
        resendEmail: {
          buttonText: "Renvoyer l'email",
          success: 'Email renvoyé avec succès !',
          error:
            "Impossible de renvoyer l'email de vérification. Veuillez réessayer ultérieurement.",
        },
      },
    },
    marketplace: {
      marketplace: 'Marché aux outils',
      backtoDashboard: 'Retour au Tableau de bord',
      internetSecuritySolutions: 'Solutions de sécurité Internet',
      passwordManager: 'Gestionnaire de mots de passe',
      passwordManagerDescription:
        'Le gestionnaire de mots de passe NordPass génère des mots de passe uniques et les mémorise pour vous. Vous pouvez accéder à vos mots de passe en tout temps sur n’importe quel appareil ou navigateur.',
      passwordAction: 'Acheter',
      encryptedCloud: 'Nuage crypté',
      encryptedCloudDescription:
        'NordLocker est un nuage sécurisé et facile à utiliser pour vos fichiers, vos idées et vos souvenirs. Protégées par cryptage en tout temps, vos données sont toujours à portée de main.',
      encryptedCloudAction: 'Acheter',
      vpn: 'VPN',
      vpnDescription:
        'Réputé pour ses valeurs solides, ses fonctionnalités simplifiées et son excellent soutien client, NordVPN est apprécié des sites technologiques influents comme des experts en sécurité informatique.',
      vpnAction: 'Acheter',
      cybersecurity: 'Plan d’intervention en matière de cybersécurité',
      cybersecurityDescription:
        'Pour pouvoir réagir rapidement en cas d’attaque, il est essentiel de se préparer. Le fait d’avoir une base bien structurée pour lancer votre plan d’intervention permet de minimiser les dommages causés à l’entité attaquée.',
      cybersecurityAction: 'Télécharger le modèle',
      cyberinsurance: 'Assurance de cybersécurité',
      cyberinsuranceDescription:
        "Obtenez une couverture d'assurance cybercomplète pour vos proches afin d'être protégé contre le vol d'identité, les cyberattaques et le cyberharcèlement.",
      cyberinsuranceAction: 'Acheter',
      backgroundCheck: 'Vérification des antécédents',
      backgroundCheckDescription:
        'Les vérifications des antécédents sont essentielles pour la sécurité, la confiance, la conformité légale et la prise de décision éclairée dans les interactions personnelles, professionnelles et financières.',
      backgroundCheckAction: 'Acheter',
      mfa: 'MFA Authenticator',
      mfaDescription:
        "NordPass en tant que fonction d'authentification permet à NordPass d'être utilisé comme un authentificateur pour les sites web et les applications qui prennent en charge l'authentification multi-facteur (MFA)",
      mfaAction: 'Acheter',
    },
    message: {
      welcomeToProtexxa: 'Bienvenue dans la communauté Protexxa',
      profile:
        'Voyons si vous avez été victime de cyberincidents ou si vous avez des vulnérabilités cachées, mais avant tout, créons votre profil :',
      buildProfile: 'Créer mon profil',
      paymentFailed: 'Échec du paiement',
      checkPayment:
        'Nous sommes désolés, mais votre paiement pour ce produit n’a pas fonctionné. Veuillez vérifier vos renseignements de paiement et réessayer ou appeler notre service client pour obtenir de l’aide.',
      contactSupport: 'Appeler le service client',
      tryAgain: 'Réessayer',
      getStarted: 'Lancez-vous! Terminez votre achat.',
      completePayment: `We're excited to have you on board! To get started and begin assessing your online security, simply complete your purchase by clicking the button below.`,
      toCheckout: 'Passer à la caisse',
      AlmostThere: 'Vous y êtes presque!',
      processPayment:
        'Votre paiement est en cours de traitement et nous préparons votre solution. Veuillez patienter un instant pendant que nous traitons votre commande. Merci de nous avoir choisis.',
      verifyYourEmail: {
        title: 'Veuillez vérifier votre email',
        message1: 'Vous y êtes presque ! Nous avons envoyé un email à ',
        message2:
          'Il vous suffit de cliquer sur le bouton dans cet email pour finaliser votre inscription. Si vous ne le voyez pas, vérifiez peut-être votre dossier de courrier indésirable.',
        resendEmailButton: "Renvoyer l'email",
        resendEmail: {
          success: 'Email renvoyé avec succès !',
          error:
            "Impossible de renvoyer l'email de vérification. Veuillez réessayer ultérieurement.",
        },
      },
      verifyingEmail: {
        success: "Vérification de l'email réussie !",
        forbidden: "L'email que vous avez essayé de vérifier n'est pas associé à ce compte.",
        genericError:
          "Une erreur s'est produite lors de la vérification de votre email. Veuillez réessayer ultérieurement.",
      },
      invalidEmailVerificationLink: {
        title: 'Lien de vérification invalide',
        message:
          "Le lien de vérification peut être incorrect, expiré, ou votre compte email est déjà vérifié. S'il n'est toujours pas vérifié, veuillez cliquer ci-dessous pour obtenir un nouveau lien de vérification ou contacter le support.",
        contactSupport: 'Contacter le support',
        resendEmailButton: 'Renvoyer la vérification',
        resendEmail: {
          success: 'Email renvoyé avec succès !',
          error:
            "Impossible de renvoyer l'email de vérification. Veuillez réessayer ultérieurement.",
        },
      },
    },
    subscription: {
      availableScans: 'Analyses disponibles',
      oneMonth: '1 analyse par mois',
      creditsAccumulate:
        'est incluse dans votre abonnement actuel. Achetez plus d’analyses en tout temps et accumulez des crédits.',
      scansRemaining: 'analyse(s) restante(s)',
      nextScan: 'Prochaine analyse',
      anotherPurchase: 'Faites une analyse en effectuant un autre achat.',
      repetPurchase: 'Achat répété',
      currentPlan: 'Votre abonnement actuel',
      defenderCommunity: 'Communauté Protexxa Defender',
      defenderCommunityValue: '49,99',
      updatePayment: 'Mettre à jour les données de paiement',
      billingHistory: 'Historique de facturation',
      date: 'Date',
      amount: 'Montant',
      details: 'Détails',
      status: 'État / Province',
      oneTime: 'Protexxa Defender, analyse ponctuelle',
      invoice: 'Détails de la facture',
    },
    profile: {
      profile: 'Profil',
      profilePhoto: 'Photo de profil',
      change: 'Modifier',
      uploadPhoto: 'Téléchargez votre photo ici',
      personalInformation: 'Renseignements personnels',
      gender: 'Genre',
      male: 'Homme',
      female: 'Femme',
      other: 'Autre',
      undefined: 'Plutôt ne pas dire',
      fullName: 'Nom complet',
      primary: 'Principale',
      namePreferred: 'Nom de préférence ou officiel',
      address: 'Adresse',
      country: 'Pays',
      street: 'Rue',
      number: 'Numéro',
      city: 'Ville',
      zip: 'Code postal',
      state: 'État / Province',
    },
    footer: {
      message: 'Protéger les entreprises comme les personnes.',
    },
    score: {
      gotoDashboard: 'Accéder au tableau de bord',
      firstScan: 'Lancer votre première analyse',
      collectData: 'Collectez vos données',
      noScoreMessage: 'Aucune cote à afficher pour le moment',
      scoreMessageF:
        'Votre entreprise a une hygiène informatique insuffisante, et vous êtes dans la catégorie de risque de compromissions la plus élevée. Des mesures immédiates sont nécessaires pour réduire la surface vulnérable aux attaques. ',
      scoreMessageE:
        'Il existe une possibilité raisonnable que votre entreprise soit touchée par une cyberattaque. Il faut mettre davantage l’accent sur l’hygiène informatique. Quelques petits changements pourront améliorer grandement les choses pour votre entreprise.',
      scoreMessageD:
        'Votre entreprise a de très bonnes habitudes en ligne et est peu susceptible d’être victime de cybermenaces. Envisagez de mettre à niveau votre formation en cybersécurité pour renforcer la protection de l’entreprise.',
      scoreMessageC:
        'Votre entreprise a de très bonnes habitudes en ligne et est peu susceptible d’être victime de cybermenaces. Envisagez de mettre à niveau votre formation en cybersécurité pour renforcer la protection de l’entreprise.',
      scoreMessageB:
        'Votre entreprise dispose d’une excellente hygiène informatique ou d’une exposition limitée aux risques. Nous vous encourageons à poursuivre vos efforts et à rester prudents. Gardez toujours la cybersécurité à l’esprit dans le cours de vos activités.',
      scoreMessageA:
        'Votre entreprise dispose d’une excellente hygiène informatique ou d’une exposition limitée aux risques. Nous vous encourageons à poursuivre vos efforts et à rester prudents. Gardez toujours la cybersécurité à l’esprit dans le cadre de vos activités.',
    },
    form: {
      informationImportant: 'Pourquoi cette information est-elle importante?',
      webDomains: 'Domaines Internet',
      noDomain: 'Je ne possède pas de domaine Internet',
      noAvatar: 'Pas pour le moment; je téléchargerai une photo de profil plus tard.',
      photoScore:
        'Remarque : nous ne serons pas en mesure d’analyser vos images lors de cette évaluation initiale, ce qui pourrait avoir une incidence sur votre cote de cybersécurité.',
      profilePicture: 'Photo de profil',
      camera: 'Appareil photo',
      gallery: 'Galerie',
      uploadPicture: 'Téléverser une image',
      takePhoto: 'Prendre une photo',
      takePicture: ' Prendre une photo',
      tips: 'Conseils',
      photoBlurry: 'Assurez-vous que votre photo est nette',
      goodLighting: 'Utilisez un bon éclairage et enlevez vos lunettes',
      removeSelection: 'Supprimer la sélection',
      selectAll: 'Sélectionner tout',
      noSocialMedia: `Je n'ai pas de compte de réseaux sociaux.`,
      phoneNumber: 'Numéro de téléphone',
      name: 'Nom',
      lastName: 'Nom de famille',
      gender: 'Genre',
      primaryEmail: 'Adresse de courrier électronique principale',
      primaryName: 'Nom principal',
      additionalEmail:
        ' Ajouter d’autres adresses de courrier électronique ou passer à l’étape suivante',
      additionalEmailNew: "Ajoutez jusqu'à 4 adresses e-mail secondaires",
      dateBirth: 'Date de naissance',
      month: 'Mois',
      alternateName: "Ajoutez jusqu'à 4 noms, préférés ou formels",
      address: 'Adresse',
      country: 'Pays',
      street: 'Rue',
      number: 'Numéro',
      city: 'Ville',
      zip: 'Code postal',
      state: 'État / Province',
      otherName: 'Êtes-vous connu sous un autre nom?',
      otherNameDescription: `Étant donné la gamme de possibilités, il est préférable pour nous de vous identifier avec une plus grande précision si nous connaissons un alias, un surnom ou un nom alternatif que vous auriez pu utiliser.`,
      dateOfBirth: 'Quelle est votre date de naissance?',
      dateOfBirthDescription:
        'Cette information nous permet de vous identifier avec plus de précision et vous aide à comprendre le rôle que jouent les caractéristiques démographiques dans la cybercriminalité.',
      whatAddress: 'Quelle est votre adresse?',
      whatAddressDescription:
        'Cela permet de déterminer si votre adresse a été compromise ou exposée de manière inappropriée.',
      genderWhat: 'Quel est votre genre?',
      genderDescription:
        'Cette information aide à déterminer le rôle du genre dans la cybercriminalité.',
      secondaryEmail: 'Avez-vous d’autres comptes de courriel?',
      secondaryEmailDescription:
        'Plus vous vérifiez d’adresses de courrier électronique, plus vous disposerez d’information sur votre sécurité en ligne.',
      secondaryEmailNew: "Si vous avez plus d'un e-mail, ajoutez-le ci-dessous",
      dontSecondaryEmail: "Je n'ai pas d'autres comptes e-mail",
      domain: 'Quels domaines Internet possédez-vous actuellement?',
      domainDescription:
        'Cette information nous aide à déterminer si vos sites Web sont compromis ou exploités par des cybercriminels.',
      picture: 'Prenez une photo de vous ou téléversez une photo',
      pictureDescription:
        'Cette image nous aide à vérifier si votre identité a été usurpée ou si votre image est utilisée sans votre permission.',
      Auth: 'Utilisez-vous l’authentification multi-facteurs pour tous vos comptes ?',
      authNew: "Est-ce que vous avez en place l'un des éléments suivants ?",
      AuthDescription: `L’authentification multi-facteurs est une couche de sécurité supplémentaire qui permet de s’assurer que les personnes qui tentent d’accéder à un compte en ligne sont bien qui elles prétendent être. Tout d’abord, l’utilisateur saisit son nom d’utilisateur et son mot de passe. Ensuite, au lieu d'avoir immédiatement accès au compte, ils doivent fournir un autre élément d'information.`,
      BooleanFormDesc:
        'Cela aide à déterminer si vous améliorez votre protection en ligne et votre sécurité, et si vous pouvez répondre rapidement et efficacement à une intrusion ou une violation cybernétique.',
      responsePlan:
        'Disposez-vous d’un plan personnel d’intervention en cas d’incident de cybersécurité?',
      responsePlanDescription:
        'Cette information nous aide à déterminer si vous pouvez réagir rapidement et efficacement en cas de cyberattaque ou d’atteinte à la cybersécurité.',
      BooleanFormResponsePlan: "Plan d'intervention en cas d'incident",
      BooleanFormCyberInsurance: 'Assurance cybersécurité',
      BooleanFormPasswordManager: 'Gestionnaire de mots de passe',
      BooleanFormMFA: 'Authentification multi-facteurs (comme MFA)',
      topApps:
        'Ces 10 applications sont celles qui collectent le plus de données sur les gens. Sélectionnez toutes celles que vous utilisez.',
      topAppsDescription:
        'Cette information nous permet de déterminer la probabilité et le degré de risque de compromission en fonction du nombre et du type de comptes que vous utilisez.',
      according: 'Selon Clario, 2021',
      password: 'Utilisez-vous un gestionnaire de mots de passe?',
      passwordDescription:
        'Cette information nous aide à déterminer si vous employez les meilleures pratiques pour stocker vos mots de passe dans une chambre forte numérique qui offre une protection solide contre les cybercriminels.',
      insurance: 'Avez-vous une assurance cybersécurité?',
      insuranceDescription:
        'Cette information nous aide à déterminer si vos comptes sont protégés contre les cyberattaques et prêts à gérer les risques financiers liés aux activités commerciales en ligne.',
      dontName: "Je n'utilise aucun autre nom.",
      TwoFactorAuth: 'Authentification à deux facteur',
      cybersecurityPlan: `Plan de réponse à la cybersécurité`,
      passwordManager: 'Gestionnaire de mots de passe',
      cybersecurityInsurance: 'Assurance cybersécurité',
      validation: {
        email: "L'adresse e-mail est requise",
        requiredField: 'Ce champ est obligatoire.',
        name: 'Le nom est requis',
        relationship: 'La relation est requise',
        dateBirth: 'La date de naissance valide est requise',
        address: {
          specialChar: 'Veuillez supprimer les caractères spéciaux',
          city: 'La ville est requise',
          country: 'Le pays est requis',
          zip: 'Le code postal est requis',
          number: 'Le numéro est requis',
          street: 'La rue est requise',
          state: "L'État/Province est requis.",
        },
        gender: 'Le genre est requis',
        domain: 'Les domaines Web sont requis',
        year: "L'année est requise",
        month: 'Le mois est requis',
        day: 'Le jour est requis',
      },
      oldStepsValidation: {
        alternativeNames: {
          required: 'Le nom est requis',
        },
        birthDate: {
          required: 'La date de naissance valide est requise',
        },
        address: {
          street: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La rue est requise',
          },
          number: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le numéro est requis',
          },
          postalCode: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'Le code postal est requis',
          },
          city: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: 'La ville est requise',
          },
          country: {
            required: 'Le pays est requis',
          },
          state: {
            pattern: 'Veuillez supprimer les caractères spéciaux',
            required: "L'État/Province est requis",
          },
        },
        gender: {
          required: 'Le genre est requis',
        },
        secondaryEmails: {
          required: "L'e-mail est requis",
        },
        webDomains: {
          required: 'Les domaines Web sont requis',
        },
        useMFA: {
          required: 'La réponse est requise',
        },
        haveResponsePlan: {
          required: 'La réponse est requise',
        },
        havePasswordManager: {
          required: 'La réponse est requise',
        },
        haveCyberSecurityInsurance: {
          required: 'La réponse est requise',
        },
      },
    },
    userThreats: {
      filter: {
        title: 'Montrant:',
        content: {
          all: 'Tous',
          reported: 'Problèmes signalés',
          completed: 'Demandes complétées',
          userReported: "Fuites signalées par l'utilisateur",
        },
      },
      severity: {
        leak: 'fuite',
        exposure: 'exposition',
      },
      userActionModal: {
        title: 'Action requise',
        description:
          "Presque arrivé ! Le site hôte vous a envoyé un e-mail avec des instructions pour supprimer votre photo non autorisée. Si vous n'avez pas reçu l'e-mail ou si vous rencontrez des difficultés avec les étapes, contactez le support de Protexxa et nous serons là pour vous aider.",
        actions: {
          close: 'Fermer',
          support: 'Contacter le support',
        },
      },
      differenceModal: {
        title: 'La différence entre Fuite et Exposition.',
        firstParagraph:
          'Ces icônes ci-dessous sont utilisées pour représenter "fuite de données" et "exposition de données". Il est important de distinguer ces deux concepts qui sont similaires mais qui présentent une différence subtile dans leurs connotations:',
        listItems: {
          leak: {
            title: 'Données divulguées: ',
            description:
              'Cela implique généralement que les données ont été divulguées ou rendues accessibles à des tiers non autorisés sans le consentement du propriétaire des données.',
          },
          exposure: {
            title: 'Données exposées: ',
            description:
              "Cela fait généralement référence à l'état dans lequel les données sont rendues visibles ou accessibles à d'autres, intentionnellement ou non, mais cela n'implique pas nécessairement que les données ont été consultées ou obtenues par des tiers non autorisés.",
          },
        },
        lastParagraph: `En essence, "données divulguées" implique souvent une violation ou une divulgation non autorisée, tandis que "données exposées" peut englober des situations où les données sont rendues visibles ou accessibles sans les mesures de sécurité nécessaires, que l'accès non autorisé ait lieu ou non.`,
      },
      whatCanIDoModal: {
        title: 'Que puis-je faire pour atténuer la situation et me protéger ?',
        firstParagraph:
          'Si vos données ont été divulguées, voici plusieurs étapes que vous pouvez entreprendre pour atténuer la situation et vous protéger :',
        listItems: {
          scope: {
            title: "Évaluer l'ampleur:",
            description:
              'Déterminez quelles données spécifiques ont été divulguées et quel impact potentiel cela pourrait avoir sur vous. Cela peut inclure des informations personnelles, des données financières ou toute autre information sensible.',
          },
          notify: {
            title: 'Informer les parties concernées:  ',
            description:
              "Si la fuite implique une entreprise ou une organisation, signalez immédiatement l'incident. Ils peuvent avoir des protocoles en place pour gérer les violations de données et peuvent prendre des mesures pour contenir la situation.",
          },
          passwords: {
            title: 'Changer les mots de passe: ',
            description:
              'Si des mots de passe ont été inclus dans les données divulguées ou si vous soupçonnez un accès non autorisé à vos comptes, changez immédiatement vos mots de passe. Utilisez des mots de passe forts et uniques pour chaque compte.',
          },
          financialAccounts: {
            title: 'Surveiller les comptes financiers: ',
            description:
              'Surveillez de près vos comptes bancaires, cartes de crédit et autres comptes financiers pour détecter toute activité suspecte. Signalez toute transaction non autorisée à votre institution financière.',
          },
          MFA: {
            title: "Activer l'authentification multi-facteurs: ",
            description:
              "Lorsque possible, activez l'authentification multi-facteurs sur vos comptes pour une sécurité supplémentaire.",
          },
          credit: {
            title: 'Envisagez la surveillance du crédit: ',
            description:
              'Si les données divulguées incluent des informations financières sensibles, envisagez de vous inscrire à un service de surveillance du crédit pour détecter toute activité inhabituelle sur votre rapport de crédit.',
          },
          informed: {
            title: 'Rester informé: ',
            description:
              "Suivez les mises à jour de l'organisation qui a subi la fuite de données pour obtenir des informations sur leurs efforts de réponse et les mesures que vous devriez prendre.",
          },
          cautious: {
            title: 'Soyez prudent face aux tentatives de phishing: ',
            description:
              "Soyez vigilant contre les e-mails ou les messages de phishing qui pourraient tenter d'exploiter la situation. Évitez de cliquer sur les liens ou de fournir des informations personnelles à moins d'être certain de la légitimité de l'expéditeur.",
          },
          advice: {
            title: 'Consulter un avocat: ',
            description:
              'Selon les circonstances et la gravité de la fuite de données, vous voudrez peut-être consulter un avocat pour comprendre vos droits et les recours éventuels.',
          },
          educate: {
            title: 'Éduquez-vous: ',
            description:
              "Profitez de cette opportunité pour en apprendre davantage sur les meilleures pratiques en matière de confidentialité et de sécurité des données afin de mieux vous protéger à l'avenir.",
          },
        },
        lastParagraph:
          "Souvenez-vous, agir rapidement et prendre des mesures proactives peut aider à minimiser l'impact d'une fuite de données sur vos informations personnelles et votre sécurité.",
      },
      userReports: {
        dateOfLeak: 'Trouvé sur',
        notProvided: 'Non Fourni',
        details: 'Détails',
        exposure: 'exposition',
        description: 'Your have reported these websites',
      },
      fullname: {
        description: "Les utilisateurs de l'entreprise ont leur nom exposé",
        recommendedAction:
          'Vérifiez si votre nom est divulgué en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
        strengthTitle: 'Nom',
        strengthAreaText: "Votre nom n'a pas été exposé sur aucun site",
        reasonToBeImportant:
          'Les criminels peuvent utiliser vos renseignements personnels pour ouvrir des comptes bancaires ou obtenir des cartes de crédit, des prestations et des documents officiels à votre nom.',
        title: 'Nom Exposé',
        details: {
          backToDashboard: 'Retour au tableau de bord',
          title: 'Nom Exposé',
          titleCompromised: 'Nom Exposé',
          subTitle1: 'Votre nom a été trouvé sur ',
          subTitle2P: ' sites Internet',
          subTitle2S: ' site web',
          card: {
            dateOfLeak: 'Trouvé sur',
            details: 'Détails',
            recommendedActionTitle: 'Mesures recommandées',
            recommendedAction:
              'Si votre nom figure sur ce site sans votre consentement, veuillez le signaler afin que nous puissions prendre des mesures pour le supprimer. Si vous êtes d’accord avec la diffusion de ces informations sur ce site, vous pouvez les ignorer.',
            newRecommendedAction: {
              exposure: {
                statusCard: {
                  unsuccessful: {
                    statusTag: 'Suppression infructueuse',
                    description: `Le nom ne peut pas être supprimé. Consultez les détails pour connaître les raisons courantes.`,
                    action: 'Détails',
                  },
                  solved: {
                    statusTag: 'Résolu',
                    description: `Le nom a été supprimé avec succès.`,
                  },
                },
              },
            },
            notProvided: 'Non Fourni',
          },
          translationAlert:
            'Moteur de traduction pour les détails de tiers lancé en décembre 2023.',
        },
      },
      address: {
        description: "Les utilisateurs de l'entreprise ont leur adresse exposée",
        recommendedAction:
          'Vérifiez si votre adresse est divulguée en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
        strengthTitle: 'Adresse',
        strengthAreaText: "Votre adresse n'a pas été exposée sur aucun site",
        reasonToBeImportant: `Les voleurs d'identité en ligne peuvent saisir votre nom et votre adresse dans une base de données consultable publiquement pour voir ce qu'ils peuvent trouver concernant votre situation financière.`,
        title: 'Adresse exposée',
        details: {
          backToDashboard: 'Retour au tableau de bord',
          title: 'Adresse Exposé',
          titleCompromised: 'Address Compromis',
          subTitle1: 'Votre adresse a été trouvée sur ',
          subTitle2P: ' sites Internet',
          subTitle2S: ' site web',
          card: {
            dateOfLeak: 'Trouvé sur',
            details: 'Détails',
            recommendedActionTitle: 'Mesures recommandées',
            recommendedAction:
              'Vérifiez si votre adresse est divulguée en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
            newRecommendedAction: {
              leakage: {
                description:
                  "Cette fuite de données provient d'une violation connue de la base de données, ce qui indique que vos informations personnelles peuvent être menacées. Veuillez lire ci-dessous les moyens de vous protéger ainsi que vos données en ligne.",
                whatCanIDo: 'Que puis-je faire ?',
              },
              exposure: {
                description:
                  'Si votre adresse figure sur ce site sans votre consentement, veuillez la signaler afin que nous puissions prendre des mesures pour la supprimer. Si vous êtes d’accord avec la diffusion de ces informations sur ce site, vous pouvez les ignorer.',
                actions: {
                  report: 'Signaler',
                  ignore: 'Ignorer',
                },
                statusCard: {
                  unsuccessful: {
                    statusTag: 'Suppression infructueuse',
                    description: `L'adresse ne peut pas être supprimé. Consultez les détails pour connaître les raisons courantes.`,
                    action: 'Détails',
                  },
                  solved: {
                    statusTag: 'Résolu',
                    description: `L'adresse a été supprimé avec succès.`,
                  },
                },
              },
            },
            notProvided: 'Non Fourni',
          },
          translationAlert:
            'Moteur de traduction pour les détails de tiers lancé en décembre 2023.',
        },
      },
      phoneNumber: {
        description: "Les utilisateurs de l'entreprise ont leur numéro de téléphone exposé",
        recommendedAction:
          'Vérifiez si votre numéro de téléphone est divulgué en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
        strengthTitle: 'Numéro de téléphone',
        strengthAreaText: "Votre numéro de téléphone n'a pas été exposé sur aucun site",
        reasonToBeImportant: `Une fois que quelqu'un a obtenu votre numéro de téléphone, il peut utiliser l’ingénierie sociale ou d'autres techniques pour trouver d’autres renseignements personnels à votre sujet.`,
        title: 'Numéro de Téléphone Exposé',
        details: {
          backToDashboard: 'Retour au tableau de bord',
          title: 'Numéro de Téléphone Exposé',
          titleCompromised: 'Numéro de Téléphone Compromis',
          subTitle1: 'Votre numéro de téléphone ',
          subTitle2: ' a été trouvé sur ',
          subTitle3P: ' sites Internet',
          subTitle3S: ' site web',
          card: {
            dateOfLeak: 'Trouvé sur',
            details: 'Détails',
            oldRecommendedAction:
              'Vérifiez si votre numéro de téléphone est divulgué en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
            recommendedActionTitle: 'Mesures recommandées',
            recommendedAction: {
              leakage: {
                description:
                  "Cette fuite de données provient d'une violation connue de la base de données, indiquant que vos informations personnelles peuvent être menacées. Veuillez lire ci-dessous les moyens de vous protéger ainsi que vos données en ligne.",
                whatCanIDo: 'Que puis-je faire ?',
              },
              exposure: {
                description:
                  'Si votre numéro de téléphone se trouve sur ce site sans votre consentement, veuillez le signaler afin que nous puissions prendre des mesures pour le supprimer. Si vous êtes d’accord avec la diffusion de ces informations sur ce site, vous pouvez les ignorer.',
                actions: {
                  report: 'Signaler',
                  ignore: 'Ignorer',
                },
                statusCard: {
                  received: {
                    statusTag: 'Requête reçue',
                    description: `Nous avons bien reçu votre demande et nous la traiterons sous peu.`,
                    action: 'Annuler',
                  },
                  inProgress: {
                    statusTag: 'En cours',
                    description: `Nous avons attribué votre rapport à notre équipe. Nous vous tiendrons informé(e) de l'état de votre demande dès qu'il y aura un changement.`,
                  },
                  unsuccessful: {
                    statusTag: 'Suppression infructueuse',
                    description: `Le numéro de téléphone ne peut pas être supprimé. Consultez les détails pour connaître les raisons courantes.`,
                    action: 'Détails',
                  },
                  solved: {
                    statusTag: 'Résolu',
                    description: `Le numéro de téléphone a été supprimé avec succès.`,
                  },
                  userAction: {
                    statusTag: 'Action Requise',
                    description: `Cliquez sur 'Détails' et nous vous enverrons par e-mail les prochaines étapes pour finaliser votre demande.`,
                    action: 'Détails',
                  },
                  waitingFeedback: {
                    statusTag: 'Action Requise',
                    description: `Cliquez sur 'Détails' et nous vous enverrons par e-mail les prochaines étapes pour finaliser votre demande.`,
                    action: 'Détails',
                  },
                },
              },
            },
            notProvided: 'Non Fourni',
          },
          translationAlert:
            'Moteur de traduction pour les détails de tiers lancé en décembre 2023.',
        },
      },
      email: {
        description:
          'utilisateurs de l’entreprise ont un potentiel de mot de passe qui a fait l’objet d’une fuite',
        recommendedAction:
          'Connectez-vous immédiatement aux comptes à risque et changez votre mot de passe.',
        strengthTitle: 'Mot de passe',
        strengthAreaText: 'Aucun de vos comptes de courriel confirmés n’a été compromis',
        reasonToBeImportant:
          'Les mots de passe constituent votre première ligne de défense contre les accès non autorisés à votre ordinateur et à vos renseignements personnels. Plus votre mot de passe est difficile à trouver, plus votre ordinateur sera protégé contre les pirates informatiques et les logiciels malveillants.',
        title: 'Mot de passe potentiellement divulgué dans une fuite',
      },
      webDomains: {
        description:
          'utilisateurs de l’entreprise ont un domaine Internet qui a fait l’objet d’une fuite',
        recommendedAction:
          'Vérifiez si vos domaines Internet ont été compromis. Vous pourriez devoir contacter votre fournisseur pour le récupérer.',
        strengthTitle: 'Domaines Internet',
        strengthAreaText: 'Aucun de vos domaines Internet n’a été compromis',
        reasonToBeImportant:
          'Si vos domaines Internet sont compromis, vous risquez d’être confronté à des attaques de dévoiement, ou détournement de domaine, qui consistent à rediriger le trafic de votre site Web vers un autre site afin de voler vos données confidentielles.',
        title: 'Domaines Internet compromis',
        leakedInformation: 'Informations Divulguées',
        exposedInformation: 'Informations exposées',
      },
      image: {
        description: 'utilisateurs de l’entreprise ont une photo d’eux utilisée en ligne',
        recommendedAction:
          'Vérifiez si votre photo est utilisée en ligne sans votre consentement. Vous pourriez avoir besoin de services de suppression ou de retrait.',
        strengthTitle: 'Image personnelle',
        strengthAreaText:
          'Votre image personnelle n’a été retrouvée sur aucun site sans votre consentement',
        reasonToBeImportant: `En plus d'être volées et utilisées par des étrangers, de nombreuses images, particulièrement celles prises avec des téléphones intelligents, comportent des marqueurs de localisation qui permettent aux gens de déterminer l'endroit exact où elles ont été prises.`,
        title: 'Image personnelle actuellement utilisée',
        component: {
          topMessageAlert:
            'Cette liste peut changer au fil du temps à mesure que nous continuons à rechercher votre image en ligne.',
          notImageFound:
            'Nous recherchons actuellement de nouvelles images de vous, veuillez les consulter plus tard',
          leftCard: {
            title: `Utilisation de l'image personnelle`,
            subTitle:
              'Nous avons trouvé les images suivantes en ligne en nous basant sur votre photo de profil.',
            lastScanDate: 'Dernière analyse',
            changePictureButton: `Changer d'image`,
            warningText:
              "Si vous mettez à jour votre photo de profil, nous vérifierons les images similaires lors de l'analyse mensuelle suivante.",
          },
          rightCard: {
            firstHalfTitle: 'Votre image personnelle a été trouvée sur',
            secondHalfTitle: 'sites web',
            showing: 'Affichage',
            select: {
              unattendedImages: 'Images non traitées',
              reportedImages: 'Images signalées',
              authorizedImages: 'Images autorisées',
            },
            card: {
              pending: 'Demande reçue',
              pendingMessage: 'Nous avons reçu votre demande et la traiterons sous peu.',
              failed: 'Retrait non réussi',
              failedMessage:
                "L'image ne peut pas être retirée. Voir les détails pour les raisons courantes pourquoi.",
              removed: 'Supprimé',
              removedMessage: "Cette image n'est plus disponible sur le site web.",
              waiting: 'En cours',
              waitingMessage:
                "Nous avons attribué votre signalement à notre équipe. Nous vous tiendrons informé de l'état de votre demande lorsqu'il y aura du nouveau.",
              report: 'Non, signaler',
              remove: 'Oui, marquer comme sûr',
              requestDenied: 'Demande refusée',
              requestDeniedMessage:
                "L'image ne peut pas être retirée. Voir les détails pour les raisons courantes pourquoi.",
              accepted: 'En cours',
              acceptedMessage:
                "Nous avons attribué votre signalement à notre équipe. Nous vous tiendrons informé de l'état de votre demande lorsqu'il y aura du nouveau.",
              userAction: 'Action requise',
              userActionMessage:
                "Cliquez sur 'Détails' et nous vous enverrons par e-mail les prochaines étapes pour compléter votre demande de retrait d'image.",
              waitingFeedback: 'En cours',
              waitingFeedbackMessage:
                "Nous avons attribué votre signalement à notre équipe. Nous vous tiendrons informé de l'état de votre demande lorsqu'il y aura du nouveau.",
              solved: 'Résolu',
              solvedMessage: 'Cette image a été retirée avec succès.',
              markAsSafe: 'Oui, Autorisée',
              youAuthorized: 'Cette page est-elle autorisée à utiliser votre image ?',
              thisNotYouMessage: `Vous n'êtes pas sur cette photo ?`,
              reportModal: {
                title: 'Quel est le problème avec cette image ?',
                firstOption:
                  "L'image est utilisée pour se faire passer pour moi ou représenter incorrectement mon identité.",
                secondOption: 'Mon image est utilisée à des fins non autorisées.',
                thirdOption: "L'image est diffamatoire ou nuit à ma réputation.",
                reportImageButton: `Signaler l'image`,
                successfullyReported: 'Signalé avec succès!',
              },
              isNoteMeModal: {
                message: `Confirmez que ce n'est pas votre image personnelle et nous supprimerons cette découverte de vos rapports. Cette action est irréversible.`,
                confirmAndRemoveButton: 'Confirmer et supprimer',
              },
              succesUpdate: 'Mise à jour réussie!',
              errorGetImages: "Une erreur s'est produite lors de l'obtention des images.",
              succesDeleted: 'Supprimé avec succès.',
            },
          },
          modal: {
            address: 'adresse',
            name: 'nom',
            phone: 'téléphone',
            image: 'image',
            na: 'Détails non fournis',
            failedTitle: "Malheureusement, nous n'avons pas pu supprimer votre ",
            close: 'Fermer',
            delete: 'Supprimer le rapport',
            contact: 'Contacter le support',
            ableToRemove: 'Avez-vous pu le supprimer vous-même ?',
            solves: 'Problème résolu, supprimer le rapport',
            removedTitle: 'Bonne nouvelle ! Votre image a été supprimée.',
            userActionTitle: "Action requise dans le processus d'image signalé",
            userActionBody: 'Veuillez vérifier votre e-mail pour de plus amples instructions.',
            deniedTitle: 'Pourquoi mon rapport a-t-il été refusé ?',
            deniedSubtitle:
              'Après une réflexion approfondie, notre décision est basée sur les explications suivantes :',
            details: 'Détails',
            checkTitle: {
              1: 'Consentement donné',
              2: 'Actualités et reportages',
              3: "Erreur de l'utilisateur ou mauvaise identification",
              4: 'Personnalités publiques ou célébrités',
              5: 'Litige de propriété',
            },
            checkDesc: {
              1: "Notre enquête suggère que l'image a peut-être été utilisée avec votre permission. Si vous vous en souvenez différemment, vous pouvez partager toute preuve que vous avez avec notre équipe de support.",
              2: "Dans certains cas, l'image a été utilisée à des fins légitimes dans des actualités ou des reportages. Si vous estimez que cette utilisation n'est pas appropriée, notre équipe de support peut approfondir l'enquête.",
              3: "Parfois, il peut y avoir des confusions. Vérifiez bien si les images signalées sont vraiment les vôtres. S'il y a une erreur, faites-le nous savoir.",
              4: "Le fait d'être bien connu peut influencer la manière dont vos images sont utilisées, en particulier dans les actualités ou les commentaires. Si cela vous inquiète, contactez notre équipe de support.",
              5: "Notre enquête a révélé des revendications contradictoires sur la propriété de l'image. Pour régler cela, nous avons besoin de plus de preuves. Si vous avez une preuve de propriété, veuillez la partager avec notre équipe de support.",
            },
          },
        },
        reviewImagesFoundButton: 'Examiner les images trouvées',
      },
      useMFA: {
        description: 'Vous n’utilisez pas l’authentification multi-facteurs',
        recommendedAction:
          'L’authentification multi-facteurs réduit immédiatement les risques de piratage de mot de passe. Connectez-vous à vos autres comptes personnels et bénéficiez d’une protection supplémentaire.',
        strengthTitle: 'Authentification multi-facteurs (AMF)',
        strengthAreaText: 'Vous utilisez déjà l’authentification multi-facteurs. Bravo!',
        reasonToBeImportant:
          'L’authentification multi-facteurs réduit immédiatement les risques de piratage de mot de passe. Si un mot de passe est piraté, deviné ou hameçonné, il n’est plus suffisant pour accéder à votre compte : sans la vérification du deuxième facteur, le mot de passe est inutile.',
        title: 'Authentification multi-facteurs (AMF)',
        tooltip: {
          part1:
            "L'authentification multifacteur (MFA) ajoute une sécurité supplémentaire en exigeant plusieurs étapes de vérification pour accéder à un compte ou à un système.",
          part2:
            'La MFA réduit les risques de compromission des mots de passe en exigeant une seconde étape de vérification, rendant un mot de passe seul inutile sans une approbation supplémentaire.',
        },
      },
      haveResponsePlan: {
        description: 'Vous n’avez pas de plan d’intervention en matière de cybersécurité!',
        recommendedActionOld:
          'Téléchargez notre modèle et créez votre propre plan d’intervention dès que possible.',
        recommendedAction:
          'Cliquez sur le bouton ci-dessous pour créer votre propre plan de réponse personnalisé et améliorer votre cybersécurité.',
        strengthTitle: 'Plan d’intervention en matière de cybersécurité',
        strengthAreaText:
          'Vous avez déjà un plan d’intervention en matière de cybersécurité! Bravo!',
        reasonToBeImportant:
          'Il est essentiel de se préparer aux attaques pour pouvoir les détecter et intervenir rapidement.',
        title: 'Plan d’intervention en matière de cybersécurité',
        buttonText: 'Créer mon plan de réponse en cybersécurité',
        buttonTextMobile: 'Créer Mon plan de réponse en cybersécurité',
        viewResponsePlanButton: 'Voir le plan de réponse',
        tooltip: {
          part1:
            'Un plan de réponse en cybersécurité est un guide pour gérer et récupérer rapidement des menaces ou attaques de sécurité.',
          part2:
            "Vous pouvez bénéficier d'une protection et d'un soutien supplémentaires en cas d'incident ou d'attaque cybernétique.",
        },
      },
      top10Apps: {
        description_zero: '',
        description_other: 'Vous utilisez {{count}} des 10 applications les plus invasives.',
        recommendedAction:
          'Supprimez les applications inutilisées et vérifiez régulièrement les autorisations des applications pour celles que vous utilisez encore afin de protéger vos informations.',
        strengthTitle: 'Applications indiscrètes',
        strengthAreaText: "You're not using any of the 10 most invasive apps",
        reasonToBeImportant:
          'On ne peut pas éviter complètement les applications dangereuses, mais vous devez vous méfier de celles qui contiennent beaucoup de publicités et qui nécessitent des autorisations invasives. Lisez toujours les autorisations et les politiques de confidentialité avant d’utiliser une application.',
        title: 'Applications indiscrètes',
        howTo: 'Comment modifier vos paramètres de confidentialité',
        tooltip: {
          part1:
            'Les applications intrusives collectent trop de données personnelles ou accèdent à votre appareil sans consentement approprié.',
          part2:
            "Vous ne pouvez pas complètement éviter les applications à risque, mais faites attention aux publicités excessives, aux permissions intrusives, et examinez d'abord les politiques.",
        },
      },
      allSocialMediasInPrivate: {
        description: "You don't have all your social accounts set to private",
        recommendedAction:
          'Ouvrez vos comptes de réseaux sociaux, allez dans les paramètres et mettez-les immédiatement en mode privé.',
        strengthTitle: 'Réseaux sociaux en mode privé',
        strengthAreaText: 'Tous vos comptes sociaux sont en mode privé',
        reasonToBeImportant:
          'La communication excessive d’information sur les réseaux sociaux peut mener au cyberharcèlement, à la divulgation de votre emplacement en temps réel, au profilage social, au hameçonnage, à l’usurpation d’identité, au chantage et à la divulgation de renseignements personnels de tiers.',
        title: 'Réseaux sociaux en mode privé',
      },
      havePasswordManager: {
        description: `Vous n'utilisez pas de gestionnaire de mots de passe pour protéger vos comptes`,
        recommendedAction:
          'Les gestionnaires de mots de passe assurent la sécurité de vos données en cryptant vos connexions pour qu’elles ne soient accessibles que lorsque vous entrez votre mot de passe principal.',
        strengthTitle: 'Gestionnaire de mots de passe',
        strengthAreaText:
          'Vous utilisez un gestionnaire de mots de passe pour protéger vos comptes',
        reasonToBeImportant:
          'Les gestionnaires de mots de passe assurent la sécurité de vos données en cryptant vos connexions pour qu’elles ne soient accessibles que lorsque vous entrez votre mot de passe principal.',
        title: 'Gestionnaire de mots de passe',
        tooltip: {
          part1:
            'Le gestionnaire de mots de passe stocke et gère vos mots de passe en toute sécurité, vous aidant à créer et accéder facilement à des mots de passe uniques.',
          part2:
            "En chiffrant vos identifiants pour qu'ils ne soient accessibles que lorsque vous entrez votre mot de passe maître, les gestionnaires de mots de passe protègent vos données.",
        },
      },
      haveCyberSecurityInsurance: {
        description: 'Vous n’avez pas d’assurance cybersécurité!',
        recommendedAction:
          'Rendez-vous sur notre page Marché aux outils et obtenez cette couche supplémentaire de protection le plus tôt possible.',
        strengthTitle: 'Assurance cybersécurité',
        strengthAreaText: 'Vous avez déjà une assurance cybersécurité! Bravo!',
        reasonToBeImportant:
          'Cette assurance vous aide à recouvrer les pertes financières découlant des incidents de cybersécurité.',
        title: 'Assurance cybersécurité',
      },
      emptyState: {
        phone: {
          all: "vous n'avez aucune fuite de téléphone à prévisualiser.",
          reported: "vous n'avez aucun rapport de téléphone à prévisualiser.",
          userReported: "vous n'avez aucun rapport de téléphone à prévisualiser.",
          completed: "vous n'avez aucune exposition de téléphone qui a été corrigée.",
        },
        name: {
          all: "vous n'avez aucune fuite de nom à prévisualiser.",
          reported: "vous n'avez aucun rapport de nom à prévisualiser.",
          userReported: "vous n'avez aucun rapport de nom à prévisualiser.",
          completed: "vous n'avez aucune exposition de nom qui a été corrigée.",
        },
        address: {
          all: "vous n'avez aucune fuite d'adresse à prévisualiser.",
          reported: "vous n'avez aucun rapport d'adresse à prévisualiser.",
          userReported: "vous n'avez aucun rapport d'adresse à prévisualiser.",
          completed: "vous n'avez aucune exposition d'adresse qui a été corrigée.",
        },
      },
    },
    companyThreats: {
      NAME: {
        title: 'Nom',
        chartLabel: 'Nom',
        strengthTitle: 'Nom',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel et vérifier si leur nom est utilisé en ligne sans leur consentement. Ils pourront avoir besoin de services de suppression ou de retrait.",
        description:
          'incidents ont été découverts dans les rapports d’utilisateurs de votre entreprise',
        strengthAreaText:
          'Aucun utilisateur de votre entreprise n’a vu son nom dévoilé dans une fuite',
        reasonToBeImportant:
          'Les criminels peuvent utiliser vos renseignements personnels pour ouvrir des comptes bancaires ou obtenir des cartes de crédit, des prestations et des documents officiels à votre nom. Ils peuvent ainsi faire des achats en se faisant passer pour vous et les débiter de votre compte bancaire.',
      },
      ADDRESS: {
        title: 'Adresse',
        chartLabel: 'Adresse',
        strengthTitle: 'Adresse',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel et vérifier si leur adresse est utilisée en ligne sans leur consentement. Ils pourront avoir besoin de services de suppression ou de retrait.",
        description:
          'incidents ont été découverts dans les rapports d’utilisateurs de votre entreprise',
        strengthAreaText:
          'Aucun des utilisateurs de votre entreprise n’a vu son adresse divulguée dans une fuite',
        reasonToBeImportant: `Savoir où votre adresse apparaît en ligne vous donne une couche supplémentaire de visibilité. Si quelqu'un a accès à votre adresse, il pourrait l'utiliser à des fins d'ingénierie sociale ou d'autres techniques pour compromettre votre sécurité.`,
      },
      PHONE: {
        title: 'Numéro de téléphone',
        chartLabel: 'Numéro de téléphone',
        strengthTitle: 'Numéros de téléphone',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel et vérifier si leur numéro de téléphone est utilisé en ligne sans leur consentement. Ils pourront avoir besoin de services de suppression ou de retrait.",
        description:
          'incidents ont été découverts dans les rapports d’utilisateurs de votre entreprise',
        reasonToBeImportant: `Une fois que quelqu'un a obtenu votre numéro de téléphone, il peut utiliser l’ingénierie sociale ou d'autres techniques pour trouver d’autres renseignements personnels à votre sujet.`,
        strengthAreaText:
          'Aucun des utilisateurs de votre entreprise n’a vu son numéro de téléphone divulgué dans une fuite',
      },
      EMAIL: {
        title: 'Mot de passe',
        chartLabel: 'Mot de passe',
        strengthTitle: 'Mots de passe',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel, se connecter à leurs comptes respectifs à risque et modifier immédiatement leur mot de passe.",
        description:
          'incidents ont été découverts dans les rapports d’utilisateurs de votre entreprise',
        reasonToBeImportant:
          'Les mots de passe constituent votre première ligne de défense contre les accès non autorisés à votre ordinateur et à vos renseignements personnels. Plus votre mot de passe est difficile à trouver, plus votre ordinateur sera protégé contre les pirates informatiques et les logiciels malveillants.',
        strengthAreaText:
          'Aucun utilisateur de votre entreprise n’a eu de compte de courriel piraté',
      },
      DOMAIN: {
        title: 'Site Web',
        chartLabel: 'Site Web',
        strengthTitle: 'Domaines Internet',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel et vérifier si leur domaine a été compromis. Il se peut qu’ils doivent contacter leur fournisseur.",
        description: 'utilisateurs de l’entreprise ont un domaine Internet compromis',
        reasonToBeImportant:
          'Si vos domaines Internet sont compromis, vous risquez d’être confronté à des attaques de dévoiement, ou détournement de domaine, qui consistent à rediriger le trafic de votre site Web vers un autre site afin de voler vos données confidentielles.',
        strengthAreaText:
          'Aucun des utilisateurs de votre entreprise n’a eu un domaine Internet compromis',
      },
      IMAGE: {
        title: 'Image personnelle utilisée',
        chartLabel: 'Image',
        strengthTitle: 'Image personnelle',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel et vérifier si leur image personnelle est utilisée en ligne sans leur consentement. Ils pourront avoir besoin de services de suppression ou de retrait.",
        descriptionOnline: "les utilisateurs de l'entreprise voient leur image utilisée en ligne.",
        descriptionRemoval:
          "les utilisateurs de l'entreprise ont signalé des images en cours de suppression.",
        reasonToBeImportant: `En plus d'être volées et utilisées par des étrangers, de nombreuses images, particulièrement celles prises avec des téléphones intelligents, comportent des marqueurs de localisation qui permettent aux gens de déterminer l'endroit exact où elles ont été prises.`,
        strengthAreaText:
          'Aucun utilisateur de votre entreprise n’a son image utilisée en ligne sans son consentement',
        modal: {
          potentialThreat: 'Menace Potentielle',
          potentialThreatText:
            'des utilisateurs de votre entreprise voient leur image utilisée en ligne.',
          remediationActions: 'Mesures Correctives',
          remediationActionsTextFirst: 'les utilisateurs ont signalé',
          remediationActionsTextSecond: 'images en cours de suppression.',
          card: {
            pending:
              "En attente d'approbation ou premier contact avec le site Web où l'image a été trouvée.",
            waiting: "En attente d'une réponse du site Web sur lequel l'image a été trouvée.",
          },
          recommendedAction: 'Action Recommandée:',
          recommendedActionText:
            "Alertez les utilisateurs qui n'ont signalé aucune utilisation non autorisée de leur image ou marqué des résultats comme sûrs pour qu'ils vérifient rapidement leurs rapports personnels et prennent les mesures nécessaires.",
        },
      },
      MFA: {
        title: 'Authentification multifacteur',
        chartLabel: 'AMF',
        strengthTitle: 'Authentification multi-facteurs',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel, se connecter à leurs comptes respectifs à risque et ajouter cette couche supplémentaire de protection.",
        description:
          'utilisateurs de l’entreprise n’utilisent pas l’authentification à deux facteurs',
        reasonToBeImportant:
          'L’authentification multi-facteurs réduit immédiatement les risques de piratage de mot de passe. Si un mot de passe est piraté, deviné ou hameçonné, il n’est plus suffisant pour accéder à votre compte : sans la vérification du deuxième facteur, le mot de passe est inutile.',
        strengthAreaText:
          'Tous les membres de votre entreprise utilisent l’authentification multi-facteurs',
      },
      CYBERSECURITY_PLAN: {
        title: 'Plan de réponse à la cybersécurité',
        chartLabel: 'Plan d’intervention',
        strengthTitle: 'Plan d’intervention en matière de cybersécurité',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel, télécharger notre modèle et créer leur plan d’intervention dès que possible.",
        description:
          'utilisateurs de l’entreprise n’ont pas de plan d’intervention en cybersécurité',
        reasonToBeImportant:
          'Il est essentiel de se préparer aux attaques pour pouvoir les détecter et intervenir rapidement. Le fait d’avoir une base bien structurée pour lancer votre plan d’intervention permet de minimiser les dommages causés à l’entité attaquée.',
        strengthAreaText:
          'Tous les utilisateurs de votre entreprise ont un plan d’intervention en cybersécurité',
        moda: {
          potentialThreat: 'Menace potentielle',
          strengthAreaText:
            'des utilisateurs de votre entreprise ne disposent pas d’un plan de réponse à la cybersécurité.',
          remediationActions: 'Actions correctives',
          remediationActionsDescription:
            'les utilisateurs ont commencé à exécuter ou terminé leurs actions de plan de réponse.',
          recommendedAction: 'Action recommandée',
          recommendedActionDescription: `Alertez ces utilisateurs pour qu'ils vérifient leur rapport personnel et créent leur propre plan de réponse dès que possible.`,
          complete: 'Completed',
          completeDescription:
            'Les utilisateurs ont pris toutes les mesures nécessaires pour mener à bien leur plan de réponse.',
          inProgress: 'En cours',
          inProgressDescription: 'Les utilisateurs exécutent actuellement un plan de réponse.',
          aborted: 'Avortée',
          abortedDescription: `L'utilisateur a commencé à exécuter un plan de réponse mais a décidé d'abandonner.`,
        },
      },
      TOP_APPS: {
        title: 'Applications indiscrètes',
        strengthTitle: 'Applications indiscrètes',
        chartLabel: 'Applications indiscrètes',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent consulter leur rapport personnel, supprimer les applications qu’ils n’utilisent pas souvent et vérifier leurs autorisations dans les autres applications.",
        description:
          'membres de l’entreprise utilisent des applications qui pourraient les mettre en danger',
        reasonToBeImportant:
          'On ne peut pas éviter complètement les applications dangereuses, mais vous devez vous méfier de celles qui contiennent beaucoup de publicités et qui nécessitent des autorisations invasives. Lisez toujours les autorisations et les politiques de confidentialité avant d’utiliser une application.',
        strengthAreaText:
          'Aucun membre de votre entreprise n’utilise d’application susceptible de les mettre en danger',
      },
      SOCIAL_MEDIA: {
        title: 'Réseaux sociaux en mode privé',
        chartLabel: 'Mode privé sur les réseaux sociaux',
        strengthTitle: 'Réseaux sociaux en mode privé',
        recommendedAction:
          "Informer votre communauté d'utilisateurs qu’ils doivent vérifier leur rapport personnel, aller dans les paramètres de leur compte de réseaux sociaux et les mettre en mode privé.",
        description:
          'utilisateurs de l’entreprise n’ont pas réglé tous leurs comptes en mode privé',
        reasonToBeImportant:
          'La communication excessive d’information sur les réseaux sociaux peut mener au cyberharcèlement, à la divulgation de votre emplacement en temps réel, au profilage social, au hameçonnage, à l’usurpation d’identité, au chantage et à la divulgation de renseignements personnels de tiers.',
        strengthAreaText:
          'Tous les utilisateurs de l’entreprise ont réglé tous leurs comptes sociaux en mode privé',
      },
      PASSWORD_MANAGER: {
        title: 'Gestionnaire de mots de passe',
        chartLabel: 'Gestionnaire de mots',
        strengthTitle: 'Gestionnaire de mots de passe',
        recommendedAction:
          'Alerter ces utilisateurs qu’ils doivent consulter leur rapport personnel et se procurer un gestionnaire de mots de passe à la page Marché aux outils pour protéger leurs mots de passe.',
        description:
          'utilisateurs de l’entreprise n’utilisent pas de gestionnaire de mots de passe',
        reasonToBeImportant:
          'Les gestionnaires de mots de passe assurent la sécurité de vos données en cryptant vos connexions pour qu’elles ne soient accessibles que lorsque vous entrez votre mot de passe principal.',
        strengthAreaText:
          'Tous les membres de votre entreprise utilisent un gestionnaire de mots de passe',
      },
      CYBERSECURITY_INSURANCE: {
        title: 'Assurance cybersécurité',
        chartLabel: 'Assurance cybersécurité',
        strengthTitle: 'Assurance cybersécurité',
        recommendedAction:
          'Alerter ces utilisateurs qu’ils doivent consulter leur rapport personnel et se procurer une assurance cybersécurité à la page Marché aux outils.',
        description: 'membres de votre entreprise n’ont pas d’assurance cybersécurité',
        reasonToBeImportant:
          'Vous pouvez obtenir une protection et un soutien supplémentaires en cas de cyberincident ou d’attaque.',
        strengthAreaText: 'Tous les membres de votre entreprise ont une assurance cybersécurité',
      },
    },
    top10apps: {
      facebookDescription:
        'En tant que réseau social, cette application a besoin que vous lui donniez accès à tous vos renseignements pour qu’elle puisse vous recommander des amis, informer les gens quand c’est votre anniversaire, proposer des groupes auxquels vous pouvez adhérer et, surtout, vous faire de la publicité.',
      tinderDescription:
        'En plus de vous aider à trouver un partenaire, Tinder surveille également votre utilisation des différentes plateformes de réseaux sociaux si vous reliez vos comptes.',
      instagramDescription:
        'Cette application appartenant à Facebook collecte 69,23 % de toutes les données disponibles, telles que vos loisirs, votre taille, votre poids et votre orientation sexuelle.',
      tikDescription:
        'TikTok, qui est à l’origine de nombreuses modes virales, recueille 46,15 % des données disponibles sur vous, y compris votre reconnaissance faciale, vos données vocales et votre bibliothèque d’images.',
      grindrDescription:
        'Grindr recueille presque autant d’informations que Tinder, avec 58,97 % de données stockées lorsque vous cherchez l’amour.',
      tescoDescription:
        'Tesco recueille des données personnelles parce qu’elles peuvent servir à vous identifier.',
      myDescription:
        'MyFitnessPal recueille des données sur vous de différentes manières. Les « Données personnelles » désignent tout renseignement qui peut servir à vous identifier, directement ou indirectement, seul ou associé à d’autres renseignements.',
      uberDescription:
        'La société Uber affirme qu’elle ne vend pas les données de ses clients, mais admet que ces données servent à envoyer des publicités ciblées et des communications de marketing ou autres à ses utilisateurs.',
      stravaDescription:
        'Strava est configurée pour télécharger toutes vos activités vers le flux Strava. Cela signifie que si vous ne changez rien, l’application partage automatiquement vos données sportives avec le reste de la communauté Strava. ',
      spotifyDescription:
        'Spotify recueille 35,90 % de vos données, en puisant dans vos profils de réseaux sociaux pour connaître vos centres d’intérêt et vos loisirs.',
    },
    socialMediaApps: {
      instagram: {
        description:
          'Cette application appartenant à Facebook collecte 69,23 % de toutes les données disponibles, telles que vos loisirs, votre taille, votre poids et votre orientation sexuelle. Comme sa société mère, Instagram peut utiliser ces renseignements pour faire de la publicité et vous recommander des comptes que vous devriez suivre.',
        securedMessage:
          'Seuls vos abonnés actuels pourront voir votre contenu une fois que vous aurez sécurisé votre compte Instagram et que vous l’aurez mis en mode privé.',
      },
      twitter: {
        description:
          'Cette application appartenant à Facebook collecte 69,23 % de toutes les données disponibles, telles que vos loisirs, votre taille, votre poids et votre orientation sexuelle. Comme sa société mère, Instagram peut utiliser ces renseignements pour faire de la publicité et vous recommander des comptes que vous devriez suivre.',
        securedMessage:
          'Seuls vos abonnés actuels pourront lire vos publications une fois que vous aurez sécurisé votre compte Twitter et que vous l’aurez mis en mode privé.',
      },
      tiktok: {
        description:
          'TikTok, qui est à l’origine de nombreuses modes virales, recueille 46,15 % des données disponibles sur vous, y compris votre reconnaissance faciale, vos données vocales et votre bibliothèque d’images.',
        securedMessage:
          'Seuls vos abonnés actuels pourront voir votre contenu une fois que vous aurez sécurisé votre compte TikTok et que vous l’aurez mis en mode privé.',
      },
      facebook: {
        description:
          'En tant que réseau social, cette application a besoin que vous lui donniez accès à tous vos renseignements pour qu’elle puisse vous recommander des amis, informer les gens quand c’est votre anniversaire, proposer des groupes auxquels vous pouvez adhérer et, surtout, vous faire de la publicité.',
        securedMessage:
          'Seuls vos abonnés actuels pourront voir votre contenu une fois que vous aurez sécurisé votre compte TikTok et que vous l’aurez mis en mode privé.',
      },
    },
    tutorials2FA: {
      enabling2FA: "Activation de l'authentification multi-facteurs (MFA)",
      description2FA:
        'La MFA réduit immédiatement les risques liés aux mots de passe compromis. Connectez-vous à tous vos comptes personnels et bénéficiez de cette couche de protection supplémentaire.',
      tiktok: {
        title: "Activation de l'authentification multi-facteurs mobile de TikTok",
        platform: 'Mobile',
        instructions: {
          steps: [
            {
              openTiktok: 'Ouvrez votre profil TikTok;',
              viewOptions:
                "Cliquez sur l'icône du menu en haut à droite pour afficher les options;",
              openSettings: `Dans le menu, cliquez sur "Paramètres et confidentialité";`,
              openSecurityOption: `Sur la page Paramètres et confidentialité, cliquez sur l'option "Sécurité".`,
            },
            {
              open2step: 'Sur la page Sécurité, cliquez sur la vérification en deux étapes;',
              enableAuthenticator:
                'Sur la page de vérification en deux étapes, cliquez pour cocher "téléphone" et/ou "authentificateur";',
              turnOnButton: 'Cliquez sur le bouton "Activer".',
            },
            {
              followInstructions: 'Suivez les instructions pour ajouter les facteurs de sécurité;',
              checkMessage: 'Assurez-vous de voir le statut "activé" et le message de succès.',
            },
          ],
        },
      },
      facebook: {
        title: "Activez l'authentification multi-facteurs pour votre compte Facebook.",
        subtitle: 'Quelle version de Facebook utilisez-vous ?',
        web: {
          title: "Activation de l'authentification multi-facteurs sur Facebook",
          platform: 'Site web',
          instructions: {
            steps: [
              {
                facebookLogin:
                  "Site Web Connectez-vous à votre compte Facebook à l'aide de votre navigateur Web;",
                openMenu:
                  'Sur la barre supérieure, cliquez sur votre photo de profil pour ouvrir le menu déroulant;',
                openPrivacySettings: 'Cliquez sur "Paramètres et confidentialité";',
                openSettings:
                  'Ensuite, cliquez sur "Paramètres" pour ouvrir la page des paramètres.',
              },
              {
                enterAccountsCenter: `Cliquez sur la bannière du Centre des comptes de Meta.`,
              },
              {
                selectPassword: `Dans le Centre des comptes de Meta, dans le panneau latéral gauche, sélectionnez "Mot de passe et sécurité";`,
                select2FA:
                  'Dans la section "Connexion et récupération", sélectionnez "Authentification à deux facteurs".',
              },
              {
                selectAccount:
                  'Sélectionnez le compte Facebook (parmi la liste de vos comptes Meta);',
                selectSecurityMethod:
                  "Sélectionnez l'une des options comme méthode de sécurité et suivez les instructions pour ajouter la méthode choisie comme votre deuxième authentification;",
                checkMessage: `Assurez-vous de voir un message "L'authentification à deux facteurs est activée" à la fin du processus.`,
              },
            ],
          },
        },
        mobile: {
          title: "Activation de l'authentification multi-facteurs sur Facebook",
          platform: 'Mobile',
          instructions: [
            {
              openApp: "Ouvrez l'application et connectez-vous à votre compte;",
              clickAvatar: "Dans le menu, en bas de la page, cliquez sur l'icône avec votre photo;",
              openSettings: `Sur la page du menu, cliquez sur l'icône en forme de "roue dentée" pour ouvrir les paramètres.`,
            },
            {
              enterAccountsCenter:
                'Sur la page Paramètres et confidentialité, cliquez sur la bannière "Centre des comptes Meta".',
            },
            {
              openPasswordSecurity:
                'Sur la page du Centre des comptes, cliquez sur "Mot de passe et sécurité";',
              select2FA:
                'Sur la page "Mot de passe et sécurité", choisissez "Authentification à deux facteurs".',
            },
            {
              selectAccount:
                'Sélectionnez le compte Facebook (parmi la liste de vos comptes Meta);',
              selectSecurityMethod: `Sélectionnez l'une des options comme méthode de sécurité, cliquez sur "Suivant" et suivez les instructions pour ajouter la méthode choisie comme votre deuxième authentification;`,
              checkMessage: `Assurez-vous de voir un message "L'authentification à deux facteurs est activée" à la fin du processus.`,
            },
          ],
        },
      },
      uber: {
        title: "Activer l'authentification multifactorielle sur votre compte Uber.",
        subtitle: "Quelle version d'Uber utilisez-vous ?",
        web: {
          title: "Activation de l'authentification multifactorielle d'Uber",
          platform: 'Site web',
          instructions: {
            steps: [
              {
                accountPage: 'Accédez à votre page de compte ;',
                securityTab: 'Cliquez sur l\'onglet "sécurité" dans le panneau latéral gauche.',
              },
              {
                twoStepsVerfication:
                  'Dans l\'onglet Sécurité, sélectionnez "vérification en 2 étapes".',
              },
              {
                getStarted: 'Cliquez sur "Commencer" et suivez le processus de vérification ;',
                clickNext:
                  'Sélectionnez une des options comme méthode de sécurité, cliquez sur "Suivant" et suivez les instructions pour ajouter la méthode choisie comme deuxième authentification ;',
                guarantee:
                  'Assurez-vous de voir un message "L\'authentification à deux facteurs est activée" à la fin du processus.',
              },
            ],
          },
        },
        mobile: {
          title: "Activation de l'authentification multi-facteurs d'Uber",
          platform: 'Mobile',
          instructions: {
            steps: [
              {
                openAccount: `Ouvrez votre application Uber et appuyez sur l'onglet "Compte" situé dans le coin inférieur droit de la barre de navigation;`,
                enterProfile:
                  'Cliquez sur votre photo de profil, située à côté de votre nom en haut de la page.',
              },
              {
                enterSecurity: `Dans votre compte Uber, sélectionnez l'onglet "Sécurité";`,
                select2FA: `Dans l'onglet Sécurité, sélectionnez "Vérification en deux étapes".`,
              },
              {
                getStarted: 'Cliquez sur "Commencer" et suivez le processus de vérification.',
                selectSecurityMethod: `Sélectionnez l'une des options comme méthode de sécurité, cliquez sur "Suivant" et suivez les instructions pour ajouter la méthode choisie comme votre deuxième authentification.`,
                checkMessage: `Assurez-vous de voir un message indiquant que l'authentification à deux facteurs est activée à la fin du processus.`,
              },
            ],
          },
        },
      },
      instagram: {
        title: "Activez l'authentification multi-facteurs pour votre compte Instagram.",
        subtitle: "Quelle version d'Instagram utilisez-vous?",
        web: {
          title: "Activation de l'authentification multi-facteurs sur Instagram",
          platform: 'Site web',
          instructions: {
            steps: [
              {
                instagramLogin:
                  'Connectez-vous à votre compte Instagram en utilisant votre navigateur web;',
                openMore: 'En bas de la barre latérale, cliquez sur "Plus" pour voir les options;',
                openSettings: 'Cliquez sur "Paramètres" pour ouvrir la page des paramètres;',
                openMetaCenter:
                  'Dans les paramètres, cliquez sur la bannière du Centre de compte de Meta.',
              },
              {
                selectSecurity:
                  'Dans le Centre de compte de Meta, sur le panneau latéral gauche, sélectionnez "Mot de passe et sécurité";',
                select2FA:
                  'Dans la section "Connexion et récupération", sélectionnez "Authentification à deux facteurs".',
              },
              {
                selectInstagramAccount:
                  'Sélectionnez le compte Instagram (parmi la liste de vos comptes Meta);',
                selectSecurityMethod:
                  "Sélectionnez l'une des options comme méthode de sécurité et suivez les instructions pour ajouter la méthode choisie comme votre deuxième authentification;",
                checkMessage:
                  "Assurez-vous de voir un message indiquant que l'authentification à deux facteurs est activée à la fin du processus.",
              },
            ],
          },
        },
        mobile: {
          title: "Activation de l'authentification multi-facteurs sur Instagram.",
          platform: 'Mobile',
          instructions: [
            {
              openInstagram: 'Ouvrez votre profil Instagram;',
              enterOptions:
                "Cliquez sur l'icône du Menu dans le coin supérieur droit pour afficher les options;",
              enterAccountCenter:
                'Cliquez sur "Centre de compte" pour ouvrir la page du Centre de compte de Meta.',
            },
            {
              enterPasswordSecurity:
                'Sur la page du Centre de compte, cliquez sur "Mot de passe et sécurité";',
              select2FA:
                'Sur la page "Mot de passe et sécurité", choisissez "Authentification à deux facteurs".',
            },
            {
              selectInstagramAccount:
                'Sélectionnez le compte Instagram (parmi la liste de vos comptes Meta);',
              selectSecurityMethod: `Sélectionnez l'une des options comme méthode de sécurité, cliquez sur "Suivant" et suivez les instructions pour ajouter la méthode choisie comme votre deuxième authentification;`,
              checkMessage:
                "Assurez-vous de voir un message indiquant que l'authentification à deux facteurs est activée à la fin du processus.",
            },
          ],
        },
      },
    },
    changePasswordTutorials: {
      canva: {
        title: 'Réinitialiser votre mot de passe sur Canva',
        subtitle: 'Quelle version de Canva utilisez-vous?',
        web: {
          title: 'Réinitialiser votre mot de passe sur Canva',
          platform: 'Site Web',
          step1: [
            'Ouvrez la page Canva.com.',
            'Cliquez sur l’icône des Paramètres du compte dans le coin supérieur droit, près du bouton « Créer ».',
            'Dans le menu latéral, sélectionnez l’option « Connexion et sécurité ».',
          ],
          step2: [
            'Sous « Connex. », près de « Mot de passe », cliquez sur « Mettre à jour ».',
            'Entrez votre mot de passe actuel pour le vérifier.',
          ],
          step3: [
            'Entrez votre nouveau mot de passe.',
            'Entrer une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Enregistrer ».',
          ],
        },
        mobile: {
          title: 'Réinitialiser votre mot de passe sur Canva',
          platform: 'Application mobile',
          step1: [
            'Connectez-vous sur votre compte.',
            'Dans la barre de navigation, en bas, sélectionnez l’option « Menu ».',
            'Faites défiler la page vers le bas et cliquez sur « Paramètres ».',
          ],
          step2: [
            'Cliquez sur « Connexion et sécurité ».',
            'Sous Connexion, près de « Mot de passe », cliquez sur « Mettre à jour ».',
          ],
          step3: [
            'Entrez votre mot de passe actuel et cliquez sur « Confirmer le mot de passe ».',
            'Après la confirmation, entrez votre nouveau mot de passe.',
            'Entrez une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Enregistrer ».',
          ],
        },
      },
      facebook: {
        title: 'Réinitialiser votre mot de passe sur Facebook',
        subtitle: 'Quelle version de Facebook utilisez-vous?',
        web: {
          title: 'Réinitialiser votre mot de passe sur Facebook',
          step1: [
            'Connectez-vous sur votre compte.',
            'Cliquez sur la photo de votre profil, dans le coin supérieur droit.',
            'Sélectionnez l’option « Paramètres et confidentialité ».',
          ],
          step2: [
            'Sélectionnez l’option « Paramètres » dans le menu.',
            'Sur la page des Paramètres, sélectionnez l’option « Mot de passe et sécurité » dans le menu latéral.',
          ],
          step3: [
            'Sous "Connexion", cliquez sur "Modifier" dans la section "Changer de mot de passe".',
          ],
          step4: [
            'Entrez votre mot de passe actuel.',
            'Entrez votre nouveau mot de passe.',
            'Entrer une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Enregistrer les changements ».',
          ],
        },
        mobile: {
          title: 'Réinitialiser votre mot de passe sur Facebook',
          step1: [
            'Connectez-vous sur votre compte.',
            'Sélectionnez le dernier élément à droite parmi les icônes de navigation.',
            'Cliquez sur l’icône « Paramètres ».',
          ],
          step2: [`Sous Compte, sélectionnez l'option "Mot de passe et sécurité".`],
          step3: [
            'Sous « Mot de passe et sécurité », trouvez la section « Connexion et récupération ».',
            'Dans cette section, cliquez sur « Modifier le mot de passe ».',
            'Entrez votre mot de passe actuel.',
            'Entrez votre nouveau mot de passe.',
            'Entrer une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Changer le mot de passe ».',
          ],
        },
      },
      generic: {
        title: 'Réinitialiser vos mots de passe sur les sites Web et les applications',
        web: {
          step1: [
            'Ouvrez la <b>page des paramètres</b> à partir de l’icône du <b>menu</b> :',
            'L’icône du menu est généralement représentée par trois lignes horizontales.',
            `Il se trouve le plus souvent <b>en haut à droite</b> dans la barre supérieure d'un site Web, mais il peut aussi figurer dans la <b>barre inférieure</b> des applications mobiles.`,
            'Après avoir ouvert la <b>page des paramètres</b>, cherchez les options de <b>sécurité</b> ou de <b>connexion</b> où se trouveront les paramètres de votre <b>mot de passe</b>, puis suivez les instructions.',
          ],
          step2: [
            'Accédez à la page des paramètres à partir du menu Profil :',
            `Si vous n'avez pas encore soumis votre <b>image de profil</b>, cherchez un <b>cercle générique avec vos initiales</b> ou une <b>icône de silhouette</b>.`,
            `Il se trouve le plus souvent <b>en haut à droite</b> dans la barre supérieure d'un site Web, mais il peut aussi figurer dans la <b>barre inférieure</b> des applications mobiles.`,
            'Après avoir ouvert le menu, rendez-vous à la <b>page des paramètres</b>, cherchez les options de <b>sécurité</b> ou de <b>connexion</b> où se trouveront les options de <b>mot de passe</b>, puis suivez les instructions.',
          ],
        },
      },
      linkedin: {
        title: 'Réinitialiser votre mot de passe sur LinkedIn',
        subtitle: 'Quelle version de LinkedIn utilisez-vous?',
        web: {
          title: 'Réinitialiser votre mot de passe sur LinkedIn',
          step1: [
            'Connectez-vous sur votre compte.',
            'Cliquez sur la photo de votre profil, dans le coin supérieur droit.',
            'Sélectionnez l’option « Préférences et confidentialité ».',
          ],
          step2: [
            'Sélectionnez l’option « Identification et sécurité » dans le menu latéral.',
            'Sous « Accès au compte », cliquez sur « Changer le mot de passe ».',
          ],
          step3: [
            'Entrez votre mot de passe actuel.',
            'Entrez votre nouveau mot de passe. LinkedIn propose des conseils pour choisir un mot de passe robuste.',
            'Assurez-vous de cocher la case « Obliger tous les autres appareils à s’identifier avec le nouveau mot de passe ». Cela vous permettra de protéger votre compte sur tous les appareils sur lesquels vous vous connectez.',
            'Cliquez sur « Enregistrer le mot de passe ».',
          ],
        },
        mobile: {
          title: 'Réinitialiser votre mot de passe sur LinkedIn',
          step1: [
            'Connectez-vous sur votre compte.',
            'Cliquez sur la photo de votre profil en haut à gauche.',
            'Sélectionnez l’option « Paramètres » en bas du menu.',
          ],
          step2: [
            'Sélectionnez l’option « Identification et sécurité ».',
            'Sous « Accès au compte », cliquez sur « Changer le mot de passe ».',
          ],
          step3: [
            'Entrez votre mot de passe actuel.',
            'Entrez votre nouveau mot de passe. LinkedIn propose des conseils pour choisir un mot de passe robuste.',
            'Assurez-vous de cocher la case « Obliger tous les autres appareils à s’identifier avec le nouveau mot de passe ». Cela vous permettra de protéger votre compte sur tous les appareils sur lesquels vous vous connectez.',
            'Cliquez sur « Enregistrer le mot de passe ».',
          ],
        },
      },
      myfitnesspal: {
        title: 'Réinitialiser votre mot de passe sur MyFitnessPal',
        subtitle: 'Quelle version de MyFitnessPal utilisez-vous?',
        web: {
          title: 'Réinitialiser votre mot de passe sur MyFitnessPal',
          step1: [
            'Connectez-vous sur votre compte.',
            'Sous « Mon accueil », cliquez sur « Paramètres ». C’est la dernière option à droite du menu.',
          ],
          step2: [
            'Sous « Paramètres du compte », sélectionnez l’option « Modifier le mot de passe ».',
            'Entrez votre mot de passe actuel.',
            'Entrez votre nouveau mot de passe.',
            'Entrer une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Enregistrer modifications ».',
          ],
        },
        mobile: {
          title: 'Réinitialiser votre mot de passe sur MyFitnessPal',
          step1: [
            'Connectez-vous sur votre compte.',
            'Cliquez sur votre photo de profil en haut à gauche.',
            'Cliquez sur l’icône Paramètres, en haut à droite.',
          ],
          step2: [
            'Dans « Mon compte », cliquez sur « Modifier le mot de passe ».',
            'Entrez votre nouveau mot de passe.',
            'Entrez une nouvelle fois votre nouveau mot de passe pour le confirmer.',
            'Cliquez sur « Modifier le mot de passe ».',
          ],
        },
      },
    },
    setAccountPrivateTutorials: {
      facebookCompromised: {
        title: 'Paramètres de confidentialité sur Facebook',
        subtitle: 'Quelle version de Facebook utilisez-vous ?',
        web: {
          title: 'Paramètres de confidentialité sur Facebook',
          platform: 'Site web',
          step1: [
            'Connectez-vous à votre compte et cliquez sur votre photo de profil en haut à droite.',
            'Sélectionnez l’option « Paramètres et confidentialité » ;',
            'Cliquez sur « Paramètres » pour ouvrir la page des paramètres.',
          ],
          step2: [
            'Sur la page des paramètres, accédez à la section « Audience et visibilité » dans la barre latérale pour voir les paramètres de confidentialité que vous pouvez ajuster.',
            'Appuyez sur l’une des options dans cette section pour ajuster « qui peut voir vos publications », « comment les gens peuvent vous trouver et vous contacter », et « qui peut vous envoyer des demandes d’ami ». ',
          ],
          step3: [
            'Appuyez sur « Comment les gens peuvent vous trouver et vous contacter » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
          ],
          step4: [
            'Appuyez sur « Profil et étiquetage » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
            'Assurez-vous de ne pas partager excessivement les informations de votre profil.',
          ],
          step5: [
            'Appuyez sur « Publications » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
          ],
          step6: [
            'Dans la barre latérale, faites défiler pour trouver la section « Outils et ressources » et cliquez sur « Vérification de la confidentialité »',
            "Utilisez l'outil « Vérification de la confidentialité » pour vous assurer que vos paramètres sont à jour.",
            'Pour obtenir les informations les plus récentes et des étapes détaillées sur la gestion de vos paramètres de confidentialité, veuillez consulter le Centre d’aide de Facebook',
          ],
        },
        mobile: {
          title: 'Paramètres de confidentialité sur Facebook',
          platform: 'Application mobile',
          step1: [
            "Connectez-vous à votre compte et appuyez sur l'icône du menu pour afficher votre page Menu.",
            "Appuyez sur l'icône « Paramètres » pour accéder à la page des paramètres.",
          ],
          step2: [
            'Sur la page « Paramètres et confidentialité », accédez à la section « Audience et visibilité » pour voir les paramètres de confidentialité que vous pouvez ajuster.',
            'Appuyez sur l’une des options dans cette section pour ajuster « qui peut voir vos publications », « comment les gens peuvent vous trouver et vous contacter », et « qui peut vous envoyer des demandes d’ami ». ',
          ],
          step3: [
            'Appuyez sur « Comment les gens peuvent vous trouver et vous contacter » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
          ],
          step4: [
            'Appuyez sur « Profil et étiquetage » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
            'Assurez-vous de ne pas partager excessivement les informations de votre profil.',
          ],
          step5: [
            'Appuyez sur « Publications » pour voir les paramètres et suivre les instructions. Veuillez examiner cette option attentivement.',
          ],
          step6: [
            'Faites défiler pour trouver la section « Outils et ressources » et cliquez sur « Vérification de la confidentialité »',
            "Utilisez l'outil « Vérification de la confidentialité » pour vous assurer que vos paramètres sont à jour.",
            'Pour obtenir les informations les plus récentes et des étapes détaillées sur la gestion de vos paramètres de confidentialité, veuillez consulter le Centre d’aide de Facebook',
          ],
        },
      },
      facebookWarning: {
        title: 'Paramètres de confidentialité sur Facebook',
        subtitle: 'Quelle version de Facebook utilisez-vous?',
        web: {
          title: 'Paramètres de confidentialité sur Facebook',
          platform: 'Site Web',
          step1: [
            'Assurez-vous que vos données ne sont accessibles qu’aux personnes en qui vous avez confiance :',
            'Connectez-vous à votre compte et cliquez sur votre photo de profil, en haut à droite.',
            'Sélectionnez l’option « Paramètres et confidentialité ».',
            'Cliquez sur « Assistance confidentialité » pour accéder aux raccourcis de confidentialité fournis par Facebook.',
          ],
          step2: [
            'Sélectionnez la première vignette intitulée « Qui peut voir ce que vous partagez » pour examiner les paramètres de confidentialité des publications et des renseignements personnels que vous partagez.',
          ],
          step3: [
            'La première étape consiste à décider qui peut voir les renseignements de votre profil.',
            'Modifiez les paramètres qui vous conviennent en cliquant sur les cases grisées à droite :',
            'Pour vos coordonnées, nous vous recommandons de sélectionner « Moi uniquement ».',
            'Vos autres données personnelles devraient être réservées à vos « Amis ».',
            'En cliquant sur « Personnalisé », vous pouvez également créer une liste d’amis qui peuvent consulter ces renseignements.',
          ],
          step4: [
            'À l’étape suivante, vous pouvez décider qui peut voir vos publications et vos stories.',
            'Modifiez les paramètres qui vous conviennent en cliquant sur les cases grisées à droite :',
            'Nous vous recommandons fortement de limiter vos futures publications et stories à vos « Amis » seulement.',
            'Vous pouvez également cacher vos publications à quelques amis en sélectionnant « Amis sauf... » ou bien choisir « Certains amis » qui pourront consulter vos publications.',
            'Cliquez sur « Limiter » pour protéger vos anciennes publications. Cela signifie que seuls vos Amis pourront voir ce que vous avez partagé auparavant.',
          ],
          step5: [
            'Si vous avez suivi les étapes de ce tutoriel, vos paramètres de confidentialité auront déjà considérablement été améliorés, vous êtes donc sur la bonne voie !',
            `N'hésitez pas à consulter les autres cartes de la Vérification de confidentialité pour découvrir ce que Facebook offre de plus pour sécuriser votre confidentialité.`,
          ],
        },
        mobile: {
          title: 'Paramètres de confidentialité sur Facebook',
          platform: 'Application mobile',
          step1: [
            'Ouvrez votre profil Instagram.',
            'Connectez-vous à votre compte et sélectionnez le dernier élément à droite parmi les icônes de navigation.',
            'Cliquez sur l’icône « Paramètres ».',
          ],
          step2: [
            'Sous "Compte", sélectionnez la carte intitulée "Vérification de confidentialité".',
          ],
          step3: [
            'Sélectionnez la première vignette intitulée « Qui peut voir ce que vous partagez » pour examiner les paramètres de confidentialité des publications et des renseignements personnels que vous partagez.',
          ],
          step4: [
            'La première étape consiste à décider qui peut voir les renseignements de votre profil.',
            'Modifiez les paramètres qui vous conviennent en cliquant sur les cases grisées à droite :',
            'Pour vos coordonnées, nous vous recommandons de sélectionner « Moi uniquement ».',
            'Vos autres données personnelles devraient être réservées à vos « Amis ».',
            'En cliquant sur « Personnalisé », vous pouvez également créer une liste d’amis qui peuvent consulter ces renseignements.',
          ],
          step5: [
            'À l’étape suivante, vous pouvez décider qui peut voir vos publications et vos stories.',
            'Modifiez les paramètres qui vous conviennent en cliquant sur les cases grisées à droite :',
            'Nous vous recommandons fortement de limiter vos futures publications et stories à vos « Amis » seulement.',
            'Vous pouvez également cacher vos publications à quelques amis en sélectionnant « Amis sauf... » ou bien choisir « Certains amis » qui pourront consulter vos publications.',
            'Cliquez sur « Limiter » pour protéger vos anciennes publications. Cela signifie que seuls vos Amis pourront voir ce que vous avez partagé auparavant.',
          ],
          step6: [
            "If you followed the steps in this tutorial, your privacy settings will have already improved significantly, so you're off to a good start!",
            'N’hésitez pas à consulter les autres vignettes de l’Assistance confidentialité pour découvrir ce que propose Facebook pour protéger votre vie privée.',
          ],
        },
      },
      instagram: {
        title: 'Configurer votre compte Instagram en privé',
        subtitle: "Quelle version d'Instagram utilisez-vous ?",
        web: {
          title: 'Configurer votre compte Instagram en privé',
          platform: 'Site Web',
          step1: [
            'Connectez-vous à votre compte Instagram via votre navigateur web ;',
            'En bas de la barre latérale, cliquez sur « Plus » pour voir les options ;',
            'Cliquez sur « Paramètres » pour ouvrir la page des Paramètres.',
          ],
          step2: [
            "Sur la page des Paramètres, cliquez sur « Confidentialité du compte » à gauche de l'écran pour accéder à la page de confidentialité du compte.",
            'Sur la page « Confidentialité du compte », cochez la case pour rendre votre compte privé.',
          ],
          step3: [
            'À partir de ce point, votre compte sera déjà privé, mais vous pouvez choisir de passer en revue vos abonnés et de supprimer les utilisateurs que vous ne souhaitez plus voir vos publications et stories.',
            'Si vous ne souhaitez pas examiner vos abonnés, cliquez sur « Annuler » pour terminer.',
          ],
        },
        mobile: {
          title: 'Configurer votre compte Instagram en privé',
          platform: 'Application Mobile',
          step1: [
            'Ouvrez votre profil Instagram ;',
            "Cliquez sur l'icône Menu en haut à droite pour voir les options ;",
            'Cliquez sur « Confidentialité du compte » pour ouvrir la page de confidentialité du compte.',
          ],
          step2: [
            'Sur la page de confidentialité du compte, cliquez sur le bouton à côté de « Compte privé ». Cela déclenchera une confirmation ;',
            'Cliquez sur « Passer en privé » pour confirmer votre choix.',
          ],
          step3: [
            'À partir de ce point, votre compte sera déjà privé, mais vous pouvez choisir de passer en revue vos abonnés et de supprimer les utilisateurs que vous ne souhaitez plus voir vos publications et stories.',
            'Si vous ne souhaitez pas examiner vos abonnés, cliquez sur « Annuler » pour terminer.',
          ],
        },
      },

      tiktok: {
        title: 'Régler votre compte TikTok en mode privé',
        subtitle: 'Quelle version de TikTok utilisez-vous?',
        web: {
          title: 'Régler votre compte TikTok en mode privé',
          platform: 'Site Web',
          step1: [
            'Connectez-vous à votre compte TikTok à l’aide de votre navigateur web.',
            'Cliquez sur l’image de votre profil, en haut à droite de l’en-tête, pour afficher les options.',
            'Cliquez sur « Paramètres » pour ouvrir la page des paramètres.',
            'Sur la page des paramètres, à la rubrique « Confidentialité », vérifiez que l’option « Compte privé » est activée.',
          ],
        },
        mobile: {
          title: 'Régler votre compte TikTok en mode privé',
          platform: 'Application mobile',
          step1: [
            'Ouvrez votre profil TikTok.',
            'Cliquez sur l’icône de Menu en haut à droite pour afficher les options.',
            'Dans le menu, cliquez sur « Paramètres et confidentialité ».',
            'Sur la page « Paramètres et confidentialité », cliquez sur l’option « Confidentialité ».',
          ],
          step2: [
            'Sur la page de confidentialité, sous « Découvrabilité », activez l’option « Compte privé » pour protéger vos publications. ',
          ],
        },
      },
      twitter: {
        title: 'Régler votre compte Twitter en mode privé',
        subtitle: 'Quelle version de Twitter utilisez-vous?',
        web: {
          title: 'Régler votre compte Twitter en mode privé',
          platform: 'Site Web',
          step1: [
            `Connectez-vous à votre compte Twitter à l'aide de votre navigateur Web.`,
            `À gauche de l’écran, cliquez sur l’onglet Notifications, puis sur le petit symbole d’engrenage qui apparaîtra à droite de celui-ci, qui vous conduira à la page des paramètres.`,
          ],
          step2: [
            'Sur la page des paramètres, choisissez l’onglet « Confidentialité et sécurité » où vous trouverez la liste des paramètres disponibles.',
            'Cliquez sur l’option « Audience et identification » pour gérer les informations que vous autorisez les autres utilisateurs à voir.',
          ],
          step3: [
            'Cochez la case vide, et une fenêtre s’affichera pour vous demander de confirmer que vous souhaitez rendre votre compte Twitter privé.',
            'Cliquez sur « Protéger » pour confirmer.',
          ],
        },
        mobile: {
          title: 'Régler votre compte Twitter en mode privé',
          platform: 'Application mobile',
          step1: [
            'Ouvrez votre application Twitter.',
            'Cliquez sur votre photo de profil en haut à gauche pour ouvrir le menu latéral.',
            'Dans le menu latéral, défilez vers le bas pour voir l’option « Paramètres et support ».',
            'Sous « Paramètres et support », cliquez sur « Paramètres et confidentialité ».',
          ],
          step2: [
            'Sur la page des paramètres, cliquez sur « Confidentialité et sécurité ».',
            'Cliquez sur l’option « Audience et identification » pour gérer les informations que vous autorisez les autres utilisateurs à voir.',
          ],
          step3: [
            'Sur la page « Audience et identification », activez l’option « Protéger mes Tweets » pour rendre votre compte privé.',
          ],
        },
      },
      uber: {
        title: 'Modifier vos paramètres de confidentialité sur Uber',
        platform: 'Application Mobile',
        step1: [
          'Ouvrez votre application Uber et appuyez sur l’onglet "Compte" situé dans le coin inférieur droit de la barre de navigation;',
          'Faites défiler vers le bas dans l’onglet Compte et sélectionnez "Paramètres" pour accéder à la page des paramètres.',
        ],
        step2: [
          'Dans la section Paramètres de l’application, appuyez sur "Confidentialité" pour voir le Centre de confidentialité.',
        ],
        step3: [
          'Appuyez sur l’un des éléments de la section Publicités et données : "Offres et promotions d’Uber", "Publicités sur Uber Eats" et "Publicités sur les trajets". Veuillez examiner attentivement chaque option.',
          'Désactivez les interrupteurs pour désactiver le partage et la collecte de données.',
        ],
      },
      myFitnessPal: {
        title: 'Modifier vos paramètres de confidentialité sur MyFitnessPal',
        platform: 'Application Mobile',
        step1: [
          'Ouvrez votre application MyFitnessPal et appuyez sur l\'onglet "Plus" situé dans le coin inférieur droit de la barre de navigation;',
          'Faites défiler la page et sélectionnez "Centre de confidentialité".',
        ],
        step2: [
          `Au Centre de confidentialité, sélectionnez "Personnalisation" pour bloquer les publicités basées sur localisation et comportement, mais la collecte de données peut continuer ;`,
          `Tenter de désactiver le partage de données dans "Gérer les consentements aux données" peut entraîner la suppression de votre compte ;`,
          `Pour gérer les paramètres de confidentialité de l'application, appuyez sur "Paramètres de partage et de confidentialité".`,
        ],
        step3: [
          `Dans "Paramètres de partage", choisissez Privé, Amis ou Verrouillé pour contrôler l'accès à votre contenu ;`,
          'Dans "Paramètres e-mail," désactivez la première option pour protéger votre adresse e-mail ;',
          'Dans les paramètres Facebook, désactivez le commutateur pour protéger votre profil contre vos amis Facebook ou déconnectez-vous de Facebook.',
        ],
      },
      strava: {
        title: 'Modifier vos paramètres de confidentialité sur Strava',
        platform: 'Application Mobile',
        step1: [
          "Ouvrez votre application Strava et appuyez sur l'icône d'engrenage dans le coin supérieur gauche pour accéder aux paramètres ;",
          'Sous Préférences, sélectionnez "Contrôles de confidentialité".',
        ],
        step2: [
          'Sur la page des Contrôles de confidentialité, sous "Où Vous Apparaissez", ajustez les paramètres pour permettre uniquement à vos Suiveurs, à Personne, ou à Vous Seul (recommandé) de voir vos informations, vos activités et votre emplacement ;',
        ],
        step3: [
          `Faites défiler jusqu'à "Contrôles Additionnels" sur la même page ;`,
          'Appuyez sur "Visibilité de la Carte" et sélectionnez la dernière option, "Masquer vos cartes d\'activités", puis activez le commutateur pour garder vos données de localisation privées ;',
          'Appuyez sur "Utilisation des Données Agrégées" et décochez la case pour cesser de contribuer à vos données d\'activité ;',
        ],
        step4: [
          `Appuyez sur "Photos Publiques sur les Parcours" et décochez la case pour empêcher le partage de votre contenu avec des inconnus ;`,
          `Enfin, appuyez sur "Ne Pas Partager Mes Informations Personnelles" et activez l'option pour cesser de partager vos informations personnelles avec des tiers.`,
        ],
      },
      spotify: {
        title: 'Modifier vos paramètres de confidentialité sur Spotify',
        platform: 'Application Web',
        step1: [
          'Pour accéder aux paramètres de confidentialité, connectez-vous à votre compte Spotify sur votre navigateur web ;',
          'Dans le coin supérieur droit, cliquez sur votre photo de profil, puis sélectionnez "Compte" dans le menu déroulant ;',
          'Cliquez sur "Modifier le profil," puis décochez la case pour arrêter de partager vos données d\'inscription à des fins marketing.',
        ],
        step2: [
          'Dans la barre latérale, cliquez sur "Paramètres de confidentialité" ;',
          'Désactivez les commutateurs pour cesser de recevoir des publicités personnalisées liées à vos données ou pour empêcher Spotify de traiter vos données Facebook.',
        ],
        step3: [
          `Dans la barre latérale, faites défiler jusqu'à l'option "Applications" pour gérer les applications ayant accès à votre compte Spotify ;`,
          'Si des applications sont répertoriées, cliquez sur "Révoquer l\'accès" à côté de chacune d\'elles pour révoquer leur accès.',
        ],
      },
      tinder: {
        title: 'Modifier vos paramètres de confidentialité sur Tinder',
        platform: 'Application Mobile',
        step1: [
          "Ouvrez votre application Tinder et appuyez sur l'icône de profil dans la barre de navigation inférieure, située dans le coin droit ;",
          "Sur l'onglet Profil, appuyez sur l'icône d'engrenage dans le coin supérieur droit pour accéder aux paramètres ;",
          'Sous Confidentialité, sélectionnez "Préférences de confidentialité".',
        ],
        step2: [
          'Sur la page Préférences de confidentialité, appuyez sur "Refuser tout" pour révoquer les autorisations de stockage et de récupération de vos données ;',
          'Notez que certaines "Autorisations Strictement Nécessaires" ne peuvent pas être refusées.',
        ],
      },
      grinder: {
        title: 'Modifier vos paramètres de confidentialité sur Grindr',
        platform: 'Application Mobile',
        step1: [
          'Ouvrez votre application Grindr et appuyez sur votre photo de profil dans le coin supérieur gauche ;',
          'Dans la barre latérale, sélectionnez "Paramètres" pour accéder à la page des paramètres ;',
          'Dans la page des paramètres, appuyez sur "Centre de Préférences de Consentement".',
        ],
        step2: [
          'Sur le Centre de Préférences de Consentement, appuyez sur "Rejeter Tout" pour révoquer les autorisations de traitement et de partage de vos données ;',
          'Notez que certains éléments de la liste sont "Toujours Actifs" et ne peuvent pas être rejetés.',
        ],
      },
    },
    app: {
      adminUserManagment: 'Gestion des administrateurs',
      myAccount: 'Mon compte',
      signOut: 'Déconnexion',
      confirmEmail_one:
        'Vous avez {{count}} adresse email non vérifiée, veuillez la confirmer pour voir votre score final.',
      confirmEmail_other:
        'Vous avez {{count}} adresses email non vérifiées, veuillez les confirmer pour voir votre score final.',
      resendEmail_one: "Renvoyer l'email",
      resendEmail_other: 'Renvoyer les emails',
      resendSuccessful: 'Email de vérification renvoyé avec succès',
      resendSuccessful_one: "L'email de vérification a été renvoyé avec succès",
      resendSuccessful_other: 'Les emails de vérification ont été renvoyés avec succès',
      resendFailure:
        "Impossible de renvoyer l'email de vérification. Veuillez réessayer ultérieurement.",
      sendEmail: 'Envoyer un courriel',
      loading: 'En cours de chargement',
      accountSettings: 'Paramètres du compte',
      profileInformation: 'Données du profil',
      subscription: 'Abonnement',
      individualProfile: 'Profil individuel',
      companyProfile: "Profil de l'entreprise",
      billing: 'Facturation',
      batchScan: 'Scan en lot',
      companyMembers: "Membres de l'entreprise",
      adminUsers: 'Utilisateurs administrateurs',
      viewResponsePlanButton: 'Voir le plan de réponse',
      responsePlanStillInProgress:
        'Votre plan de réponse en matière de cybersécurité est encore en cours. Terminez les étapes pour garantir votre sécurité.',
    },
    partners: {
      stats: {
        active: 'Actives',
      },
      detail: {
        primaryContact: 'Contact principal',
      },
      validation: {
        industryInvalid: 'Sélectionnez un secteur valide',
        regionInvalid: 'Sélectionnez une région valide',
      },
    },
    notFound: {
      pageNotFound: 'Page introuvable',
      pageError: `We couldn't find a route to this page`,
      toHome: 'Aller à la page d’accueil',
    },
    internalError: {
      wrong: `We're sorry, something went wrong.`,
      error: 'Erreur',
      technicalDifficulties: `We're experiencing technical difficulties and are unable to fulfill your request at this time. Please try again later, or contact our support team for assistance.`,
      thankYou: 'Nous vous remercions de votre patience.',
      contactSupport: 'Appeler le service client',
    },
    welcomeBatch: {
      title: 'Bienvenue sur la plateforme Defender!',
      subtitle: 'Votre parcours vers une meilleure santé cybernétique commence ici.',
      step1Title: "Étape 1 : Fournir les détails de l'entreprise",
      step1Subtitle:
        'Pour commencer, entrez les informations clés de votre entreprise. Cela nous aide à configurer votre tableau de bord et à nous aligner sur les besoins uniques de votre organisation.',
      step2Title: 'Étape 2 : Ajouter les données commerciales des employés',
      step2Subtitle:
        'Incluez les détails commerciaux pertinents des employés afin que Protexxa Defender puisse effectuer des analyses et identifier les domaines nécessitant une attention.',
      footer:
        "Ce processus garantit une vue d'ensemble complète de la santé cybernétique de votre organisation. Travaillons ensemble pour construire un environnement numérique plus fort et plus sûr.",
      button: "Commencer l'intégration",
    },
    components: {
      copied: 'Copié',
      editPhone: 'Modifier votre numéro de téléphone',
      verificationPhone:
        ' Nous allons vous envoyer un nouveau code de sécurité pour vérifier ce numéro de téléphone',
      sendCode: 'Envoyer le code',
      add: 'Ajouter',
      scoreUpdate: 'Quand vous mettez à jour vos informations, elles seront évaluées',
      nextScan: 'lors de votre prochaine évaluation mensuelle de la cybersécurité.',
      yourNumber: 'Est-ce bien votre numéro de téléphone?',
      confirmNumber:
        'Nous enverrons un code de vérification à ce numéro une fois que vous l’aurez validé. Voulez-vous continuer?',
      goBack: 'Retour',
      continue: 'Continuer',
    },
    auth: {
      email: 'Email',
      login: 'Identifiant',
      logout: 'Déconnexion',
      exitOnboarding: "Quitter l'intégration?",
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié?',
      welcomeBack: 'Bienvenue de retour',
      haveYouHere: `C'est un plaisir de vous avoir à nouveau ici`,
      findAndFix: 'Trouvez et corrigez les vulnérabilités cybernétiques en quelques minutes',
      leftPanelDescription:
        "L'outil alimenté par l'IA de Protexxa vérifie si vos informations personnelles ont été exposées en ligne sans votre consentement (y compris sur le dark web)",
      createNewAccount: 'Créer un nouveau compte',
      creatNewAccountBatch: 'Créez votre compte entreprise',
      getStartedBatch: 'Configurez les détails de votre entreprise pour la préparer',
      agreeBatch: "En cliquant sur « Terminer l'inscription », vous acceptez nos",
      getStarted: `C'est un plaisir de vous avoir ici, commençons`,
      confirmPhone: `Vous recevrez un code OTP pour vérifier votre numéro de téléphone après avoir créé un compte.`,
      passwordRequirements: 'Exigences de mot de passe',
      minimumCharacters: 'Au moins 12 caractères',
      oneNumber: 'Au moins un chiffre',
      oneUppercase: 'Au moins une lettre majuscule',
      oneLowercase: 'Au moins une lettre minuscule',
      oneEspecial: 'Au moins 1 caractère spécial',
      agree: 'En cliquant sur « Continuer », vous acceptez nos',
      terms: 'Conditions de service',
      policy: 'Politique de confidentialité',
      and: ' et ',
      createAccount: 'Créer un compte',
      completeSignup: "Compléter l'inscription",
      haveAccount: 'Vous avez déjà un compte?',
      confirmPassword: 'Confirmez le mot de passe',
      phoneNumber: 'Numéro de téléphone',
      phoneNumberDescription:
        'Vous recevrez un code OTP pour vérifier votre numéro de téléphone après avoir créé un compte.',
      otpVerificationNote:
        'Vous recevrez un code OTP pour vérifier votre numéro de téléphone après avoir créé un compte.',
      fullName: 'Nom et prénom',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      newPassword: 'Nouveau mot de passe',
      prepopulateCheckBox:
        "Je confirme que les informations fournies m'appartiennent et j'autorise Protexxa à les utiliser pour pré-remplir mon profil avec les données pertinentes de leur base de données.",
      termsAnd: 'et',
      termsWarning:
        'Veuillez consulter et accepter la Politique de confidentialité et les Conditions de service pour continuer.',
      termsWarningBanner: {
        message:
          "Veuillez lire et accepter les Conditions d'utilisation et la Politique de confidentialité pour continuer.",
        termsOfService: "Conditions d'utilisation",
        privacyPolicy: 'Politique de confidentialité',
      },
      runResponsePlan: 'Exécutez le Plan de Réponse en Cybersécurité.',
      runResponsePlanTitle: "Avez-vous besoin d'aide mais êtes-vous incapable de vous connecter ?",
      registrationFailed: "Échec de l'inscription. Veuillez réessayer.",
      invalidInvite: "Lien d'invitation invalide ou expiré.",
      createYourProtexxa: 'Créez votre compte Protexxa',
      inviteSubtitle: 'Configurez votre compte pour sécuriser vos données et rester protégé.',
      placeholders: {
        fullName: 'Insérez votre nom complet',
        email: 'Insérez votre adresse e-mail',
        phoneNumber: 'Code pays',
      },
      validation: {
        userEmail: {
          email: "L'e-mail doit être valide",
          required: "L'e-mail est requis",
        },
        password: 'Le mot de passe est requis',
        fullname: 'Le nom complet est requis',
        firstname: 'Le prénom est requis',
        lastname: 'Le nom de famille est requis',
        email: {
          required: "L'e-mail est requis",
          email: "L'e-mail n'est pas valide",
        },
        phone: {
          required: 'Le téléphone est requis',
          matches: 'Le téléphone est requis',
          long: 'Le numéro de téléphone est trop long',
          short: 'Le numéro de téléphone est trop court',
          empty: 'Le téléphone est requis',
          valid: "Le téléphone n'est pas valide",
        },
        passwordMin: 'Le mot de passe est trop court - il doit contenir au moins 12 caractères.',
        passwordMatches:
          'Doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial',
        confirmPassword: {
          required: 'La confirmation du mot de passe est requise',
          oneOf: 'Les deux mots de passe doivent être identiques',
        },
      },
    },
    thankYouPage: {
      title: "Merci d'avoir soumis le formulaire.",
      body: 'Notre Protexxa Concierge répondra à votre question ou à votre problème et vous répondra dans les 24 prochaines heures ouvrables.',
      button: 'Retour au tableau de bord',
      buttonConcierge: "Retour à la page d'accueil",
    },
    maintenance: {
      title: 'Nous reviendrons bientôt!',
      body: 'La page que vous recherchez est actuellement en maintenance et sera disponible dès que possible. Nous nous excusons pour tout inconvénient.',
      button: 'Contactez le support',
    },
    salesforce: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      company: 'Entreprise',
      email: 'E-mail',
      country: 'Pays',
      phone: 'Téléphone',
      industry: 'Industrie',
      interest: "Qu'est-ce qui vous intéresse? Sélectionnez tout ce qui s'y rapporte.",
      description: 'Comment pouvons-nous aider autrement?',
      submit: 'Soumettre',
      errorFirstName: 'Le prénom est requis',
      errorLastName: 'Le nom de famille est requis',
      errorEmail: "L'e-mail est requis",
      errorCountry: 'Le pays est requis',
      protexxaTerms:
        "Protexxa respecte votre vie privée et n'utilisera vos informations personnelles que pour gérer votre compte et fournir les produits et services demandés. Périodiquement, nous pouvons vous contacter au sujet de nos offres et d'autres contenus susceptibles de vous intéresser.",
      userConfirm:
        'En cliquant sur Soumettre ci-dessous, vous consentez à ce que Protexxa Inc. stocke et traite les informations personnelles soumises ci-dessus pour vous fournir le contenu demandé.',
      userAgreement: "J'accepte de recevoir des communications de Protexxa Inc.",
      firstNamePlaceholder: 'Insérez votre prénom',
      lastNamePlaceholder: 'Insérez votre nom de famille',
      companyPlaceholder: 'Insérez le nom de votre entreprise',
      countryPlaceholder: 'Insérez votre pays',
      emailPlaceholder: 'Insérez votre adresse e-mail',
      phonePlaceholder: '+0 (00) 000-0000',
      descriptionPlaceholder: 'Écrivez-nous un message.',
      interestPlaceholder: 'Quels sont vos intérêts?',
      industryPlaceholder: "Sélectionnez l'industrie",
      interests: {
        defenderpricing: 'Tarification de Defender',
        educationandtraining: 'Éducation et Formation',
        consulting: 'Consultation',
        generalinformation: 'Informations Générales',
        demonstration: 'Démonstration',
      },
      industries: {
        none: '--Aucun--',
        agriculture: 'Agriculture',
        apparel: 'Vêtements',
        banking: 'Banque',
        biotechnology: 'Biotechnologie',
        chemicals: 'Produits chimiques',
        communications: 'Communications',
        construction: 'Construction',
        consulting: 'Conseil',
        education: 'Éducation',
        electronics: 'Électronique',
        energy: 'Énergie',
        engineering: 'Ingénierie',
        entertainment: 'Divertissement',
        environmental: 'Environnement',
        finance: 'Finance',
        government: 'Gouvernement',
        healthcare: 'Soins de santé',
        hospitality: 'Hôtellerie',
        insurance: 'Assurance',
        machinery: 'Machines',
        manufacturing: 'Fabrication',
        media: 'Médias',
        notforprofit: 'Sans But Lucratif',
        other: 'Autre',
        recreation: 'Loisirs',
        retail: 'Détail',
        shipping: 'Expédition',
        technology: 'Technologie',
        telecommunications: 'Télécommunications',
        transportation: 'Transport',
        utilities: 'Services Publics',
        accounting: 'Comptabilité',
        airlinesaviation: 'Compagnies Aériennes/Aviation',
        alternativedisputeresolution: 'Résolution Alternative des Conflits',
        alternativemedicine: 'Médecine Alternative',
        animation: 'Animation',
        apparelfashion: 'Mode et Vêtements',
        architectureplanning: 'Architecture et Urbanisme',
        artsandcrafts: 'Arts et Artisanat',
        automotive: 'Automobile',
        aviationaerospace: 'Aviation & Aérospatiale',
        broadcastmedia: 'Médias de Diffusion',
        buildingmaterials: 'Matériaux de Construction',
        businesssuppliesandequipment: "Fournitures et Équipement d'Entreprise",
        capitalmarkets: 'Marchés de Capitaux',
        civicsocialorganization: 'Organisation Civique et Sociale',
        civilengineering: 'Génie Civil',
        commercialrealestate: 'Immobilier Commercial',
        computernetworksecurity: 'Sécurité Informatique et Réseau',
        computergames: 'Jeux Vidéo',
        computerhardware: 'Matériel Informatique',
        computernetworking: 'Réseaux Informatiques',
        computersoftware: 'Logiciels Informatiques',
        consumerelectronics: 'Appareils Électroniques Grand Public',
        consumergoods: 'Biens de Consommation',
        consumerservices: 'Services aux Consommateurs',
        cosmetics: 'Cosmétiques',
        dairy: 'Laiterie',
        defensespace: 'Défense & Espace',
        design: 'Design',
        educationmanagement: "Gestion de l'Éducation",
        elearning: 'Apprentissage en Ligne',
        electricalelectronicmanufacturing: 'Fabrication Électrique/Électronique',
        environmentalservices: 'Services Environnementaux',
        eventsservices: 'Services Événementiels',
        executiveoffice: 'Bureau Exécutif',
        facilitiesservices: 'Services aux Installations',
        farming: 'Agriculture',
        financialservices: 'Services Financiers',
        fineart: 'Beaux-Arts',
        fishery: 'Pêche',
        foodbeverages: 'Aliments et Boissons',
        foodproduction: 'Production Alimentaire',
        fundraising: 'Collecte de Fonds',
        furniture: 'Meubles',
        gamblingcasinos: "Jeux d'Argent et Casinos",
        glassceramicsconcrete: 'Verre, Céramique et Béton',
        governmentadministration: 'Administration Gouvernementale',
        governmentrelations: 'Relations Gouvernementales',
        graphicdesign: 'Conception Graphique',
        healthwellnessandfitness: 'Santé, Bien-Être et Remise en Forme',
        highereducation: 'Enseignement Supérieur',
        hospitalhealthcare: 'Hospital & Soins de Santé',
        humanresources: 'Ressources Humaines',
        importandexport: 'Importation et Exportation',
        individualfamilyservices: 'Services pour la Famille et Individuels',
        industrialautomation: 'Automatisation Industrielle',
        informationservices: 'Services Informatiques',
        informationtechnologyandservices: "Technologie de l'Information et Services",
        internationalaffairs: 'Affaires Internationales',
        internationaltradeanddevelopment: 'Commerce International et Développement',
        internet: 'Internet',
        investmentbanking: "Banque d'Investissement",
        investmentmanagement: "Gestion d'Investissement",
        judiciary: 'Judiciaire',
        lawenforcement: 'Application des Lois',
        lawpractice: 'Pratique Juridique',
        legalservices: 'Services Juridiques',
        legislativeoffice: 'Bureau Législatif',
        leisuretraveltourism: 'Loisirs, Voyage & Tourisme',
        libraries: 'Bibliothèques',
        logisticsandsupplychain: "Logistique et Chaîne d'Approvisionnement",
        luxurygoodsjewelry: 'Articles de Luxe & Bijouterie',
        managementconsulting: 'Conseil en Gestion',
        maritime: 'Maritime',
        marketresearch: 'Études de Marché',
        marketingandadvertising: 'Marketing et Publicité',
        mechanicalorindustrialengineering: 'Génie Mécanique ou Industriel',
        mediaproduction: 'Production Média',
        medicaldevices: 'Appareils Médicaux',
        medicalpractice: 'Pratique Médicale',
        mentalhealthcare: 'Soins de Santé Mentale',
        military: 'Militaire',
        miningmetals: 'Extraction et Métaux',
        motionpicturesandfilm: 'Films et Productions Cinématographiques',
        museumsandinstitutions: 'Musées et Institutions',
        music: 'Musique',
        nanotechnology: 'Nanotechnologie',
        newspapers: 'Journaux',
        nonprofitorganizationmanagement: "Gestion d'Organisations à But Non Lucratif",
        oilenergy: 'Pétrole & Énergie',
        onlinemedia: 'Média en Ligne',
        outsourcingoffshoring: 'Externalisation/Délocalisation',
        packagefreightdelivery: 'Livraison de Colis/Fret',
        packagingandcontainers: 'Emballage et Contenants',
        paperforestproducts: 'Papier & Produits Forestiers',
        performingarts: 'Arts de la Scène',
        pharmaceuticals: 'Produits Pharmaceutiques',
        philanthropy: 'Philanthropie',
        photography: 'Photographie',
        plastics: 'Plastiques',
        politicalorganization: 'Organisation Politique',
        primarysecondaryeducation: 'Éducation Primaire/Secondaire',
        printing: 'Impression',
        professionaltrainingcoaching: 'Formation et Coaching Professionnel',
        programdevelopment: 'Développement de Programmes',
        publicpolicy: 'Politique Publique',
        publicrelationsandcommunications: 'Relations Publiques et Communications',
        publicsafety: 'Sécurité Publique',
        publishing: 'Édition',
        railroadmanufacture: 'Fabrication Ferroviaire',
        ranching: 'Élevage',
        realestate: 'Immobilier',
        recreationalfacilitiesandservices: 'Installations et Services Récréatifs',
        religiousinstitutions: 'Institutions Religieuses',
        renewablesenvironment: 'Énergies Renouvelables et Environnement',
        research: 'Recherche',
        restaurants: 'Restaurants',
        securityandinvestigations: 'Sécurité et Enquêtes',
        semiconductors: 'Semi-conducteurs',
        shipbuilding: 'Construction Navale',
        sportinggoods: 'Articles de Sport',
        sports: 'Sports',
        staffingandrecruiting: 'Recrutement et Dotation en Personnel',
        supermarkets: 'Supermarchés',
        textiles: 'Textiles',
        thinktanks: 'Groupes de Réflexion',
        tobacco: 'Tabac',
        translationandlocalization: 'Traduction et Localisation',
        transportationtruckingrailroad: 'Transport/Camionnage/Ferroviaire',
        venturecapitalprivateequity: 'Capital Risque et Capital Privé',
        veterinary: 'Vétérinaire',
        warehousing: 'Entreposage',
        wholesale: 'Vente en Gros',
        wineandspirits: 'Vins et Spiritueux',
        wireless: 'Sans Fil',
        writingandediting: 'Rédaction et Édition',
      },
    },
    cybersecurityResponsePlan: {
      createResponseIntroduction: {
        introductionTitle: 'Créez votre plan de réponse en matière de cybersécurité',
        introductionBodyTop:
          'Nous sommes là pour vous aider à vous préparer au pire scénario : une faille de cybersécurité.',
        introductionBodyBottom:
          "En prenant quelques instants pour identifier vos actifs critiques, vous serez en mesure de créer un plan d'intervention personnalisé pour vous aider à réagir rapidement et efficacement en cas d'incident.",
        introductionButton: 'Commencer',
        modalTitle: 'Créez votre plan de réponse personnel en matière de cybersécurité',
        modalBody:
          "N'attendez pas qu'il soit trop tard pour vous protéger des cybermenaces. Identifiez vos actifs critiques et obtenez un guide étape par étape sur la façon de réagir à tout incident.",
        modalButtonConfirm: 'Créer mon plan de réponse à la cybersécurité',
        modalButtonCancel: 'Rappelez-moi plus tard',
      },
      createResponsePlanModal: {
        modalTitle: 'Créez votre plan de réponse personnel en matière de cybersécurité',
        modalBody:
          "N'attendez pas qu'il soit trop tard pour vous protéger des cybermenaces. Identifiez vos actifs critiques et obtenez un guide étape par étape sur la façon de réagir à tout incident.",
        modalButtonConfirm: 'Créer mon plan de réponse à la cybersécurité',
        modalButtonCancel: 'Rappelez-moi plus tard',
        success: 'Succès!',
        error: "Erreur lors de la tentative de communication avec l'API!",
      },
      form: {
        criticalContacts: {
          title: 'Contacts critiques',
          description:
            'Préparez-vous aux incidents de cybersécurité en organisant vos contacts clés. Fournissez les coordonnées de la famille, des amis et des associés professionnels, pour plus d’assurance.',
          checkText: "Pas maintenant, j'ajouterai mes contacts plus tard.",
          helpTitle: 'Pourquoi devrais-je ajouter des contacts critiques ?',
          helpText:
            "Lors d’une urgence de cybersécurité, une communication et une coordination rapides sont cruciales. En disposant de contacts précis et facilement disponibles, nous pouvons garantir des actions de réponse rapides et minimiser l'impact potentiel d'un incident.",
        },
        bankComponent: {
          title: 'Contacts critiques',
          description:
            'Préparez-vous en gardant accessibles les principaux contacts des banques et des institutions financières. Partagez les coordonnées de vos banques pour vous assurer que vous êtes prêt à faire face à tout incident de cybersécurité.',
          checkText: "Pas maintenant, j'ajouterai cette information plus tard.",
          helpTitle: 'Pourquoi dois-je informer ma banque ou mon établissement financier ?',
          helpText:
            "Grâce à ces informations, en cas d'incident, nous pouvons vous aider à contacter vos institutions financières respectives plus rapidement et plus précisément.",
          saveButton: 'Sauvegarder les modifications',
          updateErrorMessage: 'Erreur lors de la mise à jour!',
          updateSuccessMessage: 'Mise à jour effectuée avec succès!',
        },
        steps: 'pas',
        generateResponsePlan: 'Générer un plan de réponse',
        card: {
          familyTitle: 'Amis de la famille',
          familySubtitle:
            "En cas de violation cybernétique, nous serons en mesure d'envoyer des notifications SMS et des courriels personnalisés à vos contacts critiques.",
          bankTitle: 'Banques et institutions financières',
          employmentProfessionalTitle: 'Emploi & Professionnel',
          name: 'Nom',
          search: 'Recherche',
          bankName: 'Nom de la banque',
          relationship: 'Relation',
          placeHolderRelationship: 'e.g. père, conjoint, frère',
          placeHolderRelationshipWork: 'e.g. supérieur, collègue',
          phoneNumber: 'Numéro de téléphone',
          addMore: 'Ajouter plus',
          cancelButton: 'Annuler',
          addBankButton: 'Ajouter une banque',
          inputLabel: 'Sélectionnez les banques avec lesquelles vous avez actuellement des comptes',
          addManually: 'Ajouter manuellement',
          contactDescription:
            'En cas de cyber-violation, nous pourrons envoyer des notifications par SMS et des e-mails personnalisés à vos contacts critiques.',
          contact: 'Contact',
          errorGetBanks: 'Erreur lors de la tentative de chargement des banques!',
          validation: {
            name: 'Le nom est requis',
            email: 'Ce champ est requis.',
            phone: 'Ce champ est requis.',
          },
        },
        validation: {
          email: 'Doit être un email valide',
          requiredField: 'Ce champ est obligatoire',
          name: 'Le nom est requis',
          relationship: 'La relation est requise',
        },
        createErrorText: "Erreur lors de la tentative de création d'un plan de réponse.",
        createSuccess: 'Succès!',
      },
      responsePlanOverview: {
        page: {
          responsePlan: 'Plan de Réponse',
          emergencyContacts: 'Contacts Critiques',
          myAssets: 'Banques et contacts financiers',
          responsePlanAccessCode: "Code d'Accès au Plan de Réponse",
          responsePlanAccessCodeTooltip: {
            left: "En cas de violation cybernétique et de perte d'accès à la plateforme, visitez",
            link: '{{defenderUrl}}/responseplan',
            right: 'et saisissez ce code pour accéder à votre plan de réponse.',
          },
          listQuestions: {
            notShowing: {
              not: 'Pas',
              showing: 'affichage',
              ignoredActions: 'actions ignorées',
            },
            hideActions: 'Cacher les actions',
            showActions: 'Afficher les actions',
          },
          questions: {
            checks: {
              disconnectImpactedDevices:
                "Déconnectez et éteignez le(s) appareil(s) affecté(s) du réseau s'il s'agit d'un problème lié à l'ordinateur. Retirez tout lecteur USB.",
              notifyContactList:
                "Informer la liste de contacts des principales parties prenantes concernant l'incident cybernétique.",
              notifyLocalAuthorities:
                "Signaler l'incident aux autorités locales et aux fournisseurs de services répertoriés ci-dessous, et prendre note du numéro de rapport pour référence.",
              notifyBanks:
                "Si votre compte bancaire ou vos cartes de crédit sont impliqués, signalez-le et annulez les cartes immédiatement pour éviter d'être responsable des pertes.",
              callMainCreditAgencies:
                'Appelez les principales agences de crédit de votre pays et placez une alerte de fraude sur votre rapport de crédit.',
              notifyIdentityServices:
                "Si votre pièce d'identité fédérale, passeport, carte de sécurité sociale ou mots de passe ont été compromis, contactez les services ci-dessous pour le signaler.",
              notifyCanadianAntiFraudCentre:
                "En cas d'incidents de fraude, y compris les courriels ou messages texte de phishing, contactez les services ci-dessous.",
              reviewAllAccountActivity:
                'Examinez toutes les activités de votre compte en ligne pour les connexions non autorisées et déconnectez-vous de tous les appareils connectés.',
              callCompanyWhereIdentityWasUsed:
                'Appelez les entreprises où votre identité a été utilisée. Elles vous indiqueront quelles informations sont nécessaires, si une enquête a été ouverte et comment vous pouvez récupérer après cette compromission.',
              enableGoogleAlerts:
                "Activez les alertes Google pour rester informé de tout ce qui concerne vos informations personnelles. Une fois que vous l'avez configuré, vous recevrez des notifications par e-mail chaque fois que Google trouve de nouveaux résultats sur les sujets qui vous intéressent.",
            },
            ignore: 'Ignorer',
            restore: 'Restaurer',
            cards: {
              familyFriends: 'Famille et amis',
              employmentProfessional: 'Emploi et professionnels',
              contacts: 'Contacts',
              peopleWillBeNotified: 'Les personnes seront informées',
              findDetachment: 'Trouver un détachement RCMP',
              googleAlerts: 'En savoir plus sur les alertes Google',
            },
          },
        },
        initialModal: {
          title: "Nous avons généré votre plan d'intervention en cas de cybersécurité",
          firstParagraph:
            "Votre plan est accompagné d'un code unique à utiliser en cas de violation de la cybersécurité et de perte d'accès à la plateforme.",
          secondParagraph: {
            left: 'Si vous rencontrez une telle situation, rendez-vous sur',
            right:
              'et saisissez le code fourni ci-dessous. Veuillez le conserver en toute sécurité hors ligne pour une sécurité accrue.',
          },
          checkBoxText: "J'ai enregistré en toute sécurité mon code unique de plan d'intervention.",
          seeResponsePlanButton: "Voir le plan d'intervention",
        },
        sendNotification: 'Envoyer une notification',
        editNotification: 'Modifier les informations',
        textCopied: 'Texte copié !',
        cardLevel: {
          title: 'Progrès du plan de réponse',
          abortPlanButton: 'Annuler le Plan',
          resetPlanButton: 'Réinitialiser le Plan',
          body: {
            safe: {
              textChart: 'Completed',
              textDecription:
                'Votre niveau actuel de sécurité en fonction des actions que vous avez entreprises dans votre plan de réponse.',
            },
            riskbelowfifty: {
              textChart: 'En Danger',
              textDecription:
                'Votre niveau actuel de sécurité en fonction des actions que vous avez entreprises dans votre plan de réponse.',
            },
            risk: {
              textChart: 'En Danger',
              textDecription:
                'Votre niveau actuel de sécurité en fonction des actions que vous avez entreprises dans votre plan de réponse.',
            },
            disabled: {
              textDecription:
                'Une fois que vous exécutez votre plan de réponse, nous suivrons les actions que vous avez entreprises et vous aiderons à déterminer votre niveau de protection. Vous pouvez également imprimer ces actions pour plus tard.',
            },
          },
        },
        overviewCard: {
          title: 'Votre Plan de Réponse Cybernétique Personnalisé',
          bodyText:
            'Suivez notre plan de réponse recommandé pour vous aider à rester en sécurité après une cyberattaque.',
          runResponsePlanButton: 'Exécuter le Plan de Réponse',
          downloadButton: 'Télécharger',
        },
        notificationModal: {
          modalTitleEmployment: "Aviser l'emploi & le professionnel",
          modalTitleFriends: 'Avertir la famille & les amis',
          modalBodyTitle:
            'Rédigez un message à envoyer à vos contacts critiques et informez-les de ce qui se passe. Toutes les personnes que vous avez ajoutées à la liste seront notifiées.',
          modalBody2Title: 'Message personnalisé',
          modalBody2Text:
            'Exemple : \n“ Salut tout le monde, \nMes comptes en ligne ont été compromis par une faille de cybersécurité. Méfiez-vous des e-mails ou des messages suspects provenant de mes comptes. \n\nJe travaille à résoudre ce problème. Merci de votre compréhension et de votre soutien .”',
          modalButtonSend: 'Envoyer une notification',
          modalButtonCancel: 'Annuler',
          successSendNotifications: 'Notifications envoyées avec succès !',
          errorSendNotifications: "Erreur lors de l'envoi des notifications!",
        },
      },
    },
    comingSoon: {
      title: 'À venir !',
      body: "La page que vous recherchez est en cours d'élaboration et sera dévoilée prochainement. Nous apprécions votre compréhension et nous nous excusons pour tout inconvénient que cela pourrait causer.",
      button: "Retour à la page d'accueil",
      titleNew: 'Cette fonctionnalité est actuellement en développement.',
      subtitleNew: 'À venir bientôt',
    },
    responsePlanAccessCode: {
      title: "Code de réponse à l'incident",
      subtitle: 'Veuillez vérifier vos informations pour continuer',
      labelAccessCode: 'Entrez votre code de plan de réponse unique',
      labelDateBirth: 'Date de Naissance.',
      continue: 'Continuez',
      errorMessage: 'Échec de récupération du plan de réponse!',
      validation: {
        accessCode: 'Le code du plan de réponse est requis',
        birthDate: 'La date de naissance valide est requise',
      },
    },
    termsOfService: {
      title: 'Conditions générales',
      date: 'Le 28 août 2023',
      generalTerms: {
        title: 'Conditions générales',
        desc: {
          line1:
            'En accédant à Protexxa et en passant une commande, vous confirmez que vous acceptez les conditions de service exposées dans les Conditions générales ci‑dessous et qu’elles vous lient. Ces conditions s’appliquent à l’ensemble du site Web, au service et à tous les courriels ou communications entre vous et Protexxa.',
        },
      },
      license: {
        title: 'Licence',
        desc: {
          line1:
            'Protexxa vous accorde une licence révocable, non exclusive, non transférable et limitée vous permettant de télécharger, d’installer et d’utiliser l’Application ou la plateforme en conformité stricte avec les conditions du présent Accord.',
          line2: `Les présentes Conditions générales constituent un contrat entre vous et Protexxa (désignée dans les présentes Conditions générales par « Protexxa », « nous », « nos » ou « notre »), le fournisseur du site Web de Protexxa et des services accessibles à partir du site Web de Protexxa (qui sont collectivement désignés dans les présentes Conditions générales par le « Service Protexxa »).`,
          line3: `Vous acceptez d’être lié par les présentes Conditions générales. Si vous n’acceptez pas les présentes Conditions générales, veuillez ne pas utiliser le Service Protexxa. Dans les présentes Conditions générales, le terme « vous » fait référence à vous en tant que personne physique et à l’entité que vous représentez. Si vous enfreignez l’une de ces Conditions générales, nous nous réservons le droit d’annuler votre compte ou d’en bloquer l’accès, sans préavis.`,
        },
      },
      keyTerms: {
        title: 'Définitions et expressions clés',
        desc: {
          line1:
            'Afin que tout soit le plus clair possible dans les présentes Conditions générales, chaque fois qu’il est fait mention de l’un de ces termes, il est strictement défini comme suit :',
          list1:
            'Appareil : tout appareil connecté à Internet, tel qu’un téléphone, une tablette, un ordinateur ou tout autre appareil utilisé pour visiter les sites de Protexxa et en utiliser les services.',
          list2: 'Application : la plateforme Protexxa Defender et les services connexes.',
          list3:
            'Pays : où Protexxa, ses propriétaires ou ses fondateurs sont établis, dans ce cas‑ci en Ontario, au Canada',
          list4:
            'Service : le service fourni par Protexxa tel que décrit dans les conditions s’y rapportant (si accessibles) et sur cette plateforme.',
          list5:
            'Services tiers : les annonceurs, les commanditaires de concours, les partenaires promotionnels et marketing, et d’autres personnes qui fournissent notre contenu ou dont nous pensons que les produits ou services peuvent vous intéresser.',
          list6:
            'Société : Protexxa Inc. (16, Industrial Parkway Sud, bureau 115, Aurora (Ontario)  L4G 0R4), responsable de vos renseignements en vertu des présentes Conditions générales.',
          list7:
            'Témoin de connexion : une petite quantité de données générées par un site Web et enregistrées par votre navigateur Web. On l’utilise pour identifier votre navigateur, fournir des analyses et conserver des renseignements vous concernant, tels que vos préférences linguistiques ou vos données de connexion.',
          list8:
            'Vous et ses variantes : une personne ou une entité enregistrée auprès de Protexxa pour utiliser les Services.',
        },
      },
      restrictions: {
        title: 'Restrictions',
        desc: {
          line1:
            'Vous vous engagez à ne pas faire personnellement ce qui suit et à ne pas autoriser d’autres personnes à le faire :',
          list1:
            'Octroyer une licence sur l’application ou la plateforme, les vendre, les louer, les céder, les distribuer, les transmettre, les héberger, les impartir, les divulguer ou autrement exploiter commercialement l’Application ou mettre la plateforme à la disposition d’un tiers.',
          list2:
            'Modifier, réaliser des œuvres dérivées de toute partie de l’Application, la démonter, la déchiffrer, la compiler à rebours ou la désosser.',
          list3:
            'Supprimer, modifier ou masquer tout avis de propriété (y compris tout avis de droit d’auteur ou de marque de commerce) de Protexxa ou des membres de son groupe, de ses partenaires, de ses fournisseurs ou des concédants de licence de l’Application.',
        },
      },
      payment: {
        title: 'Paiement',
        desc: {
          line1:
            'Si vous vous inscrivez à l’un de nos modes de paiement récurrents, vous acceptez de payer tous les frais portés à votre compte pour le service selon les frais et conditions de facturation en vigueur au moment où chacun des frais est dû et payable. Sauf indication contraire dans un formulaire de commande, vous devez fournir à Protexxa une carte de crédit valide (Visa, Mastercard ou de tout autre émetteur que nous acceptons) (Fournisseur de paiement). Il s’agit d’une condition d’inscription au service. Le contrat de votre Fournisseur de paiement régit votre utilisation du compte de carte de crédit désigné, et vous devez vous référer à ce contrat et non aux présentes Conditions pour déterminer vos droits et responsabilités envers votre Fournisseur de paiement. En fournissant votre numéro de carte de crédit et les renseignements de paiement connexes à Protexxa, vous acceptez qu’elle soit autorisée à vérifier ces renseignements immédiatement et à facturer par la suite votre compte pour tous les frais qui lui sont dus et payables en vertu des présentes et qu’aucun autre avis ou consentement ne soit requis. Vous acceptez d’informer immédiatement Protexxa de tout changement d’adresse de facturation ou de carte de crédit utilisée pour le paiement. Protexxa se réserve le droit de modifier ses prix et ses méthodes de facturation, avec effets immédiats, en les publiant sur son site ou par l’envoi d’un courriel à ou aux administrateurs de votre organisation.',
          line2:
            'Les honoraires d’avocat, les frais de justice ou les autres frais engagés pour le recouvrement des montants en souffrance et non contestés sont à la charge et sous la responsabilité de l’utilisateur.',
          line3:
            'Aucun contrat n’existera entre vous et Protexxa pour le service tant que Protexxa n’aura pas accepté votre commande par un courriel de confirmation, un message SMS ou MMS ou tout autre moyen de communication approprié.',
          line4:
            'Vous êtes responsable des frais de tiers que vous pourriez supporter lors de l’utilisation du service.',
          line5:
            'Si vous êtes utilisateur d’un partenaire payant (un client B2B), il se peut qu’il n’y ait pas de frais. ',
        },
      },
      refund: {
        title: 'Politique de retour et de remboursement',
        desc: {
          line1: `Une fois que vous êtes abonné à un plan, vous êtes facturé automatiquement chaque mois ou année en fonction de la date de votre abonnement. Lorsque vous annulez votre abonnement, vous annulez le renouvellement automatique et nous conservons un accès complet à l’outil jusqu’à la fin de votre cycle de facturation.  Nous n’offrons pas de remboursement pour nos abonnements mensuels. Vous pouvez avoir droit à un remboursement partiel si vous annulez un abonnement annuel dans les 30 premiers jours de la date de renouvellement.`,
        },
      },
      personalInformation: {
        title: 'Utilisation des renseignements personnels ',
        desc: {
          line1: `Lorsque vous vous inscrivez pour un compte ou que vous utilisez l’Application de Protexxa, vous ne devez fournir que des renseignements personnels exacts et à jour. Il vous est strictement interdit d’utiliser ou de fournir des renseignements personnels appartenant à une autre personne sans son consentement explicite.`,
          line2:
            'En vous inscrivant et en utilisant l’Application de Protexxa, vous déclarez que :',
          list1:
            'Vous n’utiliserez vos renseignements personnels que pour créer votre compte et y accéder. ',
          list2: 'Vous n’avez pas usurpé ni volé l’identité d’une autre personne. ',
          list3: 'Tous les renseignements personnels fournis sont exacts, complets et à jour. ',
          line3: `Si Protexxa apprend ou soupçonne que vous avez fourni ou utilisé les renseignements personnels d’une autre personne sans l’autorisation appropriée, Protexxa se réserve le droit de suspendre ou de résilier votre compte et l’accès à l’Application. Les utilisateurs qui utilisent des renseignements personnels sans autorisation peuvent faire l’objet de poursuites.`,
        },
      },
      suggestions: {
        title: 'Vos suggestions',
        desc: {
          line1: `Tout commentaire ou toute rétroaction, idée, amélioration, suggestion (collectivement, les « Suggestions ») que vous fournissez à Protexxa concernant l’Application demeurera la propriété unique et exclusive de Protexxa.`,
          line2:
            'Protexxa est libre d’utiliser, de copier, de modifier, de publier ou de redistribuer les Suggestions à toute fin et de quelque manière que ce soit, sans vous accorder de crédit ou d’indemnité.',
        },
      },
      consent: {
        title: 'Votre consentement',
        desc: {
          line1: `Nous avons mis à jour nos Conditions générales afin d’assurer une transparence totale sur ce qui est vu lorsque vous visitez notre site et sur l’usage qui en est fait. En utilisant notre Application, en créant un compte ou en effectuant un achat, vous acceptez nos Conditions générales.`,
        },
      },
      api: {
        title: 'Liens vers d’autres sites Web ou interfaces de protocole d’application',
        desc: {
          line1: `Les Conditions générales ne s’appliquent qu’aux Services Protexxa. Les Services peuvent contenir des liens vers d’autres sites Web qui ne sont pas exploités ni contrôlés par Protexxa. Nous ne sommes pas responsables du contenu, de l’exactitude ou des opinions exprimées sur ces sites Web, dont nous ne contrôlons ni l’exactitude ni l’exhaustivité. N’oubliez pas que lorsque vous utilisez un lien pour passer des Services à un autre site Web, nos Conditions générales ne s’appliquent plus. La navigation et l’interaction sur tout autre site Web, y compris ceux ayant un lien sur notre plateforme, sont soumises aux règles et politiques de cet autre site Web. Ces tiers peuvent utiliser leurs propres témoins de connexion ou d’autres méthodes pour recueillir des renseignements vous concernant.`,
        },
      },
      modifications: {
        title: 'Modifications à notre plateforme',
        desc: {
          line1:
            'Protexxa se réserve le droit de modifier, de suspendre ou d’interrompre, temporairement ou définitivement, l’Application ou tout service auquel elle se connecte, avec ou sans préavis et sans responsabilité envers vous.',
        },
      },
      updates: {
        title: 'Mises à jour de notre Application',
        desc: {
          line1: `Protexxa peut occasionnellement, apporter des optimisations ou des améliorations aux caractéristiques ou fonctionnalités de l’Application, ce qui peut comprendre des correctifs, des corrections de bogues, des mises à jour, des mises à niveau et d’autres modifications (« Mises à jour »).`,
          line2:
            'Les Mises à jour peuvent modifier ou supprimer certaines caractéristiques et fonctionnalités de l’Application. Vous acceptez que Protexxa n’ait aucune obligation i) de fournir des Mises à jour ou ii) de continuer à vous fournir ou à activer les caractéristiques et les fonctionnalités de l’Application.',
          line3:
            'Vous acceptez en outre que toutes les Mises à jour soient i) considérées comme faisant partie intégrante de l’Application et ii) soumises aux conditions générales du présent Accord.',
        },
      },
      thirdParty: {
        title: 'Services de tiers',
        desc: {
          line1: `Nous pouvons afficher, inclure ou rendre accessible du contenu de tiers (y compris des données, des renseignements, des applications et d’autres produits et services) ou fournir des liens vers des sites Web ou des services de tiers (« Services de tiers »).`,
          line2:
            'Vous reconnaissez et convenez que Protexxa n’est pas responsable des Services de tiers, notamment de leur exactitude, de leur exhaustivité, de leur actualité, de leur validité, de leur respect des droits d’auteur, de leur légalité, de leur décence, de leur qualité ou de tout autre aspect de ceux‑ci. Protexxa n’assume pas et n’a pas de responsabilité envers vous ou toute autre personne ou entité en ce qui concerne les Services de tiers.',
          line3:
            'Les Services de tiers et les liens vers ceux‑ci vous sont fournis uniquement pour vous faciliter la tâche; c’est entièrement à vos risques et sous réserve des conditions générales de ces tiers que vous y avez accès et les utilisez.',
        },
      },
      termination: {
        title: 'Durée et résiliation',
        desc: {
          line1:
            'Le présent Accord demeurera en vigueur jusqu’à ce qu’il soit résilié par vous ou par Protexxa.',
          line2:
            'Protexxa peut, à sa seule discrétion, à tout moment et avec ou sans raison, suspendre ou résilier cet Accord avec ou sans préavis.',
          line3:
            'Le présent Accord sera résilié immédiatement, sans préavis de Protexxa, si vous omettez de respecter l’une des dispositions du présent Accord. Vous pouvez résilier le présent Accord en fermant votre compte et en supprimant l’Application de votre appareil.',
          line4:
            'En cas de résiliation du présent Accord, vous devez cesser d’utiliser l’Application.',
          line5: `La résiliation du présent Accord ne limitera pas les droits ou les recours de Protexxa en droit ou en equity en cas de violation de votre part (pendant la durée du présent Accord) de l’une de vos obligations en vertu du présent Accord.`,
        },
      },
      copyRight: {
        title: 'Avis de violation de droits d’auteur',
        desc: {
          line1: `Si vous êtes titulaire d’un droit d’auteur ou mandataire d’un tel titulaire et que vous estimez qu’un élément de notre Application constitue une violation de votre droit d’auteur, veuillez nous contacter en fournissant les renseignements suivants : a) une signature physique ou électronique du titulaire du droit d’auteur ou d’une personne autorisée à agir en son nom; b) l’indication du matériel prétendument contrefait; c) vos coordonnées, y compris votre adresse, votre numéro de téléphone et un courriel; d) une déclaration de vous selon laquelle vous croyez de bonne foi que les titulaires du droit d’auteur n’autorisent pas l’utilisation du matériel; et e) l’affirmation que les renseignements contenus dans l’avis sont exacts et, sous peine de parjure, vous êtes autorisé à agir au nom du propriétaire.`,
        },
      },
      indemnification: {
        title: 'Indemnisation',
        desc: {
          line1: `Vous acceptez d’indemniser et de tenir Protexxa et des membres de son groupe, de ses sociétés mères, filiales, dirigeants, employés, mandataires, partenaires et concédants de licence (le cas échéant) à l’abri de toute réclamation ou demande, y compris les honoraires d’avocat raisonnables, due à vos actions suivantes ou en découlant :`,
          list1: '1. Utilisation de l’Application.',
          list2: '2. Violation du présent Accord ou de toute loi ou réglementation.',
          list3: '3. Violation de tout droit d’un tiers.',
        },
      },
      warranties: {
        title: 'Aucune garantie',
        desc: {
          line1: `L’Application est fournie « TELLE QUELLE » et « TELLE QU’ACCESSIBLE » avec tous les défauts et toutes les défectuosités, sans garantie. Dans la pleine mesure permise par la loi applicable, Protexxa, en son nom propre et au nom des membres de son groupe et leurs concédants de licence et fournisseurs de services respectifs, décline expressément toutes les garanties, qu’elles soient expresses, implicites, légales ou autres, en ce qui concerne l’Application, y compris toutes les garanties implicites de qualité marchande, d’adéquation à un usage particulier, de titre et d’absence de contrefaçon, et les garanties qui peuvent découler de la conduite habituelle, de l’exécution habituelle, de l’usage ou de la pratique commerciale. Sans limiter la portée de ce qui précède, Protexxa ne fournit aucune garantie ni aucun engagement et ne fait aucune déclaration de quelque nature que ce soit selon laquelle l’Application répondra à vos exigences, atteindra les résultats escomptés, sera compatible ou fonctionnera avec tout autre logiciel, application, système ou service, fonctionnera sans interruption, répondra à toute norme de performance ou de fiabilité ou sera exempte d’erreur ou que toute erreur ou tout défaut peut être ou sera corrigé.`,
          line2: `Sans limiter la portée de ce qui précède, ni Protexxa ni aucun de ses fournisseurs ne font de déclaration ou ne donnent de garantie de quelque nature que ce soit, expresse ou implicite, que :`,
          list1: `1. Le fonctionnement ou la disponibilité de l’Application, ou les renseignements, le contenu et les documents ou produits qui y sont inclus.`,
          list2: '2. L’Application sera ininterrompue ou exempte d’erreurs.',
          list3:
            '3. Les renseignements ou le contenu fournis par l’Application sont exacts, fiables ou actuels.',
          list4:
            '4. L’Application, ses serveurs, le contenu ou les courriels envoyés par Protexxa ou en son nom sont exempts de virus, de scripts, de chevaux de Troie, de vers, de logiciels malveillants, de bombes à retardement ou d’autres éléments nuisibles.',
          line3:
            'Certains ressorts territoriaux n’autorisent pas l’exclusion de garanties implicites ou les restrictions aux droits d’un consommateur prévus par la loi applicable, de sorte que certaines ou la totalité des exclusions et restrictions susmentionnées pourraient ne pas s’appliquer à vous.',
        },
      },
      limitation: {
        title: 'Limitation de la responsabilité',
        desc: {
          line1:
            'Nonobstant tout dommage que vous pourriez subir, l’entière responsabilité de Protexxa et de ses fournisseurs en vertu de toute disposition du présent Accord et votre recours exclusif pour tout ce qui précède sera limité au montant que vous aurez payé pour l’Application.',
          line2:
            'Dans la pleine mesure permise par la loi applicable, Protexxa ou ses fournisseurs ne seront en aucun cas responsables des dommages‑intérêts spéciaux, accessoires, indirects ou consécutifs, quels qu’ils soient (y compris, notamment, les dommages pour perte de profits, de données ou d’autres renseignements, pour interruption d’activités commerciales, pour préjudice corporel, pour atteinte à la vie privée découlant des événements suivants ou y étant liés de quelque manière que ce soit : l’utilisation ou l’incapacité d’utilisation de l’Application, des logiciels de tiers et du matériel de tiers utilisés avec l’Application, ou autrement en relation avec toute disposition du présent Accord), même si Protexxa ou tout fournisseur a été informé de la possibilité de tels dommages et même si le recours n’atteint pas son objectif essentiel.',
          line3:
            'Certains états ou territoires n’autorisent pas l’exclusion ou la limitation des dommages accessoires ou indirects, de sorte que la limitation ou l’exclusion susmentionnée peut ne pas s’appliquer à vous.',
        },
      },
      severability: {
        title: 'Divisibilité',
        desc: {
          line1:
            'Si une disposition du présent Accord est jugée inapplicable ou invalide, cette disposition sera modifiée et interprétée de manière à atteindre ses objectifs dans toute la mesure du possible en vertu de la loi applicable, et les autres dispositions demeureront pleinement en vigueur.',
          line2: `Le présent Accord, la Politique de confidentialité et tout autre avis juridique publié par Protexxa sur les Services, constituent l’intégralité de l’accord entre vous et Protexxa au sujet des Services. Si une disposition du présent Accord est jugée invalide par un tribunal compétent, l’invalidité de cette disposition n’altérera pas la validité des autres dispositions du présent Accord, qui demeureront pleinement en vigueur. Aucune renonciation à une des Conditions du présent Accord n’est réputée constituer une renonciation supplémentaire ou continue à cette condition ou à toute autre condition, et le défaut de Protexxa de faire valoir un droit ou une disposition aux termes du présent Accord ne constitue pas une renonciation à ce droit ou à cette disposition. VOUS ET PROTEXXA CONVENEZ QUE TOUTE CAUSE D’ACTION DÉCOULANT DES, SERVICES OU LIÉE À CEUX‑CI, DOIT ÊTRE INTENTÉE DANS UN DÉLAI D’UN (1) AN À COMPTER DE LA SURVENANCE DE LA CAUSE D’ACTION. DANS LE CAS CONTRAIRE, LA CAUSE D’ACTION EST PRESCRITE DÉFINITIVEMENT.`,
        },
      },
      waiver: {
        title: 'Renonciation',
        desc: {
          line1: `Sauf dans les cas prévus par le présent Accord, le fait de ne pas exercer un droit ou de ne pas exiger l’exécution d’une obligation en vertu du présent Accord n’altère pas la capacité d’une partie à exercer ce droit ou à exiger cette exécution à tout moment par la suite, et la renonciation à invoquer une violation ne constitue pas une renonciation à invoquer toute violation ultérieure.`,
          line2:
            'L’absence d’exercice et le retard dans l’exercice, par l’une ou l’autre partie, d’un droit ou d’un pouvoir en vertu du présent Accord ne constituent pas une renonciation à ce droit ou à ce pouvoir. L’exercice unique ou partiel d’un droit ou d’un pouvoir en vertu du présent Accord n’exclut pas non plus l’exercice ultérieur de ce droit ou de tout autre droit accordé par les présentes. En cas de conflit entre le présent Accord et toute condition d’achat ou autre condition applicable, les conditions du présent Accord prévalent.',
        },
      },
      amendments: {
        title: 'Modification aux conditions générales ',
        desc: {
          line1:
            'Protexxa se réserve le droit, à sa seule discrétion, de modifier ou de remplacer ces Conditions à tout moment. Si une révision est importante, nous en donnerons un avis avant l’entrée en vigueur de nouvelles conditions. Ce qui constitue un changement important sera déterminé à notre seule discrétion.',
          line2:
            'En continuant d’accéder à notre Application ou de l’utiliser après l’entrée en vigueur de toute révision, vous acceptez d’être lié par les conditions révisées. Si vous êtes en désaccord avec les nouvelles conditions, vous ne pouvez plus utiliser Protexxa.',
        },
      },
      entireTerms: {
        title: 'Intégralité des Conditions générales',
        desc: {
          line1:
            'Ces Conditions générales constituent l’ensemble des conditions entre vous et Protexxa concernant l’utilisation de votre Application et remplacent toutes les conditions écrites ou verbales antérieures et contemporaines entre vous et Protexxa.',
          line2:
            'Vous pouvez être soumis à des conditions générales supplémentaires lorsque vous utilisez ou achetez d’autres services de Protexxa, que celle‑ci vous fournira au moment de cette utilisation ou de cet achat.',
        },
      },
      updatesTerms: {
        title: 'Mises à jour de nos Conditions',
        desc: {
          line1:
            'Il se peut que nous ayons à modifier nos services et politiques et conséquemment, les présentes Conditions, afin de refléter correctement nos services et politiques. À moins d’exigences contraires de la loi, nous vous en aviserons (par exemple, par l’entremise de notre service) avant d’apporter des modifications aux présentes Conditions et vous permettrons de les examiner avant leur entrée en vigueur. Ensuite, si vous continuez d’utiliser le service, vous serez lié par les Conditions à jour. Si vous ne souhaitez pas accepter ces Conditions ou toute autre mise à jour, vous pouvez supprimer votre compte.',
        },
      },
      intellectualProperty: {
        title: 'Propriété intellectuelle',
        desc: {
          line1:
            'L’Application et l’ensemble de son contenu, de ses caractéristiques et de ses fonctionnalités (y compris, notamment, tous les renseignements, les logiciels, les textes, les affichages, les images, les vidéos et les sons, ainsi que la conception, la sélection et la disposition de ceux‑ci) sont la propriété de Protexxa, de ses concédants de licence ou d’autres fournisseurs de ce matériel. Elle est protégée par les lois de la province de l’Ontario et les lois internationales sur les droits d’auteur, les marques de commerce, les brevets, les secrets commerciaux et autres droits de propriété intellectuelle ou exclusifs. Le matériel ne peut être copié, modifié, reproduit, téléchargé ou distribué de quelque manière que ce soit, en tout ou en partie, sans l’autorisation écrite expresse et préalable de Protexxa, sauf dans les cas expressément prévus dans les présentes Conditions générales. Toute utilisation non autorisée du matériel est interdite.',
        },
      },
      agreementArbitrate: {
        title: 'Accord d’arbitrage',
        desc: {
          line1: `Le présent article s’applique à tout différend SAUF QU’IL N’INCLUT PAS LES DIFFÉRENDS RELATIFS AUX DEMANDES EN INJONCTION OU EN EQUITY QUANT À LA VALIDITÉ OU À L’EXERCICE DE VOS DROITS EN PROPRIÉTÉ INTELLECTUELLE OU DE CEUX DE Protexxa. Le terme différend désigne tout différend, action ou autre controverse entre vous et Protexxa concernant les Services ou le présent Accord, qu’il s’agisse d’un contrat, d’une garantie, d’un délit civil, d’une loi, d’un règlement, d’une ordonnance ou de tout autre fondement juridique ou en equity. Le différend sera interprété de la manière la plus large possible, conformément à la loi.`,
        },
      },
      dispute: {
        title: 'Avis de différend',
        desc: {
          line1:
            'En cas de litige, vous ou Protexxa devez remettre à l’autre un Avis de différend, une déclaration écrite indiquant le nom, l’adresse et les coordonnées de la partie qui la délivre, les faits à l’origine du différend et la réparation demandée. Vous devez envoyer tout Avis de différend par courriel à l’adresse suivante : learn@protexxa.com. Protexxa vous enverra tout Avis de différend par courrier à votre adresse connue ou à votre adresse courriel. Vous et Protexxa tenterez de résoudre tout différend par la négociation informelle dans les soixante (60) jours de la date de transmission de l’Avis de différend. Après soixante (60) jours, vous ou Protexxa pourrez intenter une procédure d’arbitrage.',
        },
      },
      arbitration: {
        title: 'Arbitrage obligatoire',
        desc: {
          line1: `Si vous et Protexxa n’arrivez pas à résoudre un différend par la négociation informelle, tout autre effort pour résoudre un différend sera mené exclusivement par un arbitrage obligatoire, comme décrit dans cette section. Vous renoncez au droit de plaider tous les différends (ou d’y participer en tant que partie ou membre d’un groupe de recours collectif) devant un juge ou un jury. Le différend sera réglé par un arbitrage obligatoire conformément aux règles d’arbitrage commercial de l’American Arbitration Association. L’une ou l’autre des parties peut demander à un tribunal compétent toute injonction interlocutoire ou provisoire nécessaire afin de protéger ses droits ou ses biens en attendant la fin d’un arbitrage. Tous les frais judiciaires, comptables et autres frais, honoraires et dépenses engagés par la partie qui a gain de cause sont à la charge de la partie perdante.`,
        },
      },
      submissions: {
        title: 'Communications et vie privée',
        desc: {
          line1:
            'Si vous communiquez ou publiez des idées, des suggestions créatives, des dessins, des photographies, des renseignements, des publicités, des données ou des propositions, y compris des idées de produits, de services, de caractéristiques, de technologies ou de promotions nouveaux ou améliorés, vous acceptez expressément que ces communications soient automatiquement traitées comme non confidentielles et non exclusives et qu’elles deviennent la propriété exclusive de Protexxa sans vous donner droit à quelque compensation ou crédit. Protexxa et les membres de son groupe n’ont aucune obligation concernant ces communications ou ces messages. Ils peuvent utiliser indéfiniment les idées contenues dans ces affichages ou ces publications à toutes fins, sur n’importe quel support, y compris, notamment, le développement, la fabrication et la commercialisation de produits et de services supposant l’utilisation de ces idées.',
        },
      },
      promotions: {
        title: 'Promotions',
        desc: {
          line1:
            'Protexxa peut occasionnellement inclure des concours, des promotions, des loteries ou d’autres activités (Promotions) qui exigent que vous soumettiez du matériel ou des renseignements vous concernant. Veuillez noter que toutes les Promotions peuvent être régies par des règles distinctes comportant des conditions d’admissibilité particulières, comme des restrictions quant à l’âge et à l’emplacement géographique. Il vous incombe de lire toutes les règles sur les Promotions pour déterminer si vous êtes admissible ou non à participer. Si vous participez à une Promotion, vous vous engagez à respecter toutes les règles sur les Promotions.',
          line2:
            'Des conditions générales supplémentaires peuvent s’appliquer à l’achat de biens ou de services sur ou par l’intermédiaire des Services, conditions générales qui sont intégrées au présent Accord par ce renvoi.',
        },
      },
      typographicalErrors: {
        title: 'Erreurs typographiques',
        desc: {
          line1:
            'Si un produit ou un service est listé à un prix incorrect ou avec des renseignements incorrects en raison d’une erreur typographique, nous avons le droit de refuser ou d’annuler toute commande passée pour le produit ou le service listé à un prix incorrect. Nous avons le droit de refuser ou d’annuler une telle commande, même si la commande a été confirmée et que votre carte de crédit a été débitée. Si votre carte de crédit a déjà été débitée pour l’achat et que vous annulez votre commande, nous émettrons immédiatement un crédit au montant porté à votre compte de carte de crédit ou à un autre compte de paiement.',
        },
      },
      miscellaneous: {
        title: 'Divers',
        desc: {
          line1:
            'Si, pour quelque raison que ce soit, un tribunal compétent estime qu’une disposition ou une partie des présentes Conditions générales est inapplicable, leurs autres dispositions demeureront pleinement en vigueur. Toute renonciation à une disposition des présentes Conditions générales ne pendra effet que si elle est faite par écrit et signée par un représentant autorisé de Protexxa. Protexxa aura droit à des injonctions à d’autres mesures de redressement en equity (sans obligation de remettre de garantie ou de caution) en cas de manquement réel ou appréhendé de votre part. Protexxa exploite et contrôle le Service Protexxa à partir de ses bureaux situés en Ontario, au Canada. Le service n’est pas destiné à être distribué ou utilisé par une personne ou une entité dans un ressort territorial ou un pays où une telle distribution ou utilisation serait contraire aux lois ou aux règlements. En conséquence, les personnes qui choisissent d’accéder au Service Protexxa à partir d’autres lieux le font de leur propre initiative et sont les seules responsables du respect des lois locales si et dans la mesure où celles‑ci sont applicables. Les présentes Conditions générales (qui comprennent et intègrent la Politique de confidentialité de Protexxa) comportent l’intégralité de l’entente et remplacent tous les accords antérieurs entre vous et Protexxa concernant la question et vous ne pouvez pas les changer ni les modifier. Les intertitres utilisés dans le présent Accord ne le sont que pour faciliter la lecture et n’ont aucune valeur juridique.',
        },
      },
      disclaimer: {
        title: 'Clause de non‑responsabilité',
        desc: {
          line1:
            'Protexxa n’est pas responsable du contenu, du code ni de toute autre imprécision.',
          line2: 'Protexxa ne fournit aucun cautionnement ni aucune garantie.',
          line3:
            'En aucun cas Protexxa ne sera responsable des dommages‑intérêts spéciaux, directs, indirects, consécutifs ou accessoires ni de tout autre dommage, qu’il s’agisse d’une action contractuelle, d’une négligence ou d’un autre délit, découlant de l’utilisation du service ou du contenu du service ou en rapport avec ceux‑ci. La Société se réserve le droit d’apporter des ajouts, des suppressions ou des modifications au contenu du service à tout moment et sans préavis.',
          line4: `Le Service Protexxa et son contenu sont « tels quels » et « accessibles » sans garantie ni représentation, expresse ou implicite. Protexxa est un distributeur et non un éditeur du contenu fourni par des tiers; en tant que tel, Protexxa n’exerce aucun contrôle éditorial sur ce contenu et ne donne aucune garantie ou représentation quant à l’exactitude, la fiabilité ou l’actualité de tout renseignement, contenu, service ou marchandise fourni par l’intermédiaire du Service Protexxa ou accessible grâce à celui‑ci. Sans limiter la portée de ce qui précède, Protexxa décline expressément toutes les garanties et déclarations dans tout contenu transmis sur le Service Protexxa ou sur des sites pouvant apparaître comme des liens sur le Service Protexxa ou dans les produits fournis dans le cadre du Service Protexxa ou autrement en relation avec celui‑ci, ainsi que dans tout contenu transmis en relation avec le Service Protexxa ou les sites et produits décrits ci‑dessus, y compris, sans limitation, toute garantie de qualité marchande, d’adéquation à un usage particulier ou de non‑violation des droits des tiers. Aucun conseil oral ou renseignement écrit de Protexxa, de l’un des membres de son groupe, de ses employés, dirigeants, administrateurs, mandataires ou autres semblables ne crée de garantie. Les renseignements sur les prix et la disponibilité sont susceptibles d’être modifiés sans préavis. Sans restreindre la portée de ce qui précède, Protexxa ne garantit pas que le Service Protexxa sera ininterrompu, non corrompu, ponctuel, ou exempt d’erreurs.`,
        },
      },
      contactUs: {
        title: 'Nous contacter',
        desc: {
          line1: `N’hésitez pas à nous contacter si vous avez des questions.`,
          list1: 'Par courriel : learn@protexxa.com',
        },
      },
    },
    privacyPolicy: {
      title: 'POLITIQUE DE CONFIDENTIALITÉ PROTEXXA',
      date: '1ᵉʳ août 2023',
      desc: {
        line1:
          'Protexxa Inc. (« Protexxa », « nous », « notre » ou « nos ») s’engage à protéger votre vie privée. Cette Politique de confidentialité explique comment vos renseignements personnels sont recueillis, utilisés et divulgués par Protexxa.',
        line2:
          'La présente Politique de confidentialité s’applique à notre site Web et à ses sous‑domaines associés (collectivement, notre « Service ») ainsi qu’à nos applications. En accédant à notre service ou en l’utilisant, vous signifiez que vous avez lu, compris et accepté la cueillette, le stockage, l’utilisation et la divulgation de vos renseignements personnels, comme décrit dans la présente Politique de confidentialité et nos Conditions de service.',
      },
      definitionsTerms: {
        title: 'Définitions et expressions clés',
        desc: {
          line1:
            'Afin d’aider à expliquer les choses le plus clairement possible dans la présente Politique de confidentialité, chaque fois que l’un ou l’autre de ces termes est mentionné, ils sont strictement définis comme suit :',
          list1:
            'Adresse IP : Chaque appareil connecté à l’Internet se voit attribuer un numéro appelé « adresse de protocole Internet » (IP). Ces numéros sont généralement attribués par zones géographiques. Une adresse IP peut souvent être utilisée pour identifier l’emplacement à partir duquel un appareil se connecte à Internet.',
          list2:
            'Appareil : tout appareil connecté à Internet, comme un téléphone, une tablette, tel qu’un ordinateur ou tout autre appareil utilisé pour visiter Protexxa et utiliser les services.',
          list3:
            'Client : l’entreprise, l’organisation ou la personne qui s’inscrit pour utiliser le Service Protexxa afin de gérer les relations avec vos clients ou les utilisateurs de vos services',
          list4:
            'Données personnelles : tout renseignement qui, directement ou indirectement, ou pris en lien avec d’autres renseignements – incluant un numéro d’identification personnel – permet d’identifier ou de reconnaître une personne physique.',
          list5:
            'Pays : où Protexxa, ses propriétaires ou ses fondateurs sont établis, dans ce cas‑ci au Canada.',
          list6:
            'Personnel : des personnes qui sont employées par Protexxa ou qui sont sous contrat pour fournir un service au nom de l’une des parties.',
          list7:
            'Service : le service fourni par Protexxa tel que décrit dans les conditions s’y rapportant (si accessibles) et sur cette plateforme.',
          list8:
            'Services de tiers : les annonceurs, les commanditaires de concours, les partenaires promotionnels et marketing, et d’autres personnes qui fournissent notre contenu ou dont nous pensons que les produits ou services peuvent vous intéresser.',
          list9:
            'Société : dans cette politique, les termes « Société », « Protexxa », « nous », « notre » ou « nos », désignent Protexxa Inc. (16, Industrial Parkway Sud, bureau 115, Aurora (Ontario)  L4G 0R4), qui est responsable de vos renseignements en vertu de cette Politique de confidentialité.',
          list10:
            'Témoin de connexion : petite quantité de données générées par un site Web et enregistrées par votre navigateur Web. On l’utilise pour identifier votre navigateur, fournir des analyses et mémoriser des renseignements vous concernant, tels que vos préférences linguistiques ou vos données de connexion.',
          list11:
            'Vous (et l’utilisateur final) : une personne ou une entité inscrite auprès de Protexxa pour utiliser les Services.',
        },
      },
      collection: {
        title: 'Quels sont les renseignements que nous recueillons?',
        desc: {
          line1:
            'Nous recueillons des renseignements auprès de vous lorsque vous visitez notre site Web ou notre Application, que vous vous inscrivez sur notre site, que vous passez une commande, que vous utilisez la plateforme Protexxa Defender, que vous vous abonnez à notre bulletin d’information, que vous répondez à une enquête ou que vous remplissez un formulaire.',
          list1: 'Nom ou nom d’utilisateur',
          list2: 'Numéros de téléphone',
          list3: 'Adresses courriel',
          list4: 'Adresses postales',
          list5: 'Adresses de facturation',
          list6: 'Numéros de cartes de débit ou de crédit (pour les clients payants seulement)  ',
          list7: 'Âge',
          list8: 'Mot de passe',
          list9: 'Images',
          list10: 'Renseignements visant à améliorer l’expérience utilisateur et les services',
        },
      },
      endUserInfo: {
        title:
          'Quand Protexxa utilise‑t‑elle des renseignements sur les utilisateurs finaux provenant de tiers?',
        desc: {
          line1:
            'Protexxa recueille les données de l’utilisateur final nécessaires afin de fournir nos services à nos clients. Les utilisateurs finaux peuvent nous fournir volontairement des renseignements qu’ils ont rendus accessibles sur des sites Web publics. Une fois que vous avez fourni ces renseignements, Protexxa peut recueillir des renseignements accessibles au public auprès de tiers.',
        },
      },
      ecustomerInfo: {
        title:
          'Quand Protexxa utilise‑t‑elle des renseignements sur les utilisateurs provenant de tiers?',
        desc: {
          line1:
            'Protexxa utilise des renseignements provenant de tiers pour améliorer l’expérience utilisateur et les services. Cela inclut les renseignements fournis lors de l’inscription à la plateforme. ',
        },
      },
      shareInfo: {
        title: 'Partageons‑nous les renseignements que nous recueillons avec des tiers?',
        desc: {
          line1:
            'Nous pouvons partager les renseignements que nous recueillons, qu’ils soient personnels ou non, avec des tiers qui fournissent notre contenu ou dont les produits ou services apporteront une valeur ajoutée à votre expérience et/ou dont nous pensons qu’ils peuvent vous intéresser. Nous pouvons aussi les partager avec les sociétés membres de notre groupe et nos partenaires commerciaux, et si nous participons à une fusion, à une vente d’actifs ou à une autre réorganisation d’entreprise, nous pouvons également partager ou transférer vos renseignements, personnels ou non, à nos ayants cause.',
          line2:
            'Nous pouvons faire appel à des prestataires de services tiers de confiance pour exécuter des fonctions et nous fournir des services, tels que l’hébergement et la maintenance de nos serveurs et du site Web ou de l’Application, le stockage et la gestion des bases de données, la gestion du courrier électronique, le marketing de stockage, le traitement des cartes de crédit, le service à la clientèle, la gestion des sessions et l’exécution des commandes de produits et de services que vous pouvez acheter par l’intermédiaire du site Web ou de l’Application. Nous communiquerons probablement vos renseignements personnels, et possiblement certains renseignements non personnels, avec ces tiers pour leur permettre de fournir ces services, autant à vous qu’à nous.',
          line3:
            'Nous pouvons communiquer des parties de nos données de fichiers journaux, y compris les adresses IP, à des fins d’analyse avec des tiers tels que des partenaires d’analyse Web, des développeurs d’applications et des réseaux publicitaires. Si votre adresse IP est partagée, elle peut être utilisée pour estimer la localisation générale et d’autres données techniques telles que la vitesse de connexion, le fait que vous avez visité le site Web ou l’Application dans un lieu partagé et le type d’appareil utilisé pour visiter le site Web ou l’Application. Les tiers mentionnés ci‑dessus peuvent regrouper des renseignements sur notre publicité et sur ce que vous voyez sur le site Web ou l’application, puis produire des audits, des recherches et des rapports pour nous et nos annonceurs.',
          line4:
            'Nous pouvons également divulguer des renseignements vous concernant, qu’ils soient personnels ou non, à des autorités gouvernementales ou policières ou à des parties privées si nous le jugeons nécessaire ou approprié, à notre seule discrétion, pour répondre à des réclamations, à des procédures judiciaires (y compris des citations à comparaître), pour protéger nos droits et nos intérêts ou ceux d’un tiers, la sécurité du public ou de toute personne, pour prévenir ou faire cesser toute activité illégale, contraire à l’éthique ou susceptible de donner lieu à une action en justice, ou de respecter autrement les ordonnances des tribunaux, les lois, les règles et les règlements applicables.',
        },
      },
      whenCollectInfo: {
        title:
          'Où et quand les renseignements sont‑ils recueillis auprès des clients et des utilisateurs finaux?',
        desc: {
          line1:
            'Protexxa recueille les renseignements personnels que vous lui communiquez. Nous pouvons également recevoir des renseignements personnels vous concernant auprès de tiers, comme il est décrit ci‑dessus.',
        },
      },
      useInfo: {
        title: 'Comment utilisons‑nous les renseignements que nous recueillons?',
        desc: {
          line1:
            'Les renseignements que nous recueillons auprès de vous peuvent être utilisés à l’une des fins suivantes : ',
          list1:
            'Générer des évaluations de cybersécurité personnalisées pour les utilisateurs finaux',
          list2: 'Générer des résultats et des recommandations globaux',
          list3:
            'Personnaliser votre expérience (vos renseignements nous aident à mieux répondre à vos besoins individuels)',
          list4:
            'Améliorer notre site Web ou notre application (nous nous efforçons continuellement d’améliorer notre site Web ou notre application en fonction des renseignements recueillis et de vos commentaires)',
          list5:
            'Améliorer le service à la clientèle (vos renseignements nous aident à répondre plus efficacement à vos demandes de service à la clientèle et à vos besoins d’assistance)',
          list6: 'Traiter les transactions',
          list7:
            'Gérer un concours, une promotion, un sondage ou une autre caractéristique du site',
          list8: 'Transmettre des courriels périodiques',
        },
      },
      emailUse: {
        title: 'Comment utilisons‑nous votre adresse courriel?',
        desc: {
          line1:
            'Votre adresse courriel est utilisée pour vous fournir nos services et, en la communiquant sur ce site Web ou sur l’Application, vous acceptez de recevoir des courriels de notre part. Vous pouvez annuler votre participation à l’une ou l’autre de ces listes de courriels en tout temps en cliquant sur le lien de retrait ou sur une autre option de désabonnement incluse dans le courriel en question. Nous n’envoyons de courriels qu’aux personnes qui nous ont autorisés à les contacter, soit directement, soit par l’intermédiaire d’un tiers. En nous communiquant votre adresse courriel, vous acceptez également que nous l’utilisions pour atteindre notre public cible sur des sites tels que Facebook, où nous affichons des publicités personnalisées à des personnes particulières ayant choisi de recevoir des communications de notre part. Les adresses courriel communiquées uniquement par le biais de la page de traitement des commandes seront utilisées dans le seul but de vous envoyer des renseignements et des mises à jour concernant votre commande. Toutefois, si vous nous avez fourni la même adresse courriel selon une autre méthode, nous pouvons l’utiliser à l’une ou l’autre des fins énoncées dans la présente Politique. Remarque : À tout moment, si vous souhaitez vous désabonner de la réception de courriels futurs, nous incluons des instructions détaillées de désabonnement au bas de chaque courriel.',
        },
      },
      keepInfo: {
        title: 'Pendant combien de temps conservons‑nous vos renseignements personnels?',
        desc: {
          line1:
            'Nous ne conservons vos renseignements qu’aussi longtemps que nous en avons besoin afin de vous fournir des services et d’atteindre les objectifs décrits dans la présente politique. C’est également le cas de toute personne avec laquelle nous partageons vos renseignements et qui fournit des services en notre nom. Lorsque nous n’aurons plus besoin d’utiliser vos renseignements ni de les conserver pour nous conformer à nos obligations légales ou réglementaires, nous les retirerons de nos systèmes ou nous les dépersonnaliserons, afin de ne pas pouvoir vous identifier.',
        },
      },
      infoProtect: {
        title: 'Comment protégeons‑nous vos renseignements personnels?',
        desc: {
          line1:
            'Nous mettons en œuvre diverses mesures de sécurité afin de préserver la sécurité de vos renseignements personnels lorsque vous passez une commande ou lorsque vous saisissez ou communiquez vos renseignements personnels, ou que vous y accédez. Nous proposons l’utilisation d’un serveur sécurisé. Tous les renseignements sensibles ou de crédit fournis sont transmis grâce à la technologie du protocole SSL (de l’anglais Secure Socket Layer), puis cryptés dans la base de données de nos fournisseurs de passerelles de paiement, pour n’être accessibles qu’aux personnes autorisées disposant de droits d’accès spéciaux à ces systèmes et tenues de préserver la confidentialité de ces renseignements. Après une transaction, vos renseignements privés (cartes de crédit, numéros de sécurité sociale, données financières, etc.) ne sont jamais conservés à nos dossiers. Nous ne pouvons cependant pas assurer ou garantir la sécurité absolue des renseignements que vous transmettez à Protexxa ni garantir que vos renseignements sur le Service ne peuvent pas être consultés, divulgués, modifiés ou détruits par la violation de l’une de nos mesures de protection physiques, techniques ou de gestion.',
        },
      },
      infoTransfer: {
        title: 'Est‑ce que mes renseignements pourraient être transmis vers d’autres pays?',
        desc: {
          line1:
            'Protexxa est une société constituée en Ontario, au Canada. Les renseignements recueillis grâce à notre site Web ou à notre Application, par le biais d’interactions directes avec vous ou par l’utilisation de nos services d’assistance peuvent être transférés de temps à autre à nos bureaux ou à notre personnel, ou à des tiers, situés dans le monde entier, et peuvent être consultés et hébergés n’importe où dans le monde, y compris dans des pays où il n’existe pas de lois d’application générale régissant l’utilisation et le transfert de ces données. Dans la pleine mesure permise par la loi applicable, en utilisant l’un des éléments ci‑dessus, vous consentez volontairement au transfert transfrontalier et à l’hébergement de ces renseignements.',
        },
      },
      infoSecure: {
        title: 'Les renseignements recueillis par le biais du service Protexxa sont‑ils sécurisés?',
        desc: {
          line1:
            'Nous agissons avec précaution afin d’assurer la sécurité de vos renseignements. Nous disposons de procédures physiques, électroniques et administratives pour protéger vos renseignements personnels, prévenir l’accès non autorisé à ces derniers, maintenir leur sécurité et les utiliser correctement. Cependant, ni les gens ni les systèmes de sécurité ne sont infaillibles et cela vaut aussi pour les systèmes de chiffrement. De plus, les gens peuvent commettre des crimes intentionnellement, faire des erreurs ou ne pas respecter les politiques. Par conséquent, bien que nous fassions des efforts raisonnables pour protéger vos renseignements personnels, nous ne pouvons pas garantir leur sécurité absolue.  ',
        },
      },
      infoUpdate: {
        title: 'Puis‑je mettre à jour ou corriger mes renseignements personnels?',
        desc: {
          line1:
            'Votre droit de demander des mises à jour ou des corrections des renseignements recueillis par Protexxa dépend de votre relation avec celle‑ci. Les membres du personnel peuvent mettre à jour ou corriger leurs renseignements conformément aux politiques internes de la société en matière d’emploi.',
          line2:
            'Les clients ont le droit de demander la restriction de certains usages et de la communication de renseignements personnels identifiables comme suit. Vous pouvez nous contacter pour 1) mettre à jour ou corriger vos renseignements personnels, 2) modifier vos préférences en ce qui concerne les communications et autres renseignements que vous recevez de notre part, ou 3) supprimer les renseignements personnels conservés à votre sujet dans nos systèmes (sous réserve du paragraphe suivant), en annulant votre compte. Ces mises à jour, corrections, modifications et suppressions n’auront aucun effet sur les autres renseignements que nous conservons ou que nous avons fournis à des tiers conformément à la présente Politique de confidentialité avant la mise à jour, la correction, la modification ou la suppression en question. Afin de protéger votre vie privée et votre sécurité, nous pouvons prendre des mesures raisonnables (comme demander un mot de passe unique) pour vérifier votre identité avant de vous permettre d’avoir accès à votre profil ou de faire des corrections. Il vous incombe de toujours tenir secrets votre mot de passe et vos renseignements de compte uniques.',
          line3:
            'Vous devez savoir qu’il n’est pas technologiquement possible de supprimer de notre système chaque enregistrement des renseignements que vous nous avez fournis. Notre besoin de sauvegarder nos systèmes pour protéger les renseignements contre les pertes accidentelles signifie qu’une copie de vos renseignements peut exister sous une forme inaltérable qu’il nous sera difficile ou impossible de trouver. Dès réception de votre demande, tous les renseignements personnels stockés dans les bases de données que nous utilisons activement et dans d’autres supports facilement consultables seront mis à jour, corrigés, modifiés ou supprimés, selon le cas, dès que possible et dans la mesure où cela est raisonnablement et techniquement réalisable.',
          line4:
            'Si vous êtes un utilisateur final et que vous souhaitez mettre à jour, supprimer ou recevoir tous les renseignements que nous possédons à votre sujet, vous pouvez le faire en contactant Protexxa.',
        },
      },
      personnel: {
        title: 'Personnel',
        desc: {
          line1:
            'Si vous êtes un travailleur ou un candidat de Protexxa, nous recueillons les renseignements que vous nous fournissez volontairement. Nous utilisons les renseignements recueillis à des fins de ressources humaines pour gérer les avantages accordés aux travailleurs et présélectionner les candidats.',
          line2:
            'Vous pouvez nous contacter pour 1) mettre à jour ou corriger vos renseignements, 2) modifier vos préférences en ce qui concerne les communications et autres renseignements que vous recevez de notre part, ou 3) recevoir un enregistrement des renseignements dont nous disposons à votre sujet. Ces mises à jour, corrections, modifications et suppressions n’auront aucun effet sur les autres renseignements que nous conservons ou que nous avons fournis à des tiers conformément à la présente Politique de confidentialité avant la mise à jour, la correction, la modification ou la suppression en question.',
        },
      },
      saleBusiness: {
        title: 'Vente de l’entreprise',
        desc: {
          line1:
            'Nous nous réservons le droit de transférer des renseignements à un tiers dans le cas d’une vente, d’une fusion ou d’un autre transfert de la totalité ou de la quasi‑totalité des actifs de Protexxa ou de l’une des sociétés membres de son groupe (telles que définies aux présentes), ou de la partie de Protexxa ou de l’une des sociétés membres de son groupe à laquelle le service se rapporte, ou dans le cas où nous cesserions nos activités ou déposerions une requête ou dans le cas où requête en faillite, en réorganisation ou une procédure similaire serait déposée contre nous, pourvu que le tiers accepte de se conformer aux conditions de la présente Politique de confidentialité.',
        },
      },
      affiliates: {
        title: 'Membres de notre groupe',
        desc: {
          line1: `Nous pouvons communiquer des renseignements (y compris des renseignements personnels) vous concernant aux sociétés membres de notre groupe. Aux fins de la présente Politique de confidentialité, l’expression « membres de son (notre) groupe » désigne toute personne ou entité qui, directement ou indirectement, contrôle, est contrôlée par ou est sous contrôle commun avec Protexxa, que ce soit par la propriété ou autrement. Les renseignements vous concernant que nous fournissons aux sociétés membres de notre groupe seront traités par ces sociétés conformément aux conditions de la présente Politique de confidentialité.`,
        },
      },
      governingLaw: {
        title: 'Lois applicables',
        desc: {
          line1:
            'La présente Politique de confidentialité est régie par les lois de la province d’Ontario, au Canada, sans égard à ses dispositions en matière de conflits de lois. Vous consentez à la compétence exclusive des tribunaux relativement à toute action ou tout différend survenant entre les parties en vertu de la présente Politique de confidentialité ou en lien avec celle‑ci.',
          line2:
            'Les lois de l’Ontario, à l’exclusion des règles de conflit de lois, régissent le présent Accord et votre utilisation du site Web ou de l’Application. Votre utilisation du site Web ou de l’Application peut également être assujettie à d’autres lois locales, provinciales, nationales ou internationales.',
          line3:
            'En utilisant Protexxa ou en nous contactant directement, vous signifiez votre acceptation de cette Politique de confidentialité. Si vous n’acceptez pas la présente Politique de confidentialité, vous ne devez pas vous engager sur notre site Web ou notre Application, ni utiliser nos services. L’utilisation continue du site Web ou de l’Application, l’interaction directe avec nous ou la publication de changements à la présente Politique de confidentialité qui n’ont pas d’incidence importante sur l’utilisation ou la communication de vos renseignements personnels signifieront que vous acceptez ces changements.',
        },
      },
      consent: {
        title: 'Votre consentement',
        desc: {
          line1:
            'Nous avons mis à jour notre Politique de confidentialité afin d’assurer une transparence totale sur ce qui est vu lorsque vous visitez notre site et sur l’usage qui en est fait. En utilisant notre Application, en créant un compte ou en effectuant un achat, vous consentez par la présente à notre Politique de confidentialité et en acceptez les conditions.',
        },
      },
      linksWeb: {
        title: 'Liens vers d’autres sites Web.',
        desc: {
          line1:
            'La présente Politique de confidentialité s’applique uniquement aux Produits et Services Protexxa. Les Services peuvent contenir des liens vers d’autres sites Web qui ne sont pas exploités ni contrôlés par Protexxa. Nous ne sommes pas responsables du contenu, de l’exactitude ou des opinions exprimées sur ces sites Web, nous ne les vérifions pas, ne les contrôlons pas et nous ne nous assurons pas de leur exactitude ni de leur exhaustivité. N’oubliez pas que lorsque vous utilisez un lien pour passer des Services à un autre site Web, nos Conditions générales ne s’appliquent plus. La navigation et l’interaction sur tout autre site Web, y compris ceux ayant un lien sur notre plateforme, sont soumises aux règles et politiques qui lui sont propres. Ces tiers peuvent utiliser leurs propres témoins de connexion ou d’autres méthodes pour recueillir des renseignements vous concernant.',
        },
      },
      cookies: {
        title: 'Témoins de connexion',
        desc: {
          line1: `Protexxa utilise des « Témoins de connexion » pour identifier les zones de notre site Web ou notre Application que vous avez visités. Un Témoin de connexion est une petite pièce de données stockée sur votre ordinateur ou votre appareil mobile par votre navigateur Web. Nous en utilisons pour améliorer la performance et la fonctionnalité de notre site Web ou de notre Application, mais leur utilisation n’est pas essentielle. Sans eux, toutefois, certaines fonctionnalités comme les vidéos pourraient ne plus être accessibles, ou vous seriez tenu de saisir vos coordonnées chaque fois que vous visitez le site Web ou l’Application, car nous ne pourrions pas nous souvenir que vous vous y étiez déjà connecté. La plupart des navigateurs Web peuvent être paramétrés pour désactiver l’utilisation des Témoins de connexion. Toutefois, si vous les désactivez, vous pourriez ne pas être en mesure d’accéder à la fonctionnalité de notre site Web ou de notre Application correctement, ou pas du tout. Nous ne plaçons jamais de Renseignements personnels identifiables dans les Témoins de connexion.`,
        },
      },
      blocking: {
        title: 'Blocage et désactivation des témoins de connexion et des technologies similaires',
        desc: {
          line1:
            'Partout où vous vous trouvez, vous pouvez également configurer votre navigateur pour bloquer les témoins de connexion et les technologies semblables, mais cette action peut bloquer nos témoins de connexion essentiels et empêcher notre site Web ou notre Application de fonctionner adéquatement, et vous pourriez ne pas être en mesure d’utiliser toutes ses fonctions et tous ses services. Vous devez également savoir que vous pourriez également perdre certains renseignements sauvegardés (p. ex. les renseignements d’ouverture de session sauvegardés, les préférences de site) si vous bloquez des témoins de connexion sur votre navigateur. Différents navigateurs mettent à votre disposition différents contrôles. Désactiver un témoin de connexion ou une catégorie de témoins de connexion ne supprime pas le témoin de votre navigateur. Vous devrez le faire vous‑même à partir de votre navigateur. Consulter le menu d’aide de votre navigateur pour plus de renseignements.',
        },
      },
      remarketing: {
        title: 'Services de remarketing',
        desc: {
          line1:
            'Nous utilisons des services de remarketing. Qu’est‑ce que le remarketing? Dans le marketing numérique, le remarketing (ou le reciblage) consiste à présenter des annonces sur Internet à des personnes qui ont déjà visité votre site Web ou votre application. Cela permet à votre entreprise de « suivre », en apparence, des gens sur Internet en leur présentant des annonces publicitaires sur les sites Web et les plateformes qu’ils utilisent le plus.',
        },
      },
      payment: {
        title: 'Conditions de paiement',
        desc: {
          line1:
            'En ce qui concerne les renseignements sur les cartes de crédit ou les autres renseignements sur le traitement des paiements que vous nous avez fournis, nous nous engageons à stocker ces renseignements confidentiels de la manière la plus sûre possible.',
        },
      },
      kidsPrivacy: {
        title: 'Vie privée des enfants',
        desc: {
          line1:
            'Notre Application est accessible à tous. Cependant, tout utilisateur de moins de 13 ans doit obtenir le consentement de ses parents. Si vous êtes un parent ou un tuteur et que vous savez que votre enfant nous a transmis des Renseignements personnels sans votre consentement, veuillez communiquer avec nous. Si nous apprenons que nous avons recueilli des renseignements personnels auprès de personnes de moins de 13 ans sans le consentement parental, nous pouvons prendre des mesures pour supprimer ces renseignements.',
        },
      },
      changesPrivacyPolicy: {
        title: 'Modifications apportées à notre Politique de confidentialité',
        desc: {
          line1:
            'Il se peut que nous ayons à modifier nos Services et politiques et conséquemment, la présente Politique de confidentialité, afin qu’elle les reflète correctement. À moins d’exigences contraires de la loi, nous vous aviserons (par exemple, par l’entremise de notre Service) des modifications apportées à la présente Politique de confidentialité. Ensuite, si vous continuez d’utiliser les Services, vous serez lié par la Politique de confidentialité. Si vous ne souhaitez pas accepter la présente Politique de confidentialité ou toute autre mise à jour, vous pouvez supprimer votre compte.',
        },
      },
      thirdParty: {
        title: 'Services de tiers',
        desc: {
          line1: `Nous pouvons afficher, inclure ou rendre accessible du contenu de tiers (y compris des données, des renseignements, des applications et d’autres produits et services) ou fournir des liens vers des sites Web ou des services de tiers (« Services de tiers »).`,
          line2:
            'Vous reconnaissez et convenez que Protexxa n’est pas responsable des Services de tiers, notamment de leur exactitude, de leur exhaustivité, de leur actualité, de leur validité, de leur respect des droits d’auteur, de leur légalité, de leur décence, de leur qualité ou de tout autre aspect de ceux‑ci. Protexxa n’assume pas et n’a pas de responsabilité envers vous ou toute autre personne ou entité en ce qui concerne les Services de tiers.',
          line3:
            'Les Services de tiers et les liens vers ceux‑ci vous sont fournis uniquement pour vous faciliter la tâche; c’est entièrement à vos risques et sous réserve des conditions générales de ces tiers que vous y avez accès et les utilisez.',
        },
      },
      tracking: {
        title: 'Technologies de suivi',
        desc: {
          list1:
            'Témoins de connexion : nous utilisons des Témoins de connexion afin d’améliorer la performance et la fonctionnalité de notre plateforme, mais leur utilisation n’est pas essentielle. Sans eux, toutefois, certaines fonctionnalités comme les vidéos pourraient ne plus être disponibles, ou vous pourriez être tenu de saisir vos coordonnées chaque fois que vous visitez la plateforme, car nous ne pourrions pas nous souvenir que vous vous y étiez déjà connecté.',
          list2:
            'Sessions : nous utilisons le terme « Sessions » pour indiquer les zones que vous avez visitées sur notre plateforme. Une Session est une petite pièce de données stockée sur votre ordinateur ou votre appareil mobile par votre navigateur Web.',
        },
      },
      generalData: {
        title: 'Informations sur le Règlement général sur la protection des données (RGPD)',
        desc: {
          line1:
            'Nous pourrions recueillir et utiliser des renseignements auprès de vous si vous êtes de l’Espace économique européen (EEE), et dans cette section de notre Politique de confidentialité, nous allons expliquer exactement comment et pourquoi ces données sont recueillies et comment nous maintenons ces données sous protection contre leur reproduction ou leur utilisation à mauvais escient.',
        },
      },
      gdpr: {
        title: 'Qu’est‑ce que le RGPR?',
        desc: {
          line1:
            'Le RGPD est une loi sur la protection des renseignements personnels et des données qui s’applique à l’échelle de l’Union européenne (UE) et qui régit la façon dont les données des résidents de l’UE sont protégées par les entreprises et accroît le contrôle que les résidents de l’UE exercent sur leurs renseignements personnels.',
          line2:
            'Le RGPR est pertinent pour toute entreprise active mondialement, et non pas simplement pour les entreprises établies dans l’UE ou les résidents de celle‑ci. Les renseignements de nos clients sont importants, peu importe où ils se trouvent, et c’est pourquoi nous avons mis en œuvre des contrôles du RGPD comme norme de référence pour toutes nos activités à l’échelle mondiale.',
        },
      },
      personalData: {
        title: 'Qu’est‑ce qu’un renseignement personnel?',
        desc: {
          line1:
            'Tout renseignement qui concerne une personne identifiable ou identifiée. Le RGPD couvre un large éventail de renseignements qui pourraient être utilisés seuls ou en combinaison avec d’autres éléments d’information pour identifier une personne. Les renseignements personnels ne se limitent pas au nom ou à l’adresse courriel d’une personne. Il peut s’agir de renseignements financiers, d’opinions politiques, de données génétiques, de données biométriques, d’adresses IP, d’adresses physiques, de l’orientation sexuelle et de l’origine ethnique.',
          line2: 'Les Principes de protection des données comprennent des exigences telles que :',
          list1:
            'Les Renseignements personnels recueillis doivent être traités de façon équitable, légale et transparente et ne doivent être utilisés que de la façon à laquelle une personne s’attendrait raisonnablement.',
          list2:
            'Les Renseignements personnels ne devraient être recueillis que pour répondre à une fin précise et ne devraient être utilisés qu’à cette fin. Lorsqu’elles recueillent des renseignements personnels, les entreprises doivent préciser pourquoi elles ont besoin.',
          list3:
            'Les renseignements personnels ne doivent pas être conservés plus longtemps que nécessaire pour atteindre leur objectif.',
          list4:
            'Les personnes visées par le RGPD ont le droit d’accéder à leurs propres renseignements personnels. Elles peuvent également demander une copie de leurs données et demander que celles‑ci soient mises à jour, supprimées, restreintes ou transférées à une autre organisation.',
        },
      },
      gdprImportant: {
        title: 'Pourquoi le RGPD est‑il important?',
        desc: {
          line1:
            'Le RGPD ajoute de nouvelles exigences concernant la façon dont les entreprises devraient protéger les renseignements personnels des particuliers qu’elles recueillent et traitent. Il augmente également les enjeux de conformité en élargissant l’application de la loi et en imposant des amendes plus élevées en cas de manquement. Au‑delà de ces faits, c’est tout simplement la chose à faire. Chez Protexxa, nous croyons fermement que la confidentialité de vos données est très importante, et nous avons déjà de solides pratiques de sécurité et de protection de la vie privée en place qui vont au‑delà des exigences de ce nouveau règlement.',
        },
      },
      individualData: {
        title: 'Droits des personnes concernées – Accès, portabilité et suppression des données',
        desc: {
          line1:
            'Nous sommes déterminés à aider nos clients à répondre aux exigences du RGPD en matière de droits relatifs aux données. Protexxa traite ou stocke tous les renseignements personnels chez des fournisseurs qui respectent la loi régissant la protection des renseignements personnels. Nous conservons toutes les conversations et les renseignements personnels pendant une période maximale de six ans, à moins que votre compte ne soit supprimé. Dans ce cas, nous aliénons toutes les données conformément à nos Conditions de service et à notre Politique de confidentialité, mais nous ne les conservons pas plus de 60 jours.',
          line2:
            'Nous savons que si vous travaillez avec des clients de l’UE, vous devez être en mesure de leur fournir la capacité d’accéder, de mettre à jour, de récupérer et de supprimer des renseignements personnels. Nous avons ce qu’il faut! Dès le début, nous nous sommes établis en tant que libre‑service et nous vous avons toujours donné accès à vos données et à vos renseignements clients. Notre service à la clientèle est là pour répondre à vos questions concernant l’utilisation de l’interface de protocole d’application.',
        },
      },
      contactUs: {
        title: 'Nous contacter',
        desc: {
          line1: 'N’hésitez pas à nous contacter si vous avez des questions.',
          list1: 'Par courriel : learn@protexxa.com',
        },
      },
    },
    charts: {
      tooltip: {
        invalid: 'Valeurs invalides',
        have_one: '{{count}} sur {{maxValue}} utilisateurs a',
        have_other: '{{count}} sur {{maxValue}} utilisateurs ont',
        dontHave_one: "{{count}} sur {{maxValue}} utilisateurs n'a pas",
        dontHave_other: "{{count}} sur {{maxValue}} utilisateurs n'ont pas",
        notRecognized: 'Valeurs non reconnues.',
        default: 'Valeurs par défaut.',
        cybersecurity: 'Assurance de cybersécurité.',
        nameExposed: 'leur nom exposé en ligne.',
        passwordManager: 'un gestionnaire de mots de passe.',
        mfa: 'AMF activée sur tous leurs comptes.',
        responsePlan: 'Un plan de réponse aux incidents.',
        privateAccounts: 'tous leurs comptes sociaux réglés en privé.',
        imageExposed: 'leur image exposée en ligne.',
        domainCompromised: 'un domaine web compromis.',
        passwordCompromised: 'mots de passe compromis.',
        phoneExposed: 'leur numéro de téléphone exposé en ligne.',
        addressExposed: 'leur adresse exposée en ligne.',
      },
      analytics: {
        fullname: 'Nom',
        address: 'Adresse',
        phoneNumber: 'Téléphone',
        email: 'Mot de passe',
        webDomains: 'Domaines',
        monthly: 'Mensuel',
        image: 'Image',
        useMFA: 'AMF',
        haveResponsePlan: 'Plan de Réponse aux Incidents',
        top10Apps: 'Réseaux sociaux privés',
        allSocialMediasInPrivate: 'Réseaux sociaux privés',
        havePasswordManager: 'Gestionnaire de mot',
        haveCyberSecurityInsurance: 'Assurance cybersécurité',
        backtoDashboard: 'Retour au tableau de bord',
        analyticsOverview: 'Aperçu des analyses',
        companyName: "Nom de l'entreprise",
        filterBy: 'Filtrer par : ',
        lastYear: "L'année dernière",
        lastSixMonths: 'Les 6 derniers mois',
        lastTreeMonths: 'Les 3 derniers mois',
        last365Days: 'Les 365 derniers jours',
        last180days: 'Les 180 derniers jours',
        last90days: 'Les 90 derniers jours',
        cybersecurityScores: 'Le score Protexxa de',
        monthlyScoreOverTime: 'Score mensuel au fil du temps',
        indicatorsOfCompromise: 'Vulnérabilités',
        avarageNumberOfUserswithIncidentsOverTime:
          "Nombre moyen d'utilisateurs avec des incidents au fil du temps.",
        showing: 'Affichage : ',
        all: 'Tous les indicateurs',
        exploreButton: 'Suivi de la progression des scores',
        noDataTitle: 'Cette section nécessite plus de données',
        noDataDescription:
          'Votre tendance de score sera affichée après des analyses ultérieures sur votre compte.',
        scoreTrend: 'Tendance du score',
        cyberHealthScoreTrendOverTime: 'Tendance du score de santé cybernétique au fil du temps',
      },
    },
    dashboardReviewCards: {
      updateButton: {
        haveYouFixed: 'Avez-vous résolu ce problème ?',
        update: 'Mettre à jour',
      },
      confirmModal: {
        title: 'Confirmer que vous avez résolu ce problème',
        subTitle:
          'Lorsque vous mettez à jour vos informations, elles seront évaluées lors de votre prochaine évaluation mensuelle du score de cybersécurité.',
        useMFA:
          "Je confirme avoir activé l'authentification multi-facteurs (MFA) pour une sécurité accrue ou avoir mis en place des mesures pour protéger mes informations personnelles sur les plateformes qui ne prennent pas en charge la MFA.",
        havePasswordManager:
          'Je confirme avoir acquis un gestionnaire de mots de passe pour protéger tous mes comptes et mes informations personnelles.',
        top10Apps:
          "Vérifiez la liste des applications intrusives et décochez celles avec lesquelles vous n'avez plus de compte.",
        socialMedia:
          'Je confirme avoir soit défini mes profils sur les réseaux sociaux comme privés, soit pris des mesures pour protéger mes informations personnelles sur les plateformes qui ne disposent pas de paramètres de confidentialité totale.',
        button: {
          update: 'Mettre à jour',
          close: 'Fermer',
        },
      },
      toast: {
        success: 'Information mise à jour avec succès!',
      },
    },
    notifications: {
      notificationsModal: {
        title: 'Notifications',
        tabs: {
          unread: 'Non lu',
          all: 'Tout',
        },
      },
      emptyState: {
        all: {
          title: "Il n'y a pas de nouvelles pour toi.",
          description: "Revenez plus tard pour voir s'il y a des notifications.",
        },
        unread: {
          title: 'Vous avez lu toutes les notifications!',
          description: "Revenez plus tard pour voir s'il y a des nouvelles.",
        },
      },
      domainNotification: {
        title: 'Domaine Web compromis',
        description: ' de vos domaine(s) web aurait pu être compromis au cours du dernier mois.',
      },
      passwordNotification: {
        title: 'Fuite potentielle de mot de passe',
        description: [
          'Nouvelle fuite potentielle: ',
          ' de vos comptes e-mail confirmés a été divulgué ce mois-ci.',
        ],
      },
      adressNotification: {
        title: 'Adresse exposée',
        description: [
          'Nouvelle fuite: Nous avons découvert que votre adresse a été divulguée sur ',
          ' websites this month.',
        ],
      },
      mfaNotification: {
        title: 'Authentification multi-facteurs',
        description:
          "Nous avons remarqué que vous n'utilisez pas l'authentification multi-facteurs (MFA). Cliquez ici pour examiner cette zone critique.",
      },
      scoreNotification: {
        title: 'Nouveau score de {{score}}',
        titleDefault: 'Nouveau score disponible',
        description: [
          'Lors de notre dernière analyse, le ',
          ' votre score Protexxa a augmenté de ',
          ' votre score Protexxa a diminué de ',
          ' points.',
        ],
      },
      safeNotification: {
        title: 'Pas de nouvelles menaces!',
        description: [
          "Nous n'avons trouvé aucune ",
          'nouvelle',
          ' menace lors du dernier contrôle du ',
          ". N'oubliez pas de résoudre tous les problèmes non résolus!",
        ],
      },
      imageNotification: {
        title: 'Nouvelle image trouvée!',
        description:
          "Nous avons découvert de nouveaux cas d'utilisation de votre image personnelle en ligne.",
      },
      nameNotification: {
        title: 'Nom exposé',
        description: [
          'Nouvelle découverte de votre nom qui a fuité sur ',
          ' sites le mois dernier.',
        ],
      },
      phoneNotification: {
        title: 'Numéro de téléphone exposé',
        description: [
          'Nouvelle découverte : votre numéro de téléphone a fuité sur ',
          ' sites le mois dernier.',
        ],
      },
      otherNotification: {
        title: 'Autres menaces importantes',
        description: [
          'Vous faites face à ',
          ' nouveaux problèmes ',
          'qui pourraient vous exposer à une cyberattaque. Réparons-les maintenant.',
        ],
      },
      reportStatusNotification: {
        pending: {
          title: "Demande d'image signalée reçue",
          description:
            "Nous avons bien reçu votre demande de rapport d'image et nous la traiterons sous peu.",
        },
        accepted: {
          title: "L'image signalée est en cours de traitement.",
          description:
            "Nous avons assigné votre rapport à notre équipe. Nous vous tiendrons informé(e) de l'évolution de votre demande dès qu'il y aura un changement.",
        },
        requestDenied: {
          title: "La suppression de l'image signalée a échoué.",
          description:
            "L'image ne peut pas être supprimée. Consultez les détails pour connaître les raisons courantes.",
        },
        waitingFeedback: {
          title: "Action requise dans le processus d'image signalée",
          description:
            "Nous avons besoin de votre contribution pour poursuivre le processus de suppression de l'image. Veuillez cliquer ici pour suivre les instructions.",
        },
        userAction: {
          title: "Action requise dans le processus d'image signalée",
          description:
            "Nous avons besoin de votre contribution pour poursuivre le processus de suppression de l'image. Veuillez cliquer ici pour suivre les instructions.",
        },
        remove: {
          title: 'Image signalée résolue.',
          description: 'Cette image a été supprimée avec succès.',
        },
        solved: {
          title: 'Image signalée résolue.',
          description: 'Cette image a été supprimée avec succès.',
        },
        failed: {
          title: "La suppression de l'image signalée a échoué.",
          description:
            "L'image ne peut pas être supprimée. Consultez les détails pour connaître les raisons courantes.",
        },
      },
      responsePlanNotification: {
        title: "Plan de rapport d'incident",
        description:
          'Créez votre propre plan de réponse personnalisé pour améliorer votre cybersécurité.',
      },
      unresolvedNotification: {
        title: 'Les questions non résolues',
        description:
          'Votre dernière analyse contient encore des menaces non résolues. Rendons vos données plus sécurisées !',
      },
      companyScoreNotification: {
        title: "Nouveau Score de l'entreprise: ",
        description: [
          'Après votre dernier scan, le ',
          ' votre score Protexxa ',
          ' a augmenté de ',
          ' a diminué de ',
          ' points. Consultez les détails.',
        ],
      },
      companyUpdatesNotification: {
        title: "Indicateurs d'analyse mis à jour !",
        description:
          'Consultez le dernier rapport et les dernières tendances, en comparant cette analyse aux analyses précédentes.',
      },
      settings: {
        title: 'Notifications',
        subtitle: {
          category: 'Catégorie',
          push: 'Push',
          email: 'E-mail',
        },
        settingsData: {
          critical: {
            title: 'Menaces Critiques',
            subtitle:
              'Recevez une notification lorsque nous détectons que votre adresse, votre mot de passe ou votre domaine ont été compromis.',
          },
          important: {
            title: 'Menaces Importantes',
            subtitle:
              'Recevez une notification lorsque nous découvrons de nouvelles utilisations de vos informations personnelles en ligne.',
          },
          image: {
            title: 'Expositions signalées',
            subtitle:
              'Soyez informé lorsque nous mettons à jour un rapport concernant une image personnelle, un nom, un numéro de téléphone ou une adresse utilisés en ligne.',
          },
          reminders: {
            title: 'Rappels',
            subtitle:
              "Recevez une notification pour des rappels tels que les processus d'hygiène cybernétique et les problèmes non résolus.",
          },
          company: {
            title: "Notifications d'Entreprise",
            subtitle:
              "Recevez une notification lorsque nous analysons l'entreprise : nouveaux scores et mises à jour analytiques.",
          },
        },
        button: {
          save: 'Enregistrer les modifications',
        },
        toast: {
          success: 'Information mise à jour avec succès!',
          error: 'Une erreur est survenue',
        },
      },
    },
    externalLink: {
      title: 'Vous quittez Protexxa',
      description:
        "Nous faisons tout notre possible pour vérifier la sécurité des liens externes, mais veuillez vérifier l'URL avant de continuer.",
      button: 'Continuer',
      back: 'Retour à Protexxa',
    },
    authVerification: {
      title: 'Vérifiez vos informations',
      subtitle: 'Vérifiez vos informations pour continuer',
      codeText: 'Entrez le code dans les espaces ci-dessous',
      phoneNumberDescription: 'Nous avons envoyé le code de sécurité au numéro de téléphone',
      editPhoneNumber: 'Modifier le numéro de téléphone',
      emailDescription: 'Nous avons envoyé le code de sécurité à',
      retryText: "Vous n'avez pas reçu le code?",
      resendCode: 'Renvoyer le code',
      sendToEmail: 'Envoyer le code par e-mail à la place',
      sendToPhone: 'Envoyer le code au numéro de téléphone à la place',
      wrongCode: 'Code erroné',
      smsDelayWarning:
        'Nous rencontrons actuellement des délais dans la livraison des messages texte pour les codes de vérification à deux facteurs affectant certains utilisateurs au Canada. Si cela vous concerne, veuillez utiliser la vérification par courriel pour continuer. Nous nous excusons pour le désagrément. Merci de votre patience pendant que nous travaillons à résoudre ce problème!',
    },
    dashboardV2: {
      common: {
        error: 'Une erreur est survenue.',
        noData: 'Aucune donnée disponible.',
        loading: 'Chargement…',
        viewAll: 'Voir tout',
      },
      severity: {
        critical: 'CRITIQUE',
        high: 'ÉLEVÉ',
        medium: 'MOYEN',
        low: 'FAIBLE',
      },
      riskLevel: {
        critical: 'Critique',
        high: 'Élevé',
        medium: 'Moyen',
        low: 'Faible',
      },
      speedometer: {
        criticalRisk: 'Risque critique',
        highRisk: 'Risque élevé',
        mediumRisk: 'Risque moyen',
        lowRisk: 'Risque faible',
        sinceLastScan: 'depuis la dernière analyse',
      },
      welcomeHeader: {
        greeting: 'Bon retour,',
        subtitle: 'Voici un aperçu de votre santé cybernétique actuelle.',
        downloadReport: 'Télécharger le rapport',
      },
      securityRiskSummary: {
        title: 'Résumé des risques de sécurité',
        lastScan: 'Dernière analyse :',
        nextScan: 'Prochaine analyse :',
        noScoreData: 'Aucune donnée de score disponible.',
      },
      scoreTrend: {
        title: 'Tendance du score',
        noTrendData: 'Aucune donnée de tendance disponible.',
      },
      criticalIssues: {
        title: 'Problèmes critiques à traiter immédiatement',
        viewAll: "Voir tous les résultats d'analyse",
        noIssues: 'Aucun problème critique trouvé.',
      },
      recommendations: {
        title: 'Recommandations',
        subtitle:
          'Effectuez ces actions pour sécuriser vos données personnelles et améliorer votre score de risque !',
        noRecommendations: 'Aucune recommandation disponible.',
        viewFindings: 'Voir les résultats associés',
        viewAllFindings_one: 'Voir le {{count}} résultat',
        viewAllFindings_other: 'Voir tous les {{count}} résultats',
        priority: {
          immediate: 'Immédiat',
          important: 'Important',
          awareness: 'Sensibilisation',
        },
      },
      riskFindings: {
        title: 'Résultats des risques',
        subtitle: 'Les types de problèmes que nous avons détectés lors de votre analyse',
        issueCount_one: '{{count}} problème',
        issueCount_other: '{{count}} problèmes',
        noFindings: 'Aucun résultat de risque trouvé.',
      },
      possibleAttacks: {
        title: 'Attaques possibles',
        subtitle: 'Les recommandations non traitées peuvent vous exposer à ces attaques !',
        noAttacks: 'Aucune attaque possible identifiée.',
        issues: 'problèmes',
        relatedFindings: '{{count}} résultats associés',
        cta: {
          intro: 'Découvrez ce que signifient ces cyberattaques et comment vous en protéger.',
          label: 'Cyberattaques les plus courantes',
        },
      },
      training: {
        title: 'Formation',
        startTraining: 'Commencer la formation',
        recentLearning: 'Apprentissage récent',
        skillsAcquired: 'Compétences acquises',
        noTrainingData: 'Aucune donnée de formation disponible.',
      },
      jobMatching: {
        title: "Correspondance d'emploi",
        viewJobs: 'Voir les emplois',
        recentActivity: "Activité récente d'emploi",
        noActivity: "Aucune activité récente d'emploi.",
      },
      breachNarrative: {
        reviewAction: 'Examiner et agir',
      },
      findings: {
        title: 'Résultats',
        lastScan: 'Dernière analyse :',
        nextScan: 'Prochaine analyse :',
        sectionTitle:
          'Vos données personnelles sont exposées ou à risque à ces endroits. Examinez-les et corrigez-les dès maintenant',
        sectionSubtitle:
          'Concentrez-vous d’abord sur les problèmes critiques et à risque élevé pour sécuriser votre compte plus rapidement.',
        emptyState: 'Aucun résultat disponible.',
        viewMore: 'Voir plus',
        dataExposedLabel: 'Données exposées :',
        breachedLabel: 'Compromis :',
        seeDetails: 'Voir les détails',
        summary: {
          criticalIssues_one: '{{count}} problème critique',
          criticalIssues_other: '{{count}} problèmes critiques',
          criticalSubtitle: 'Corrigez-les immédiatement',
          fixCritical: 'Corriger les problèmes critiques',
          importantIssues_one: '{{count}} problème important',
          importantIssues_other: '{{count}} problèmes importants',
          importantSubtitle: 'À examiner bientôt',
          resolvedIssues_one: '{{count}} problème résolu',
          resolvedIssues_other: '{{count}} problèmes résolus',
          resolvedSubtitle: 'Problèmes traités présentant moins de risque',
        },
        controls: {
          searchPlaceholder: 'Rechercher par site web, type de données ou mot-clé',
          sortBy: 'Trier par :',
          sortDefault: 'Plus récents',
          filters: 'Filtres',
          bulkAction: 'Action groupée',
          listView: 'Vue liste détaillée',
          gridView: 'Vue grille',
        },
        filters: {
          byRecommendation: 'Recommandation : {{name}}',
          byAttack: 'Attaque : {{name}}',
          bySeverity: 'Sévérité : {{name}}',
          byFinding: 'Résultat spécifique',
        },
        riskPill: {
          critical: 'Risque critique',
          high: 'Risque élevé',
          medium: 'Risque moyen',
          low: 'Risque faible',
        },
        dataType: {
          password: 'Mot de passe',
          name: 'Nom',
          email: 'Courriel',
          username: 'Nom d’utilisateur',
          image: 'Image',
          phone: 'Téléphone',
          address: 'Adresse',
          domain: 'Domaine',
        },
        cta: {
          placeholder: 'Agir',
        },
        groupCard: {
          issuesFound_one: '{{count}} problème trouvé',
          issuesFound_other: '{{count}} problèmes trouvés',
          fixAll_one: 'Corriger {{count}} problème',
          fixAll_other: 'Corriger les {{count}} problèmes',
          expand: 'Développer pour voir',
          collapse: 'Réduire',
        },
        leakRow: {
          unknownSource: 'Source inconnue',
          defaultDescription:
            'Cela peut vous exposer à des arnaques par courriel et à l’usurpation d’identité.',
        },
        modal: {
          dateFound: 'Date de découverte :',
          leakDetails: 'Détails de la fuite',
          source: 'Source',
          breachDate: 'Date de la compromission',
          dataTypesLeaked: 'Types de données divulgués',
          personalDataFound: 'Données personnelles trouvées',
          noPersonalData: 'Aucune donnée personnelle exposée dans cet enregistrement.',
          recommendations: 'Recommandations',
          noRecommendations: 'Aucune recommandation pour cette fuite.',
          markResolved: 'Marquer comme résolu',
          resolved: 'Résolu',
          resolveSuccess: 'Marqué comme résolu.',
          resolveError: 'Échec du marquage comme résolu.',
          title: {
            password: 'Fuite de mot de passe',
            email: 'Fuite de courriel',
            phone: 'Fuite de téléphone',
            name: 'Fuite de nom',
            address: 'Fuite d’adresse',
            image: 'Fuite d’image',
            domain: 'Fuite de domaine',
          },
          field: {
            username: 'Nom d’utilisateur',
            password: 'Mot de passe',
            name: 'Nom',
            breachType: 'Type de compromission',
          },
        },
      },
    },
    '0001': 'Enregistrement introuvable',
    '0002': 'Adresse e-mail utilisateur introuvable',
    '0003': `Adresse e-mail de l'entreprise déjà configurée !`,
    '0004': 'Entreprise introuvable',
    '0005': 'Entreprises introuvables',
    '0006': 'Utilisateur introuvable',
    '0007': `L'utilisateur n'a pas accès à une entreprise`,
    '0008':
      'Votre entreprise a dépassé le nombre de sièges autorisés par la licence. Veuillez contacter votre administrateur pour augmenter le nombre de sièges avec Protexxa.',
    '0009': 'Domaine e-mail invalide',
    '0010': 'Fuite introuvable',
    '0011':
      'Le nom de domaine appartient à une entreprise. Vérifiez si vous avez reçu une invitation de cette entreprise.',
    '0012': `L'enregistrement précédent n'a pas de crédits`,
    '0013': `L'enregistrement n'a pas de crédits`,
    '0014': `Administrateurs d'utilisateurs introuvables`,
    '0015': 'Veuillez vous authentifier',
    '0016': 'Interdit',
    '0017': 'Jeton incorrect',
    '0018': 'Invitation introuvable',
    '0019': 'Adresse e-mail déjà utilisée',
    '0020': 'Enregistrement déjà avec 0 crédits',
    '0021': 'Enregistrement précédent introuvable',
    '0022': `Erreur d'authentification.`,
    '0022e': 'Veuillez réessayer.',
    '0023': 'Code introuvable',
    '0024': 'Code non valide',
    '0025': 'Le code est expiré',
    '0026': 'Rapport non trouvé',
    '0027': 'Conflit de rapport',
    '0028': 'Votre accès au compte a été temporairement désactivé.',
    '0029': "Veuillez contacter votre administrateur système pour obtenir de l'aide.",
    '0030': 'Échec de la mise à jour du numéro de téléphone.',
    '0031': 'Étape de connexion inattendue : ',
    '0032': 'Échec de la réexpédition du code.',
    '0033': 'Échec de la mise à jour des options MFA.',
    '0034': 'Une erreur est survenue lors de la connexion.',
    '0035':
      'Le domaine {{domain}} est utilisé par une entreprise, veuillez vous inscrire via le lien d’invitation',
    '0036': 'Échec de l’envoi du code de vérification',
    '0037': 'Une erreur est survenue lors de l’inscription.',
    '0038': 'Une erreur est survenue lors de la confirmation.',
    '0039': 'Aucune méthode MFA sélectionnée.',
    '0040': 'Erreur de validation. Veuillez vérifier vos données.',
    '0000': 'Une erreur est survenue.',
  },
}
